{
  "moduleHome": {
    "screensIn": "الشاشات في {{module}}",
    "related": "شاشات ذات صلة",
    "quickActions": "إجراءات سريعة",
    "needsAttention": "يحتاج إلى متابعة",
    "moreActions": "المزيد"
  },
  "catalogPicker": {
    "placeholder": "اختر صنفًا",
    "search": "ابحث بالاسم أو رمز الصنف أو رقم القطعة أو الباركود…",
    "empty": "لا توجد أصناف مطابقة لهذا البحث",
    "searching": "جارٍ البحث…",
    "loadMore": "تحميل المزيد",
    "loadingMore": "جارٍ التحميل…",
    "loadError": "تعذّر تحميل قائمة الأصناف.",
    "partNumber": "رقم القطعة {{value}}",
    "clear": "مسح الصنف",
    "stock": {
      "inStock": "متوفر في هذا المستودع",
      "outOfStock": "نفد من هذا المستودع",
      "notHere": "غير موجود في هذا المستودع",
      "available": "المتاح {{quantity}}",
      "chooseWarehouse": "اختر مستودعًا أولًا"
    }
  },
  "app": {
    "admin": "Multaqa ERP Admin",
    "company": "Multaqa ERP"
  },
  "sealedByCompany": "مختوم بختم {{name}}",
  "approval": {
    "pendingTitle": "بانتظار الموافقة",
    "pendingDescription": "هذا المستند مُقدَّم ولا يمكن ترحيله حتى تتم الموافقة عليه.",
    "rejectedTitle": "تم رفض الموافقة",
    "stepOf": "الخطوة {{step}} من {{count}}",
    "approve": "موافقة",
    "reject": "رفض",
    "comment": "تعليق",
    "submit": "حفظ القرار",
    "cancel": "إلغاء",
    "priorDecisionsTitle": "القرارات حتى الآن",
    "approvedBy": "{{name}} وافق",
    "rejectedBy": "{{name}} رفض",
    "unknownDecider": "شخص ما",
    "decisionsTitle": "قرارات الموافقة",
    "decisionsErrorTitle": "تعذر تحميل قرارات الموافقة",
    "decisionsErrorDescription": "أعد المحاولة لمعرفة من اتخذ القرار بشأن هذا المستند."
  },
  "audit": {
    "title": "تدقيق المنصة",
    "subtitle": "السجل التراكمي غير القابل للتعديل لأحداث إدارة المنصة.",
    "columns": {
      "occurredAt": "وقت الحدوث",
      "action": "الإجراء",
      "entity": "الكيان",
      "actor": "الفاعل",
      "company": "الشركة",
      "group": "المجموعة",
      "oldValues": "القيم القديمة",
      "newValues": "القيم الجديدة"
    },
    "actorType": {
      "user": "مستخدم",
      "platform_admin": "مشرف منصة",
      "system": "النظام"
    },
    "noValue": "—",
    "emptyTitle": "لا توجد أحداث تدقيق بعد",
    "emptyBody": "ستظهر أحداث الإدارة هنا بمجرد تسجيلها.",
    "supportRequired": {
      "title": "يلزم فتح جلسة دعم",
      "body": "سجل تدقيق المجموعة من بيانات العميل. افتح جلسة دعم في المجموعة لقراءته."
    },
    "groupPicker": "المجموعة"
  },
  "action": {
    "save": "حفظ",
    "more": "المزيد",
    "view": "عرض",
    "cancel": "إلغاء",
    "unlink": "إلغاء الربط",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إنشاء",
    "search": "بحث",
    "signIn": "تسجيل الدخول",
    "signOut": "تسجيل الخروج",
    "back": "رجوع",
    "retry": "إعادة المحاولة",
    "goBack": "العودة",
    "reload": "أعد تحميل الصفحة",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "actions": "إجراءات",
    "previousPage": "الصفحة السابقة",
    "nextPage": "الصفحة التالية",
    "yes": "نعم",
    "no": "لا",
    "total": "الإجمالي",
    "clearFilters": "مسح عوامل التصفية",
    "filter": "تصفية",
    "filterActive": "تصفية، {{count}} نشط",
    "moreFilters": "مزيد من عوامل التصفية",
    "fewerFilters": "عوامل تصفية أقل",
    "moreFiltersActive": "مزيد من عوامل التصفية ({{count}} نشطة)",
    "fewerFiltersActive": "عوامل تصفية أقل ({{count}} نشطة)",
    "close": "إغلاق",
    "remove": "إزالة",
    "clearAll": "مسح الكل",
    "download": "تنزيل",
    "downloadPdf": "تنزيل PDF",
    "downloadPdfFailed": "تعذر تنزيل المستند."
  },
  "pagination": {
    "pageOf": "صفحة {{current}} من {{total}}",
    "range": "{{from}}–{{to}} من {{total}}",
    "rowsPerPage": "عدد الصفوف في الصفحة"
  },
  "date": {
    "openCalendar": "فتح التقويم",
    "clear": "مسح التاريخ"
  },
  "accountPicker": {
    "balanceSheet": "ميزانية",
    "balanceSheetFullName": "الميزانية العمومية",
    "profitAndLoss": "أ.خ",
    "profitAndLossFullName": "الأرباح والخسائر"
  },
  "shortcuts": {
    "title": "اختصارات لوحة المفاتيح",
    "search": "ابحث وانتقل إلى أي مكان",
    "switchCompany": "بدّل الشركة",
    "newLine": "أضف سطرًا إلى المستند",
    "moveLines": "تنقّل بين أسطر المستند",
    "sheet": "اعرض هذه القائمة",
    "close": "أغلق النافذة أو اللوحة"
  },
  "nav": {
    "dashboard": "لوحة التحكم",
    "customers": "العملاء",
    "suppliers": "الموردون",
    "products": "المنتجات",
    "productCategories": "فئات المنتجات",
    "collections": "المجموعات",
    "productAttributes": "خصائص المنتجات",
    "unitsOfMeasure": "وحدات القياس",
    "tags": "الوسوم",
    "settings": "الإعدادات",
    "toggleSidebar": "إظهار أو إخفاء القائمة الجانبية",
    "toggleTheme": "تبديل المظهر",
    "changeLanguage": "تغيير اللغة",
    "notifications": "الإشعارات",
    "alerts": "التنبيهات",
    "payslips": "قسائم الراتب"
  },
  "scan": {
    "title": "مسح رمز",
    "lookupHint": "امسح أو اكتب باركود منتج أو رمز تخزين أو دفعة أو حاوية أو رمز مستودع.",
    "inputLabel": "الرمز",
    "submit": "بحث",
    "failed": "تعذّر البحث عن الرمز. حاول مرة أخرى.",
    "notFound": "لا شيء يطابق «{{code}}»",
    "notFoundHint": "تحقق من الملصق. قد يكون أيضًا لمستودع لا يمكنك الوصول إليه.",
    "recognises": "الرموز التي يمكنك مسحها",
    "expires": "تنتهي صلاحيتها {{date}}",
    "kind": {
      "product": "منتج",
      "lot": "دفعة",
      "bin": "حاوية",
      "warehouse": "مستودع",
      "serial": "رقم تسلسلي"
    },
    "open": {
      "product": "فتح المنتج",
      "lot": "فتح الدفعة",
      "bin": "عرض المخزون في هذه الحاوية",
      "warehouse": "عرض المخزون في هذا المستودع",
      "serial": "فتح الرقم التسلسلي"
    },
    "button": "مسح",
    "paletteGroup": "إجراءات",
    "serialStatus": {
      "in_stock": "في المخزون",
      "in_transit": "في الطريق",
      "damaged": "تالف",
      "sold": "مباع",
      "written_off": "مشطوب",
      "lost": "مفقود",
      "returned_to_supplier": "مرتجع إلى المورد"
    },
    "matchKind": {
      "variant_barcode": "باركود المنتج",
      "variant_sku": "رمز المنتج",
      "serial_number": "رقم تسلسلي",
      "lot_barcode": "باركود التشغيلة",
      "lot_number": "رقم التشغيلة",
      "location_barcode": "باركود الرف",
      "location_code": "رمز الرف",
      "warehouse_code": "رمز المستودع"
    },
    "choice": {
      "title": "وُجدت عدة نتائج. اختر المقصود منها:"
    }
  },
  "shell": {
    "platform": "المنصة",
    "userMenu": "قائمة الحساب",
    "search": "بحث",
    "searchScoped": "البحث في {{scope}}",
    "searchPlatform": "البحث عن المجموعات والشركات والمشغلين",
    "searchEmpty": "لا توجد وجهات تطابق \"{{query}}\".",
    "language": "اللغة",
    "theme": "المظهر",
    "signedInAs": "تم الدخول باسم",
    "twoFactor": "المصادقة الثنائية",
    "accountSettings": "إعدادات الحساب",
    "signOut": "تسجيل الخروج",
    "signingOut": "جارٍ تسجيل الخروج…",
    "searchHint": "ابحث في الشاشات والإجراءات والسجلات",
    "otherLanguage": "English",
    "palette": {
      "screens": "الشاشات",
      "actions": "الإجراءات",
      "create": "إنشاء",
      "seeAll": "عرض كل النتائج",
      "records": {
        "customers": "العملاء",
        "suppliers": "الموردون",
        "products": "المنتجات",
        "invoices": "الفواتير",
        "bills": "فواتير الموردين",
        "employees": "الموظفون"
      }
    }
  },
  "rail": {
    "customise": {
      "title": "تخصيص",
      "tabs": {
        "quick": "الوصول السريع",
        "sections": "الأقسام"
      }
    },
    "close": "إغلاق",
    "labels": "تسميات التنقل الجانبي",
    "labelsHint": "يؤدي إيقاف التسميات إلى إتاحة مساحة لرؤية أقسام أكثر.",
    "resize": "تغيير عرض التنقل الجانبي",
    "collapse": "طي التنقل",
    "expand": "توسيع التنقل",
    "apps": "تطبيقات التنقل الجانبي",
    "pin": "تثبيت {{label}}",
    "show": "إظهار {{label}}",
    "hide": "إخفاء {{label}}",
    "pinned": "{{count}} مثبت",
    "saveAndClose": "حفظ وإغلاق",
    "lifted": "تم رفع {{label}}. استخدم الأسهم للتحريك، والمسافة للإفلات، وEscape للإلغاء.",
    "dropped": "تم إفلات {{label}}.",
    "cancelled": "تم إلغاء {{label}}.",
    "unpin": "إلغاء تثبيت {{label}}",
    "quickAccess": {
      "title": "الوصول السريع",
      "add": "إضافة اختصار",
      "edit": "تعديل الوصول السريع",
      "empty": "ستظهر الشاشات التي تختارها هنا.",
      "count": "{{count}} من {{max}}",
      "moveUp": "نقل {{label}} لأعلى",
      "moveDown": "نقل {{label}} لأسفل",
      "remove": "إزالة {{label}}",
      "collapse": "طي الوصول السريع",
      "expand": "توسيع الوصول السريع",
      "recent": "فُتحت مؤخرًا"
    },
    "pinnedLabel": "مثبتة",
    "more": "المزيد",
    "createDocuments": {
      "invoice": "فاتورة",
      "receivePayment": "استلام دفعة",
      "statement": "كشف حساب",
      "creditNote": "إشعار دائن",
      "salesReceipt": "إيصال مبيعات",
      "refundReceipt": "إيصال استرداد",
      "expense": "مصروف",
      "cheque": "شيك",
      "bill": "فاتورة مورد",
      "payBills": "دفع الفواتير",
      "supplierCredit": "رصيد مورد",
      "cardCredit": "رصيد بطاقة",
      "journalEntry": "قيد يومية",
      "bankDeposit": "إيداع بنكي",
      "transfer": "تحويل"
    },
    "admin": {
      "groups": "المجموعات",
      "onboarding": "تسجيل عميل جديد",
      "plans": "الباقات",
      "settings": "الإعدادات",
      "holidays": "تقويم العطلات",
      "announcements": "الإعلانات",
      "support": "جلسات الدعم",
      "audit": "السجل",
      "feedback": "الملاحظات",
      "overview": "نظرة عامة",
      "sections": {
        "customers": "العملاء",
        "operations": "العمليات"
      },
      "noCompanyContext": "لا يوجد سياق شركة"
    },
    "company": {
      "groupConsole": "لوحة المجموعة",
      "modules": "الوحدات",
      "admin": "الإدارة",
      "roles": "الأدوار",
      "members": "الأعضاء",
      "dashboard": "لوحة المعلومات",
      "workflows": "مسارات الموافقة",
      "approvals": "الموافقات",
      "expandSection": "توسيع {{section}}",
      "collapseSection": "طي {{section}}",
      "hr": {
        "home": "نظرة عامة",
        "reports": "التقارير",
        "analytics": "التحليلات",
        "settings": "إعدادات الموارد البشرية",
        "employees": "الموظفون",
        "org": "الهيكل التنظيمي",
        "violations": "المخالفات",
        "attendance": "الحضور",
        "workingTime": "وقت العمل",
        "attendanceBoard": "الحضور اليومي",
        "attendanceCorrections": "طلبات الحضور",
        "leave": "الإجازات",
        "expenses": "المصروفات",
        "cashCustody": "العهد النقدية",
        "performance": "الأداء",
        "assets": "العهد",
        "recruitment": "التوظيف",
        "payrollRuns": "مسيّرات الرواتب",
        "payrollComponents": "مكوّنات الراتب",
        "bulkPayrollAssignment": "إسناد مكوّن جماعي",
        "payrollSettings": "قواعد الرواتب",
        "payslips": "قسائم الراتب",
        "salaryAdvances": "السلف على الراتب",
        "fieldSettings": "الحقول المخصصة"
      },
      "accounting": {
        "home": "نظرة عامة",
        "chart": "دليل الحسابات",
        "settings": "الإعدادات",
        "periods": "الفترات المالية",
        "tax": "الضرائب",
        "taxCentre": "مركز الضرائب",
        "journal": "قيود اليومية",
        "journals": "اليوميات",
        "trialBalance": "ميزان المراجعة",
        "workingCapital": "رأس المال العامل",
        "analysisTags": "وسوم التحليل",
        "costCenters": "مراكز التكلفة",
        "reports": "التقارير",
        "invoices": "الفواتير",
        "salesReceipts": "إيصالات البيع",
        "customerStatements": "كشوف حسابات العملاء",
        "bills": "فواتير الموردين",
        "spend": "المصروفات",
        "expenses": "المصروفات",
        "payments": "المدفوعات",
        "bankAccounts": "الحسابات البنكية",
        "deposits": "الإيداعات البنكية",
        "assets": "الأصول الثابتة",
        "depreciation": "تشغيل الإهلاك",
        "reconciliation": "التسوية البنكية",
        "budgets": "الميزانيات",
        "openingBalances": "الأرصدة الافتتاحية",
        "paymentTerms": "شروط الدفع",
        "closeBooks": "إغلاق الدفاتر",
        "recurringTemplates": "قوالب متكررة",
        "cashPosition": "المركز النقدي",
        "cheques": "الشيكات",
        "supplierStatement": "كشف حساب",
        "payrollPayments": "مدفوعات الرواتب"
      },
      "companies": "الكيانات",
      "departments": "الإدارات",
      "branches": "الفروع",
      "positions": "المسمّيات الوظيفية",
      "sequences": "الترقيم",
      "settings": "إعدادات الشركة",
      "notificationSettings": "إعدادات الإشعارات",
      "alertRules": "قواعد التنبيه",
      "audit": "سجل التدقيق",
      "sections": {
        "configure": "إعداد",
        "organisation": "المؤسسة",
        "directory": "الدليل",
        "hr": "الموارد البشرية",
        "inventory": "المخزون",
        "purchasing": "المشتريات",
        "sales": "المبيعات",
        "accounting": "المحاسبة"
      },
      "groups": {
        "people": "الأفراد",
        "time": "الوقت",
        "pay": "الأجور",
        "talent": "المواهب",
        "reports": "التقارير",
        "setup": "الإعداد",
        "stock": "الرصيد المتاح",
        "batches": "الدفعات والصلاحية",
        "sales": "المبيعات",
        "purchases": "المشتريات",
        "expenses": "المصروفات",
        "receivables": "الذمم المدينة",
        "payables": "الذمم الدائنة",
        "banking": "البنوك",
        "ledger": "الأستاذ",
        "periodClose": "إغلاق الفترة",
        "assets": "الأصول",
        "operations": "العمليات"
      },
      "inventory": {
        "overview": "نظرة عامة",
        "stock": "الرصيد المتاح",
        "movements": "حركات المخزون",
        "adjustments": "التسويات",
        "disposals": "عمليات الشطب",
        "lots": "الدفعات والصلاحية",
        "reports": "تحليل المخزون",
        "warehouses": "المستودعات",
        "locations": "المواقع",
        "access": "صلاحيات المستودعات",
        "transfers": "التحويلات",
        "counts": "الجرد",
        "serials": "الأرقام التسلسلية",
        "newTransfer": "تحويل جديد"
      },
      "purchasing": {
        "orders": "أوامر الشراء",
        "receipts": "إيصالات استلام البضائع",
        "debitNotes": "الإشعارات المدينة",
        "paymentsMade": "المدفوعات الصادرة",
        "apAging": "تقادم الذمم الدائنة",
        "returns": "المرتجعات",
        "threeWayMatch": "المطابقة الثلاثية",
        "goodsReceivedNotInvoiced": "بضاعة مستلمة غير مفوترة",
        "landedCosts": "التكاليف الإضافية",
        "landedCostsPending": "التكاليف الإضافية المعلّقة",
        "landedCostCategories": "فئات التكاليف الإضافية",
        "overview": "نظرة عامة",
        "newOrder": "أمر شراء جديد",
        "newLandedCost": "تكلفة إضافية جديدة"
      },
      "sales": {
        "overview": "نظرة عامة",
        "orders": "عروض الأسعار وأوامر البيع",
        "creditNotes": "الإشعارات الدائنة",
        "paymentsReceived": "المدفوعات المستلمة",
        "reservations": "الحجوزات",
        "returns": "المرتجعات",
        "trend": "اتجاه المبيعات",
        "arAging": "تقادم الذمم المدينة",
        "newOrder": "أمر بيع جديد"
      }
    },
    "spine": {
      "label": "التنقل الرئيسي"
    }
  },
  "companySwitcher": {
    "trigger": "تبديل الشركة",
    "group": "المجموعة",
    "subsidiaries": "الشركات التابعة",
    "search": "البحث عن الكيانات",
    "noResults": "لا توجد كيانات مطابقة",
    "active": "نشطة",
    "select": "تحديد {{code}}",
    "manage": "إدارة الكيانات",
    "emptyGroup": "لا توجد كيانات بعد",
    "shortcutHint": "للتبديل",
    "meta": "{{currency}} · {{role}}",
    "subsidiariesCount_zero": "لا توجد كيانات",
    "subsidiariesCount_one": "كيان واحد",
    "subsidiariesCount_two": "كيانان",
    "subsidiariesCount_few": "{{count}} كيانات",
    "subsidiariesCount_many": "{{count}} كيانًا",
    "subsidiariesCount_other": "{{count}} كيان"
  },
  "customer": {
    "detailsDescription": "الهوية والضرائب وشروط الدفع.",
    "contactsDescription": "الأشخاص المسؤولون لدى هذا العميل.",
    "tagsDescription": "وسوم للتجميع والتصفية.",
    "title": "العملاء",
    "countLabel_zero": "لا عملاء",
    "countLabel_one": "عميل واحد",
    "countLabel_two": "عميلان",
    "countLabel_few": "{{count}} عملاء",
    "countLabel_many": "{{count}} عميلًا",
    "countLabel_other": "{{count}} عميل",
    "subtitle": "إدارة دليل العملاء وجهات الاتصال والوسوم.",
    "create": "عميل جديد",
    "edit": "تعديل عميل",
    "details": "تفاصيل العميل",
    "detailSubtitle": "سجل العميل {{code}}",
    "columnsMenu": {
      "label": "الأعمدة",
      "description": "إظهار الأعمدة أو إخفاؤها"
    },
    "deactivate": "إلغاء تنشيط العميل",
    "deactivateConfirmation": "هل أنت متأكد من إلغاء تنشيط العميل {{code}}؟ لن يتمكن العملاء غير النشطين من إنشاء طلبات جديدة.",
    "activate": "إعادة تنشيط العميل",
    "code": "كود العميل",
    "name": "اسم العميل",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "type": "نوع العميل",
    "typeCompany": "شركة",
    "typeIndividual": "فرد",
    "address": "العنوان",
    "addressSection": "العنوان المنظم",
    "addressEn": "العنوان (بالإنجليزية)",
    "addressAr": "العنوان (بالعربية)",
    "identitySection": "الهوية",
    "contactSection": "جهة الاتصال الرئيسية",
    "contactOptional": "اختياري — ستتم إضافة جهة الاتصال بعد حفظ العميل.",
    "billingSection": "الفوترة والضرائب",
    "internalSection": "الإعدادات الداخلية",
    "receiver_type": "نوع المستلم",
    "governorate": "المحافظة",
    "city": "المدينة",
    "street": "الشارع",
    "building_number": "رقم المبنى",
    "mobile": "الهاتف المحمول",
    "till_note": "ملاحظة الصندوق",
    "isWalkIn": "عميل حضوري",
    "country": "الدولة",
    "taxIdentifier": "الرقم الضريبي",
    "paymentTerms": "شروط الدفع",
    "paymentTermsNone": "بدون شروط دفع",
    "defaultCurrency": "العملة الافتراضية",
    "optional": "اختياري",
    "invalidForm": "أكمل الحقول المطلوبة المميزة قبل الحفظ.",
    "taxTreatment": "المعاملة الضريبية",
    "salesperson": "مندوب المبيعات",
    "department": "القسم",
    "isIntercompany": "عميل بين الشركات",
    "targetCompany": "الشركة المستهدفة",
    "status": "الحالة",
    "active": "نشط",
    "inactive": "غير نشط",
    "allTypes": "جميع الأنواع",
    "allStatuses": "جميع الحالات",
    "allTags": "جميع الوسوم",
    "contacts": "جهات الاتصال",
    "addContact": "إضافة جهة اتصال",
    "tags": "الوسوم",
    "attachTag": "إرفاق وسم",
    "detachTag": "إزالة الوسم",
    "noContacts": "لا توجد جهات اتصال مضافة بعد.",
    "noContactsDescription": "أضف جهة اتصال لتوجيه الفواتير وكشوف الحساب إلى شخص محدد.",
    "noTags": "لا توجد وسوم مرفقة.",
    "createSuccess": "تم إنشاء العميل بنجاح.",
    "updateSuccess": "تم تحديث العميل بنجاح.",
    "activateSuccess": "تمت إعادة تنشيط العميل.",
    "deactivateSuccess": "تم إلغاء تنشيط العميل بنجاح.",
    "contactAdded": "تمت إضافة جهة الاتصال بنجاح.",
    "contactRemoved": "تمت إزالة جهة الاتصال بنجاح.",
    "tagAttached": "تم إرفاق الوسم بنجاح.",
    "tagDetached": "تمت إزالة الوسم بنجاح.",
    "backToList": "العودة إلى قائمة العملاء",
    "outstandingBalance": "الرصيد المستحق",
    "primaryContact": "جهة الاتصال الرئيسية",
    "lastActivity": "آخر نشاط",
    "financialSummary": {
      "title": "الملخص المالي",
      "balance": "الرصيد",
      "overdue": "المتأخر",
      "unapplied": "المبالغ غير المخصصة",
      "lastPayment": "آخر دفعة",
      "loadError": "تعذر تحميل الملخص المالي."
    },
    "hub": {
      "tabsLabel": "أقسام العميل",
      "tabs": {
        "overview": "نظرة عامة",
        "invoices": "الفواتير",
        "payments": "المدفوعات المستلمة",
        "statement": "كشف الحساب"
      },
      "invoicesEmpty": "لا توجد فواتير لهذا العميل",
      "invoicesEmptyDescription": "ستظهر هنا الفواتير الصادرة لهذا العميل.",
      "paymentsEmpty": "لم يتم استلام مدفوعات بعد",
      "paymentsEmptyDescription": "ستظهر هنا المدفوعات المستلمة من هذا العميل.",
      "statementEmpty": "لا توجد قيود في كشف الحساب",
      "statementEmptyDescription": "لا يحتوي كشف حساب هذا العميل على قيود لهذه الفترة.",
      "statementFrom": "من",
      "statementTo": "إلى",
      "openingBalance": "الرصيد الافتتاحي",
      "invoicesLoadError": "تعذر تحميل فواتير هذا العميل.",
      "paymentsLoadError": "تعذر تحميل المدفوعات.",
      "statementLoadError": "تعذر تحميل كشف حساب هذا العميل.",
      "draft": "مسودة",
      "columns": {
        "document": "المستند",
        "date": "التاريخ",
        "dueDate": "تاريخ الاستحقاق",
        "amountDue": "المبلغ المستحق",
        "reference": "المرجع",
        "amount": "المبلغ",
        "type": "النوع",
        "description": "الوصف",
        "paid": "المدفوع",
        "balance": "الرصيد"
      }
    },
    "emptyTitle": "لا يوجد عملاء بعد",
    "emptyBody": "أنشئ أول عميل لإصدار الفواتير وتتبع المستحقات عليه.",
    "noResultsTitle": "لا يوجد عملاء مطابقون لعوامل التصفية",
    "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح عوامل التصفية لعرض كل العملاء.",
    "validation": {
      "nameRequired": "أدخل اسم العميل.",
      "addressRequired": "أدخل عنوان العميل.",
      "countryRequired": "اختر الدولة.",
      "contactNameRequired": "أدخل اسم جهة الاتصال.",
      "emailInvalid": "أدخل بريدًا إلكترونيًا صالحًا."
    }
  },
  "supplier": {
    "detailsDescription": "الهوية والضرائب وشروط الدفع.",
    "contactsDescription": "الأشخاص المسؤولون لدى هذا المورد.",
    "tagsDescription": "وسوم للتجميع والتصفية.",
    "title": "الموردون",
    "countLabel_zero": "لا موردين",
    "countLabel_one": "مورّد واحد",
    "countLabel_two": "مورّدان",
    "countLabel_few": "{{count}} موردين",
    "countLabel_many": "{{count}} موردًا",
    "countLabel_other": "{{count}} مورد",
    "subtitle": "إدارة دليل الموردين وجهات الاتصال والوسوم.",
    "create": "مورد جديد",
    "edit": "تعديل مورد",
    "details": "تفاصيل المورد",
    "deactivate": "إلغاء تنشيط المورد",
    "deactivateConfirmation": "هل أنت متأكد من إلغاء تنشيط المورد {{code}}؟ لا يمكن إصدار أوامر شراء جديدة لمورد غير نشط.",
    "activate": "إعادة تنشيط المورّد",
    "code": "كود المورد",
    "name": "اسم المورد",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "address": "العنوان",
    "addressEn": "العنوان (بالإنجليزية)",
    "addressAr": "العنوان (بالعربية)",
    "country": "الدولة",
    "taxIdentifier": "الرقم الضريبي",
    "paymentTerms": "شروط الدفع",
    "paymentTermsNone": "بدون شروط دفع",
    "defaultCurrency": "العملة الافتراضية",
    "optional": "اختياري",
    "department": "القسم",
    "isIntercompany": "مورد بين الشركات",
    "targetCompany": "الشركة المستهدفة",
    "status": "الحالة",
    "active": "نشط",
    "inactive": "غير نشط",
    "allStatuses": "جميع الحالات",
    "contacts": "جهات الاتصال",
    "addContact": "إضافة جهة اتصال",
    "tags": "الوسوم",
    "attachTag": "إرفاق وسم",
    "detachTag": "إزالة الوسم",
    "noContacts": "لا توجد جهات اتصال مضافة بعد.",
    "noContactsDescription": "أضف جهة اتصال لتوجيه الفواتير وكشوف الحساب إلى شخص محدد.",
    "noTags": "لا توجد وسوم مرفقة.",
    "saveErrorTitle": "لم يُحفظ المورد",
    "saveErrorFields": "راجع ما يلي ثم احفظ مرة أخرى:",
    "createSuccess": "تم إنشاء المورد بنجاح.",
    "updateSuccess": "تم تحديث المورد بنجاح.",
    "activateSuccess": "تمت إعادة تنشيط المورّد.",
    "deactivateSuccess": "تم إلغاء تنشيط المورد بنجاح.",
    "contactAdded": "تمت إضافة جهة الاتصال بنجاح.",
    "contactRemoved": "تمت إزالة جهة الاتصال بنجاح.",
    "tagAttached": "تم إرفاق الوسم بنجاح.",
    "tagDetached": "تمت إزالة الوسم بنجاح.",
    "backToList": "العودة إلى قائمة الموردين",
    "hub": {
      "tabsLabel": "أقسام المورد",
      "tabs": {
        "overview": "نظرة عامة",
        "products": "المنتجات",
        "bills": "الفواتير",
        "payments": "المدفوعات المسددة"
      },
      "billsEmpty": "لا توجد فواتير من هذا المورد",
      "billsEmptyDescription": "ستظهر هنا الفواتير التي تسجلها من هذا المورد.",
      "paymentsEmpty": "لم تُسدَّد مدفوعات بعد",
      "paymentsEmptyDescription": "ستظهر هنا المدفوعات التي تسددها لهذا المورد.",
      "billsLoadError": "تعذر تحميل فواتير هذا المورد.",
      "paymentsLoadError": "تعذر تحميل المدفوعات.",
      "draft": "مسودة",
      "columns": {
        "document": "المستند",
        "reference": "مرجع المورد",
        "date": "التاريخ",
        "dueDate": "تاريخ الاستحقاق",
        "amountDue": "المبلغ المستحق",
        "amount": "المبلغ"
      }
    },
    "primaryContact": "جهة الاتصال الرئيسية",
    "lastActivity": "آخر نشاط",
    "emptyTitle": "لا يوجد موردون بعد",
    "emptyBody": "أنشئ أول مورد لتسجيل الفواتير وتتبع المستحقات عليك.",
    "noResultsTitle": "لا يوجد موردون مطابقون لعوامل التصفية",
    "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح عوامل التصفية لعرض كل الموردين.",
    "validation": {
      "codeRequired": "أدخل كود المورد.",
      "nameEnRequired": "أدخل اسم المورد بالإنجليزية.",
      "nameArRequired": "أدخل اسم المورد بالعربية.",
      "countryRequired": "اختر الدولة.",
      "contactNameRequired": "أدخل اسم جهة الاتصال.",
      "emailInvalid": "أدخل بريدًا إلكترونيًا صالحًا."
    }
  },
  "product": {
    "detailsDescription": "ماهية المنتج ووحدة قياسه.",
    "pricesDescription": "سعر البيع والتكلفة والضريبة.",
    "partNumber": "رقم القطعة",
    "partNumberHelper": "رقم الصانع أو المورد لهذا الصنف. اختياري، ويمكن أن يتكرر بين الأصناف.",
    "title": "المنتجات",
    "countLabel_zero": "لا منتجات",
    "countLabel_one": "منتج واحد",
    "countLabel_two": "منتجان",
    "countLabel_few": "{{count}} منتجات",
    "countLabel_many": "{{count}} منتجًا",
    "countLabel_other": "{{count}} منتج",
    "subtitle": "إدارة كتالوج المنتجات والأسعار وحالة المخزون.",
    "create": "منتج جديد",
    "edit": "تعديل منتج",
    "quickCreateHelp": "ابدأ بالبيانات الأساسية لإنشاء المنتج. يمكنك إضافة التفاصيل الاختيارية لاحقًا.",
    "fieldLegend": "دليل الحقول",
    "required": "مطلوب",
    "optional": "اختياري",
    "hintLabel": "مزيد من المعلومات",
    "essentials": "البيانات الأساسية",
    "optionalDetails": "تفاصيل اختيارية",
    "details": "تفاصيل المنتج",
    "deactivate": "إلغاء تنشيط المنتج",
    "deactivateConfirmation": "هل أنت متأكد من إلغاء تنشيط المنتج {{sku}}؟ لن يمكن تحديد المنتجات المتوقفة في أوامر مبيعات جديدة.",
    "sku": "رمز وحدة التخزين (SKU)",
    "skuHelper": "اترك هذا الحقل فارغًا ليتم إنشاء الرمز تلقائيًا.",
    "name": "اسم المنتج",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "nameHelper": "أدخل الاسم بإحدى اللغتين على الأقل (الإنجليزية أو العربية).",
    "description": "الوصف",
    "descriptionEn": "الوصف (بالإنجليزية)",
    "descriptionAr": "الوصف (بالعربية)",
    "type": "نوع المنتج",
    "typeStockable": "قابل للتخزين",
    "typeConsumable": "استهلاكي",
    "typeService": "خدمة",
    "typeStockableHint": "منتج مادي يُحفظ في المخزون ويكون متاحاً للبيع.",
    "typeConsumableHint": "منتج مادي يُستخدم أو يُستهلك دون تتبع المخزون.",
    "typeServiceHint": "عمل أو وقت يُباع دون مخزون.",
    "category": "الفئة",
    "selectCategory": "اختر الفئة",
    "unitOfMeasure": "وحدة القياس",
    "selectUnitOfMeasure": "اختر وحدة القياس",
    "salesPrice": "سعر البيع",
    "salesPriceCurrency": "عملة البيع",
    "costPrice": "سعر التكلفة",
    "costPriceCurrency": "عملة التكلفة",
    "taxRate": "نسبة الضريبة (%)",
    "status": "الحالة",
    "statusActive": "نشط",
    "statusDiscontinued": "متوقف",
    "allTypes": "جميع الأنواع",
    "allStatuses": "جميع الحالات",
    "allCategories": "جميع الفئات",
    "prices": "أسعار المنتج",
    "setPrice": "تحديد السعر",
    "setPriceTitle": "تحديد سعر المنتج",
    "setPriceDescription": "تحديد سعر مخصص لعملة أو قائمة أسعار محددة.",
    "price": "السعر",
    "currency": "العملة",
    "priceList": "معرف قائمة الأسعار",
    "noPrices": "لم يتم تكوين أسعار مخصصة.",
    "createSuccess": "تم إنشاء المنتج بنجاح.",
    "updateSuccess": "تم تحديث المنتج بنجاح.",
    "activateSuccess": "تمت إعادة تنشيط المنتج.",
    "activate": "إعادة تنشيط المنتج",
    "deactivateSuccess": "تم إلغاء تنشيط المنتج بنجاح.",
    "priceSetSuccess": "تم حفظ سعر المنتج بنجاح.",
    "backToList": "العودة إلى قائمة المنتجات",
    "emptyTitle": "لا توجد منتجات بعد",
    "emptyBody": "أضف أول منتج أو خدمة لاستخدامه في الفواتير وفواتير الموردين.",
    "noResultsTitle": "لا توجد منتجات مطابقة لعوامل التصفية",
    "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح عوامل التصفية لعرض كل المنتجات.",
    "additionalDetails": "تفاصيل إضافية",
    "itemCodeType": "نظام ترميز الصنف",
    "selectItemCodeType": "اختر نظام الترميز",
    "itemCodeTypeNone": "غير محدد",
    "itemCode": "رمز الصنف",
    "etaUnitType": "نوع وحدة الفاتورة الإلكترونية",
    "etaUnitTypePlaceholder": "مثال: PCE أو KGM",
    "etaUnitTypeHelp": "أدخل رمز وحدة الفاتورة الإلكترونية المستخدم لهذا المنتج.",
    "department": "القسم",
    "selectDepartment": "اختر القسم",
    "departmentNone": "بدون قسم",
    "validation": {
      "nameRequired": "أدخل اسم المنتج بالعربية أو الإنجليزية.",
      "unitRequired": "اختر وحدة القياس.",
      "amountInvalid": "أدخل مبلغًا، مثل 100 أو 100.50.",
      "taxRateInvalid": "أدخل نسبة مئوية، مثل 14 أو 14.5.",
      "pricePositive": "أدخل سعرًا أكبر من صفر."
    },
    "costing": {
      "computedHint": "تُحسب من المخزون المتاح",
      "standardNoPermission": "لا يغيّرها إلا من يملك صلاحية تعديل التكاليف المعيارية.",
      "confirmTitle": "حفظ تغييرات التكلفة هذه؟",
      "standardTitle": "تغيير التكلفة المعيارية",
      "standardDescription": "يُعاد تقييم المخزون المتاح بالتكلفة المعيارية الجديدة عند الحفظ.",
      "onHand": "المخزون المتاح",
      "oldCost": "التكلفة المعيارية الحالية",
      "newCost": "التكلفة المعيارية الجديدة",
      "revaluation": "إعادة التقييم (معاينة)",
      "previewNote": "هذه معاينة فقط. تُحسب إعادة التقييم وتُرحَّل عند الحفظ.",
      "stockLoading": "جارٍ تحميل المخزون المتاح",
      "stockError": "تعذّر تحميل المخزون المتاح. ستُحسب إعادة التقييم مع ذلك عند الحفظ.",
      "categoryMoveTitle": "تغيير طريقة التكلفة",
      "categoryMoveBody": "سينتقل مخزون هذا المنتج من {{from}} إلى {{to}}.",
      "categoryMoveStandard": "يُعاد تقييم مخزونه بتكلفته المعيارية، ويُسجَّل الفرق في حساب فروق الأسعار.",
      "confirmAction": "حفظ التغييرات",
      "forbidden": "ليست لديك صلاحية إجراء تغيير التكلفة هذا.",
      "saveErrorTitle": "لم يُحفظ المنتج"
    }
  },
  "category": {
    "title": "فئات المنتجات",
    "subtitle": "إدارة فئات المنتجات الهيكلية والعلاقات الأبوية.",
    "create": "فئة جديدة",
    "edit": "تعديل الفئة",
    "details": "تفاصيل الفئة",
    "deactivate": "إلغاء تنشيط الفئة",
    "deactivateConfirmation": "هل أنت متأكد من إلغاء تنشيط الفئة {{code}}؟ لن يمكن تعيين الفئات غير النشطة للمنتجات الجديدة.",
    "code": "رمز الفئة",
    "name": "اسم الفئة",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "parent": "الفئة الأب",
    "noParent": "بدون (فئة رئيسية)",
    "selectParent": "اختر الفئة الأب",
    "changeParent": "تغيير الفئة الأب",
    "changeParentTitle": "تغيير الفئة الأب",
    "changeParentDescription": "اختر فئة أب جديدة لـ {{code}}.",
    "salesTax": "ضريبة المبيعات",
    "purchaseTax": "ضريبة المشتريات",
    "noTax": "بدون ضريبة",
    "taxSearch": "ابحث في نسب الضرائب",
    "taxNoResults": "لا توجد نسبة ضريبة تطابق هذا البحث.",
    "taxRemove": "إزالة نسبة الضريبة",
    "taxHint": "تُستخدم للمنتجات في هذه الفئة ما لم يكن لعميل أو مورد أو منتج نسبة خاصة به.",
    "taxReadOnlyHint": "لا يستطيع تغيير هذا إلا من يملك صلاحية إدارة نسب الضرائب.",
    "taxLoading": "جارٍ تحميل نسب الضرائب…",
    "taxLoadError": "تعذر تحميل نسب الضرائب. حاول مرة أخرى.",
    "status": "الحالة",
    "active": "نشط",
    "inactive": "غير نشط",
    "allStatuses": "جميع الحالات",
    "treeView": "عرض شجري",
    "listView": "عرض قائمة",
    "rowActions": "إجراءات الفئة",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "noCategories": "لم يتم العثور على فئات منتجات.",
    "noCategoriesDescription": "تجمّع الفئات المنتجات للتقارير والإعدادات الافتراضية. أنشئ أول فئة للبدء.",
    "noSearchMatches": "لا توجد فئات مطابقة لـ \"{{query}}\".",
    "count": "{{visible}} من {{total}} فئة",
    "createSuccess": "تم إنشاء الفئة بنجاح.",
    "updateSuccess": "تم تحديث الفئة بنجاح.",
    "activateSuccess": "تمت إعادة تنشيط الفئة.",
    "activate": "إعادة تنشيط الفئة",
    "deactivateSuccess": "تم إلغاء تنشيط الفئة بنجاح.",
    "parentSuccess": "تم تحديث الفئة الأب بنجاح.",
    "backToList": "العودة إلى الفئات",
    "optional": "اختياري",
    "validation": {
      "codeRequired": "أدخل رمز الفئة.",
      "nameRequired": "أدخل اسم الفئة بالعربية أو الإنجليزية."
    },
    "costing": {
      "method": "طريقة التكلفة",
      "methodHint": "طريقة تقييم مخزون هذه الفئة. أبقِ الطريقة الافتراضية للشركة ما لم تحتج هذه الفئة إلى طريقة خاصة بها.",
      "inherit": "الافتراضي للشركة",
      "methods": {
        "standard": "التكلفة المعيارية",
        "average": "المتوسط المرجح",
        "fifo": "الوارد أولًا يصرف أولًا (FIFO)"
      },
      "readOnlyHint": "لا يعدّل هذا إلا من يملك صلاحية تغيير طرق التكلفة.",
      "priceDifferenceAccount": "حساب فروق الأسعار",
      "priceDifferenceHint": "يُسجَّل فيه الفرق بين سعر المورد والتكلفة المعيارية. اتركه فارغًا لاستخدام حساب الشركة.",
      "priceDifferenceDefault": "الحساب الافتراضي للشركة",
      "useDefaultAccount": "استخدام الحساب الافتراضي",
      "accountSearch": "ابحث في الحسابات",
      "accountEmpty": "لا يوجد حساب يطابق هذا البحث.",
      "confirmTitle": "تغيير طريقة التكلفة؟",
      "confirmBody": "ستنتقل منتجات هذه الفئة التي لها رصيد إلى {{method}}. تبقى قيمة مخزونها كما هي.",
      "confirmBodyStandard": "ستُعاد تقييم منتجات هذه الفئة التي لها رصيد بتكلفتها المعيارية، ويُسجَّل الفرق في حساب فروق الأسعار.",
      "confirmAction": "تغيير الطريقة",
      "saveErrorTitle": "لم تُحفظ الفئة",
      "forbidden": "ليست لديك صلاحية تغيير طريقة التكلفة."
    }
  },
  "contact": {
    "name": "اسم جهة الاتصال",
    "role": "المنصب / الدور",
    "phone": "رقم الهاتف",
    "email": "البريد الإلكتروني",
    "isPrimary": "جهة اتصال رئيسية",
    "primary": "رئيسي",
    "addTitle": "إضافة جهة اتصال",
    "addDescription": "إضافة شخص جهة اتصال جديد لهذا العميل."
  },
  "phoneField": {
    "country": "الدولة",
    "internationalHint": "الرقم يتضمن رمز الدولة"
  },
  "currencyField": {
    "placeholder": "اختر العملة",
    "search": "ابحث عن عملة",
    "noResults": "لا توجد عملة مطابقة لهذا البحث."
  },
  "countryField": {
    "placeholder": "اختر الدولة",
    "search": "ابحث عن دولة",
    "noResults": "لا توجد دولة مطابقة لهذا البحث."
  },
  "tag": {
    "selectTag": "اختر وسماً لإرفاقه",
    "title": "وسوم الدليل",
    "subtitle": "إدارة وسوم التصنيف على مستوى الشركة للعملاء والموردين.",
    "create": "وسم جديد",
    "edit": "تعديل الوسم",
    "delete": "حذف الوسم",
    "deleteConfirmation": "هل أنت متأكد من حذف الوسم \"{{name}}\"؟ سيتم إلغاء إرفاقه من جميع العملاء والموردين.",
    "name": "اسم الوسم",
    "namePlaceholder": "مثال: كبار العملاء، الجملة",
    "noTags": "لم يتم العثور على وسوم.",
    "emptyBody": "تصنّف الوسوم العملاء والموردين في الدليل. أنشئ أول وسم للبدء.",
    "noResultsTitle": "لا توجد وسوم مطابقة لهذا البحث",
    "noResultsBody": "جرّب عبارة مختلفة، أو امسح البحث.",
    "createSuccess": "تم إنشاء الوسم بنجاح.",
    "updateSuccess": "تم إعادة تسمية الوسم بنجاح.",
    "deleteSuccess": "تم حذف الوسم بنجاح.",
    "validation": {
      "nameRequired": "أدخل اسم الوسم."
    }
  },
  "auth": {
    "signInTitle": "تسجيل الدخول",
    "signInSubtitle": "سجّل الدخول إلى الشركات التي منحك المسؤول الوصول إليها.",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "login": "البريد الإلكتروني أو رقم الهاتف",
    "password": "كلمة المرور",
    "signingIn": "جارٍ تسجيل الدخول…",
    "forgotPasswordLink": "نسيت كلمة المرور؟",
    "backToSignIn": "العودة إلى تسجيل الدخول",
    "twoFactor": {
      "title": "التحقق الثنائي",
      "subtitle": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة، أو أحد رموز الاسترداد.",
      "code": "رمز المصادقة",
      "recoveryCode": "رمز الاسترداد",
      "useRecoveryCode": "استخدام رمز استرداد بدلًا من ذلك",
      "useAuthenticatorCode": "استخدام رمز التطبيق بدلًا من ذلك",
      "verifying": "جارٍ التحقق…",
      "verify": "تحقّق",
      "recoverySubtitle": "أدخل أحد رموز الاسترداد التي حفظتها عند التسجيل.",
      "lostDevice": "فقدت جهازك؟",
      "haveAuthenticator": "هل لديك تطبيق المصادقة؟",
      "noChallenge": "إذا لم تكن قد أدخلت كلمة مرورك للتو، فسجّل الدخول أولًا."
    },
    "forgotPassword": {
      "title": "إعادة تعيين كلمة المرور",
      "subtitle": "أدخل البريد الذي تسجّل به الدخول، وسنرسل رابطًا لاختيار كلمة مرور جديدة.",
      "sendLink": "إرسال رابط الاسترداد",
      "sending": "جارٍ الإرسال…",
      "emailSent": "إن كان هناك حساب لهذا البريد، فقد أُرسل إليه رابط الاسترداد.",
      "phoneResetHint": "إذا كنت تسجل الدخول برقم هاتف، فاطلب من مسؤول الموارد البشرية رمز إعادة التعيين.",
      "resetCodeLink": "لدي رمز إعادة تعيين من الموارد البشرية"
    },
    "resetCode": {
      "title": "استخدام رمز إعادة التعيين",
      "subtitle": "أدخل الرمز الذي حصلت عليه من الموارد البشرية لاختيار كلمة مرور جديدة.",
      "identifier": "البريد الإلكتروني أو رقم الهاتف",
      "code": "رمز إعادة التعيين",
      "newPassword": "كلمة المرور الجديدة",
      "confirmation": "تأكيد كلمة المرور الجديدة",
      "submit": "تغيير كلمة المرور",
      "submitting": "جارٍ تغيير كلمة المرور…",
      "success": "تم تغيير كلمة مرورك. سجّل الدخول باستخدام كلمة المرور الجديدة."
    },
    "activate": {
      "title": "تفعيل حسابك",
      "intro": "أدخل الرمز من البطاقة التي أعطتك إياها الموارد البشرية.",
      "code": "رمز التفعيل",
      "phone": "رقم الهاتف",
      "password": "كلمة المرور الجديدة",
      "confirmation": "تأكيد كلمة المرور الجديدة",
      "currentPassword": "كلمة المرور الحالية",
      "existingAccount": "لديك حساب بالفعل. أدخل كلمة المرور الحالية للانضمام إلى هذه الشركة.",
      "submit": "تفعيل الحساب",
      "submitting": "جارٍ تفعيل الحساب…",
      "success": "حسابك نشط الآن. سجّل الدخول باستخدام رقم هاتفك."
    },
    "resetPassword": {
      "title": "اختر كلمة مرور جديدة",
      "subtitle": "أدخل كلمة المرور الجديدة لحسابك.",
      "newPassword": "كلمة المرور الجديدة",
      "newPasswordConfirmation": "تأكيد كلمة المرور الجديدة",
      "reset": "إعادة تعيين كلمة المرور",
      "resetting": "جارٍ التعيين…",
      "success": "تمت إعادة تعيين كلمة المرور. يمكنك الآن تسجيل الدخول.",
      "passwordMinLength": "يجب أن لا تقل كلمة المرور عن 8 أحرف.",
      "passwordConfirmationMatch": "كلمتا المرور غير متطابقتين."
    },
    "invitationAccept": {
      "title": "قبول الدعوة",
      "subtitle": "أدخل اسمك وكلمة مرور للانضمام إلى المنظمة.",
      "name": "الاسم الكامل",
      "password": "كلمة المرور",
      "passwordConfirmation": "تأكيد كلمة المرور",
      "submit": "قبول الدعوة",
      "submitting": "جارٍ القبول…",
      "missingLink": "رابط الدعوة هذا غير مكتمل. تواصل مع مسؤول النظام للحصول على رابط جديد."
    },
    "twoFactorSetup": {
      "title": "تفعيل المصادقة الثنائية",
      "subtitle": "امسح رمز الـ QR بتطبيق المصادقة، ثم أدخل الرمز المكوّن من 6 أرقام للتأكيد.",
      "stepConfirmPassword": "أكّد كلمة مرورك للمتابعة.",
      "password": "كلمة المرور",
      "confirm": "تأكيد",
      "stepScan": "امسح رمز الـ QR هذا بتطبيق المصادقة",
      "code": "الرمز من التطبيق",
      "enable": "تفعيل المصادقة الثنائية",
      "enabling": "جارٍ التفعيل…",
      "stepRecovery": "احفظ رموز الاسترداد",
      "recoverySubtitle": "يمكن استخدام كل رمز مرة واحدة إن فقدت الوصول إلى تطبيق المصادقة. خزّنها في مكان آمن.",
      "download": "تنزيل",
      "copy": "نسخ",
      "copied": "تم النسخ",
      "done": "تم",
      "secretLabel": "أو أدخل هذا المفتاح يدويًا:",
      "invalidSecret": "تعذّر تحميل رمز الـ QR. حاول مرة أخرى."
    },
    "errors": {
      "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "rateLimited": "محاولات كثيرة جدًا. انتظر دقيقة وحاول مجددًا.",
      "recoveryCodeInvalid": "هذا الرمز غير صالح.",
      "twoFactorInvalid": "الرمز الذي أدخلته غير صالح."
    },
    "signInEyebrow": "تسجيل دخول الشركة",
    "welcomeBack": "مرحبًا بعودتك",
    "emailPlaceholder": "you@company.com",
    "loginPlaceholder": "البريد الإلكتروني أو رقم الهاتف",
    "togglePassword": "إظهار كلمة المرور أو إخفاؤها",
    "show": "إظهار",
    "hide": "إخفاء",
    "provisionedNote": "ينشئ مسؤول شركتك الحسابات.",
    "operatorEyebrow": "مشغّل المنصة",
    "operatorEmail": "بريد المشغّل",
    "twoFactorMandatory": "المصادقة الثنائية إلزامية في هذا الجانب ولا يمكن إيقافها.",
    "continueToTwoFactor": "المتابعة إلى المصادقة الثنائية",
    "devLogin": "تسجيل دخول المطوّر",
    "noSelfRegistration": "يتم إنشاء حسابات المشغّلين بواسطة مشغّل آخر، ولا يمكن التسجيل الذاتي.",
    "hero": {
      "tag": "متعددة الشركات",
      "headlineLead": "تسجيل دخول واحد.",
      "headlineRest": "لكل شركة.",
      "headlineBody": "حافظ على فصل دفاتر كل شركة، وأدر كل شيء من مساحة عمل واحدة.",
      "sampleLabel": "دفتر نموذجي · للتوضيح فقط",
      "sampleCompanyLabel": "الشركة",
      "sampleCompany": "شركة نورثستار القابضة",
      "sampleContext": "السنة المالية 2026 · USD",
      "trialBalance": "ميزان المراجعة",
      "debits": "مدين",
      "credits": "دائن",
      "difference": "الفرق",
      "balanced": "متوازن",
      "capabilities": "متعدد الشركات · متعدد العملات · المحاسبة · الموارد البشرية · العمليات",
      "privacy": "تبقى دفاتر كل شركة منفصلة وخاصة.",
      "operatorsOnly": "للمشغّلين فقط",
      "platformHeadline": "أنت تشغّل المنصة. ولا تطّلع على دفاترهم.",
      "platformBody": "يدير المشغّلون المجموعات والخطط وصلاحيات الدعم. يُسجَّل فتح جلسة دعم داخل مجموعة عميل، ويمكن للعميل رؤيتها في شاشة التدقيق الخاصة به.",
      "twoFactorMandatory": "المصادقة الثنائية إلزامية هنا ولا يمكن إيقافها."
    }
  },
  "account": {
    "title": "حسابك",
    "subtitle": "ملفك الشخصي وكلمة المرور وما تُشعر به.",
    "tabs": {
      "profile": "الملف الشخصي",
      "security": "الأمان",
      "notifications": "الإشعارات"
    },
    "avatar": {
      "title": "الصورة",
      "upload": "ارفع صورة",
      "remove": "إزالة",
      "hint": "JPEG أو PNG أو WebP، بحجم أقصاه 2 ميجابايت. نقتطع منها مربعًا ونحفظ نسختين صغيرتين؛ ولا نحفظ الملف الذي ترفعه. صورتك مرئية لمن في مجموعة شركاتك."
    },
    "profile": {
      "title": "أنت",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "noEmail": "لا يوجد بريد إلكتروني",
      "loginPhone": "رقم هاتف تسجيل الدخول",
      "notSet": "غير محدد",
      "emailFixed": "بريدك الإلكتروني هو معرّف دخولك ولا يمكن تغييره من هنا. راجع أحد المسؤولين.",
      "verified": "مُوثّق",
      "unverified": "غير مُوثّق",
      "saved": "تم الحفظ.",
      "error": "تعذّر تحميل ملفك الشخصي.",
      "errors": {
        "name": "يجب أن يتكوّن الاسم من حرفين على الأقل."
      },
      "languageTitle": "اللغة",
      "languageNote": "يُحفظ في حسابك، فينتقل معك إلى أي جهاز آخر.",
      "languageNotSaved": "تغيّرت اللغة على هذا الجهاز لكن لم يُحفظ التغيير في حسابك.",
      "deviceTitle": "هذا الجهاز",
      "deviceNote": "يُحفظ المظهر في هذا المتصفح فقط.",
      "timePreferencesTitle": "الوقت والمنطقة الزمنية",
      "timePreferencesNote": "اختر طريقة عرض الطوابع الزمنية والأوقات في مساحة عملك.",
      "timezone": "المنطقة الزمنية",
      "timezoneBrowser": "استخدام المنطقة الزمنية لهذا الجهاز",
      "timeFormat": "تنسيق الوقت",
      "timeFormat12": "12 ساعة (ص/م)",
      "timeFormat24": "24 ساعة",
      "timePreferencesSaving": "جارٍ الحفظ…"
    },
    "email": {
      "change": "تغيير البريد الإلكتروني",
      "dialogTitle": "تغيير بريدك الإلكتروني",
      "dialogBody": "سنرسل رابط تأكيد إلى العنوان الجديد. لن يتغير بريدك إلا بعد فتح ذلك الرابط. وسنُبلغ عنوانك الحالي بأنك طلبت هذا التغيير.",
      "pending": "في انتظار التأكيد على {{email}}. افتح الرابط الذي أرسلناه لإكمال التغيير.",
      "changed": "تم تغيير بريدك الإلكتروني.",
      "expired": "انتهت صلاحية رابط التأكيد أو سبق استخدامه.",
      "taken": "لم يعد هذا العنوان متاحًا. اطلب تغييرًا آخر."
    },
    "loginPhone": {
      "change": "تغيير",
      "changeButton": "تغيير رقم الدخول",
      "removeButton": "إزالة رقم الدخول",
      "changeDescription": "ستسجّل الدخول بهذا الرقم. اطلب من الموارد البشرية رمزًا صادرًا لهذا الرقم تحديدًا، ثم أدخله مع كلمة المرور الحالية.",
      "code": "الرمز من الموارد البشرية",
      "codeError": "تحقق من الرمز والرقم. تصدر الموارد البشرية الرمز لرقم واحد فقط.",
      "removeDescription": "ستسجّل الدخول ببريدك الإلكتروني فقط. أدخل كلمة المرور الحالية للتأكيد.",
      "remove": "إزالة",
      "removeEmail": "إزالة البريد الإلكتروني",
      "changeTitle": "تغيير رقم هاتف تسجيل الدخول",
      "removeTitle": "إزالة رقم هاتف تسجيل الدخول",
      "removeEmailTitle": "إزالة بريدك الإلكتروني",
      "currentPassword": "كلمة المرور الحالية",
      "save": "حفظ رقم الهاتف",
      "success": "تم تحديث رقم هاتف تسجيل الدخول.",
      "removed": "تمت إزالة رقم هاتف تسجيل الدخول.",
      "emailRemoved": "تمت إزالة بريدك الإلكتروني."
    },
    "security": {
      "passwordTitle": "تغيير كلمة المرور",
      "twoFactorTitle": "التحقق بخطوتين",
      "passwordBody": "اختر كلمة مرور لا تستخدمها في أي مكان آخر. ستبقى مسجّل الدخول على هذا الجهاز.",
      "currentPassword": "كلمة المرور الحالية",
      "newPassword": "كلمة المرور الجديدة",
      "confirmPassword": "تأكيد كلمة المرور",
      "passwordChanged": "تم تغيير كلمة المرور.",
      "errors": {
        "required": "هذا الحقل مطلوب.",
        "minLength": "يجب أن تتكوّن كلمة المرور من 8 أحرف على الأقل.",
        "mismatch": "كلمتا المرور غير متطابقتين.",
        "generic": "تعذّر تغيير كلمة المرور."
      }
    },
    "sessions": {
      "title": "أين أنت مسجّل الدخول",
      "body": "إدارة الأجهزة والمتصفحات النشطة المسجّلة حالياً في حسابك.",
      "device": "الجهاز",
      "ipAddress": "عنوان IP",
      "lastActive": "آخر نشاط",
      "thisDevice": "هذا الجهاز",
      "currentSessionBadge": "الجلسة الحالية",
      "revoke": "إنهاء الجلسة",
      "endOthers": "إنهاء جميع الجلسات الأخرى",
      "singleSessionNotice": "أنت مسجّل الدخول على هذا الجهاز فقط. لا توجد أي جلسات نشطة أخرى.",
      "revokeDialogTitle": "إنهاء الجلسة",
      "revokeDialogBody": "هل أنت متأكد من إنهاء هذه الجلسة؟ سيتم تسجيل الخروج فوراً من ذلك الجهاز.",
      "endOthersDialogTitle": "إنهاء جميع الجلسات الأخرى",
      "endOthersDialogBody": "هل أنت متأكد من إنهاء جميع الجلسات الأخرى؟ سيتم تسجيل الخروج من كافة المتصفحات والأجهزة باستثناء هذا الجهاز فوراً."
    }
  },
  "dashboard": {
    "title": "لوحة التحكم",
    "pulse": {
      "loading": "جارٍ تحميل لوحة المعلومات",
      "lastMonth": "{{month}}: {{value}}",
      "vsPreviousPeriod": "مقارنة بالأيام نفسها من الشهر الماضي",
      "noPrior": "لا يوجد رقم سابق",
      "total": "الإجمالي",
      "tiles": {
        "revenue": "الإيرادات · الشهر حتى اليوم",
        "expenses": "المصروفات · الشهر حتى اليوم",
        "netResult": "صافي النتيجة · الشهر حتى اليوم",
        "cash": "النقدية",
        "cashAccounts_zero": "لا حسابات",
        "cashAccounts_one": "حساب واحد",
        "cashAccounts_two": "حسابان",
        "cashAccounts_few": "{{count}} حسابات",
        "cashAccounts_many": "{{count}} حسابًا",
        "cashAccounts_other": "{{count}} حساب",
        "sales": "المبيعات · الشهر حتى اليوم",
        "orders": "الطلبات · الشهر حتى اليوم",
        "averageOrder": "متوسط الطلب · الشهر حتى اليوم",
        "headcount": "عدد الموظفين",
        "joinedThisMonth_zero": "لم ينضم أحد هذا الشهر",
        "joinedThisMonth_one": "انضم موظف واحد هذا الشهر",
        "joinedThisMonth_two": "انضم موظفان هذا الشهر",
        "joinedThisMonth_few": "انضم {{count}} موظفين هذا الشهر",
        "joinedThisMonth_many": "انضم {{count}} موظفًا هذا الشهر",
        "joinedThisMonth_other": "انضم {{count}} موظف هذا الشهر",
        "leaveWaiting": "طلبات إجازة بانتظار القرار",
        "claimsWaiting": "طلبات مصروفات للمراجعة",
        "awaitingDecision": "بانتظار القرار",
        "departments": "الإدارات",
        "largestDepartment": "الأكبر: {{name}}",
        "stockValue": "قيمة المخزون",
        "items_zero": "لا أصناف",
        "items_one": "صنف واحد",
        "items_two": "صنفان",
        "items_few": "{{count}} أصناف",
        "items_many": "{{count}} صنفًا",
        "items_other": "{{count}} صنف",
        "stockIssued": "المخزون المصروف · هذا الشهر",
        "received": "{{value}} مستلم",
        "belowMinimum": "أقل من الحد الأدنى",
        "toReorder": "أصناف تحتاج إعادة طلب",
        "outOfStock": "نفد من المخزون",
        "itemsOut": "أصناف بلا رصيد"
      },
      "series": {
        "month": "الشهر",
        "revenue": "الإيرادات",
        "expenses": "المصروفات",
        "netResult": "صافي النتيجة",
        "partial": "هذا الشهر حتى الآن",
        "sales": "المبيعات",
        "headcount": "عدد الموظفين",
        "joiners": "المنضمون",
        "leavers": "المغادرون",
        "received": "المستلم",
        "issued": "المصروف"
      },
      "panels": {
        "monthlyResult": "الإيرادات والمصروفات الشهرية",
        "monthlyResultCaption": "الشهر حتى اليوم · الإيرادات {{revenue}} · المصروفات {{expenses}} · صافي النتيجة {{netResult}}",
        "profitAndLossLink": "فتح تقرير الأرباح والخسائر",
        "whoOwesWhom": "من يدين لمن",
        "customersOweUs": "مستحق لنا من العملاء",
        "weOweSuppliers": "مستحق علينا للموردين",
        "overdue": "{{value}} متأخر",
        "agingLink": "فتح تقرير أعمار الديون",
        "spending": "أين ذهبت الأموال · هذا العام",
        "monthlySales": "المبيعات الشهرية",
        "salesLink": "فتح نظرة المبيعات العامة",
        "topCustomers": "أكبر العملاء · هذا الشهر",
        "salesByCategory": "المبيعات حسب الفئة · هذا الشهر",
        "headcount": "عدد الموظفين والمنضمون والمغادرون",
        "peopleLink": "فتح قائمة الموظفين",
        "peopleByDepartment": "الموظفون حسب الإدارة",
        "stockMovement": "المخزون المستلم والمصروف",
        "inventoryLink": "فتح نظرة المخزون العامة",
        "stockByCategory": "قيمة المخزون حسب الفئة"
      },
      "aging": {
        "current": "غير مستحق",
        "days_1_30": "1–30 يومًا",
        "days_31_60": "31–60 يومًا",
        "days_61_90": "61–90 يومًا",
        "days_over_90": "أكثر من 90 يومًا"
      },
      "start": {
        "accounting": {
          "title": "المحاسبة",
          "body": "رحّل أول فاتورة بيع أو شراء لترى أموالك هنا.",
          "cta": "فتح المحاسبة"
        },
        "sales": {
          "title": "المبيعات",
          "body": "أكّد أول أمر بيع لترى المبيعات حسب الشهر.",
          "cta": "فتح المبيعات"
        },
        "hr": {
          "title": "الموظفون",
          "body": "أضف أول موظف لترى عدد الموظفين والإدارات.",
          "cta": "فتح الموارد البشرية"
        },
        "inventory": {
          "title": "المخزون",
          "body": "استلم أول مخزون لترى قيمته وحركته.",
          "cta": "فتح المخزون"
        }
      },
      "error": "تعذّر تحميل هذه الأرقام."
    },
    "placeholder": "لا يوجد شيء هنا بعد. ستصل الوحدات مع الخطة التالية.",
    "greeting": "صباح الخير، {{name}}",
    "greetingAfternoon": "مساء الخير، {{name}}",
    "greetingEvening": "مساء الخير، {{name}}",
    "greetingRamadan": "رمضان كريم، {{name}}",
    "greetingEid": "عيد مبارك، {{name}}",
    "scope": "{{group}} · {{company}}",
    "scopeUnknown": "لا توجد شركة نشطة",
    "header": {
      "memberships": "عضوياتك · {{company}}",
      "groupMemberships": "عضويات المجموعة"
    },
    "stats": {
      "entities": "الكيانات",
      "members": "الأعضاء · هذه الشركة",
      "allActive": "الجميع نشط",
      "roles": "الأدوار",
      "roleSplit": "{{builtIn}} مدمج، {{custom}} مخصص",
      "grants": "صلاحياتك · هذه الشركة",
      "grantsNote": "من دليل الصلاحيات",
      "suspendedCount_zero": "لا يوجد موقوفون",
      "suspendedCount_one": "موقوف واحد",
      "suspendedCount_two": "موقوفان",
      "suspendedCount_few": "{{count}} موقوفين",
      "suspendedCount_many": "{{count}} موقوفًا",
      "suspendedCount_other": "{{count}} موقوف"
    },
    "entities": {
      "title": "الكيانات",
      "meta": "الشركات التي أنت عضو فيها",
      "code": "الرمز",
      "country": "الدولة",
      "countryPlaceholder": "اختر دولة",
      "entity": "الكيان",
      "currency": "العملة",
      "yourRole": "دورك",
      "customRole": "دور مخصص",
      "total": "الإجمالي",
      "count_zero": "لا توجد كيانات",
      "count_one": "كيان واحد",
      "count_two": "كيانان",
      "count_few": "{{count}} كيانات",
      "count_many": "{{count}} كيانًا",
      "count_other": "{{count}} كيان"
    },
    "waiting": {
      "title": "بانتظارك",
      "count_zero": "لا توجد عناصر",
      "count_one": "عنصر واحد",
      "count_two": "عنصران",
      "count_few": "{{count}} عناصر",
      "count_many": "{{count}} عنصرًا",
      "count_other": "{{count}} عنصر",
      "leave": "الإجازات",
      "expenses": "طلبات المصروفات",
      "reviews": "مسودات التقييم",
      "assets": "أصول تحتاج إلى إجراء",
      "link": "فتح القائمة",
      "emptyTitle": "لا يوجد شيء بالانتظار",
      "emptyBody": "لا شيء يحتاج قرارك الآن."
    },
    "audit": {
      "title": "الإدارة الأخيرة",
      "meta": "سجل التغييرات",
      "emptyTitle": "لا توجد أحداث بعد",
      "emptyBody": "ستظهر أحداث الإدارة هنا بمجرد تسجيلها.",
      "link": "فتح سجل التغييرات"
    },
    "attention": {
      "overdueReceivables": "المتحصلات المتأخرة",
      "overdueCount_zero": "لا فواتير متأخرة السداد",
      "overdueCount_one": "فاتورة واحدة متأخرة السداد",
      "overdueCount_two": "فاتورتان متأخرتان في السداد",
      "overdueCount_few": "{{count}} فواتير متأخرة السداد",
      "overdueCount_many": "{{count}} فاتورة متأخرة السداد",
      "overdueCount_other": "{{count}} فاتورة متأخرة السداد",
      "overdueNone": "لا شيء متأخر السداد",
      "billsDueWeek": "فواتير مستحقة هذا الأسبوع",
      "billsDueCount_zero": "لا فواتير مستحقة بحلول {{date}}",
      "billsDueCount_one": "فاتورة واحدة تُستحق بحلول {{date}}",
      "billsDueCount_two": "فاتورتان تُستحقان بحلول {{date}}",
      "billsDueCount_few": "{{count}} فواتير تُستحق بحلول {{date}}",
      "billsDueCount_many": "{{count}} فاتورة تُستحق بحلول {{date}}",
      "billsDueCount_other": "{{count}} فاتورة تُستحق بحلول {{date}}",
      "billsDueNone": "لا شيء مستحق هذا الأسبوع",
      "approvalsWaiting": "موافقات بانتظارك",
      "approvalsNote": "بانتظار قرارك",
      "approvalsNone": "لا شيء بانتظارك",
      "draftInvoices": "مسودات الفواتير",
      "draftBills": "مسودات فواتير الموردين",
      "draftNote": "بانتظار التأكيد",
      "draftNone": "لا مسودات",
      "groups": {
        "accounting": "المحاسبة",
        "people": "الأفراد"
      },
      "allClear": "كل شيء على ما يرام",
      "errorHint": "تعذّر التحميل",
      "leaveRequests": "طلبات إجازة مفتوحة",
      "leaveRequestsCount_zero": "لا طلبات معلّقة",
      "leaveRequestsCount_one": "طلب واحد معلّق",
      "leaveRequestsCount_two": "طلبان معلّقان",
      "leaveRequestsCount_few": "{{count}} طلبات معلّقة",
      "leaveRequestsCount_many": "{{count}} طلبًا معلّقًا",
      "leaveRequestsCount_other": "{{count}} طلب معلّق",
      "leaveRequestsNone": "لا شيء معلّق",
      "expenseClaims": "طلبات مصروفات للمراجعة",
      "expenseClaimsNone": "لا شيء مقدمًا",
      "documentsExpiring": "مستندات على وشك الانتهاء",
      "documentsExpiringCount_zero": "لا مستندات تنتهي خلال 30 يومًا",
      "documentsExpiringCount_one": "مستند واحد ينتهي خلال 30 يومًا",
      "documentsExpiringCount_two": "مستندان ينتهيان خلال 30 يومًا",
      "documentsExpiringCount_few": "{{count}} مستندات تنتهي خلال 30 يومًا",
      "documentsExpiringCount_many": "{{count}} مستندًا ينتهي خلال 30 يومًا",
      "documentsExpiringCount_other": "{{count}} مستند ينتهي خلال 30 يومًا",
      "documentsExpiringNone": "لا شيء ينتهي خلال 30 يومًا",
      "headcount": "عدد الموظفين",
      "headcountJoined_zero": "لم ينضم أحد هذا الشهر",
      "headcountJoined_one": "انضمام واحد هذا الشهر",
      "headcountJoined_two": "انضمامان هذا الشهر",
      "headcountJoined_few": "{{count}} انضمامات هذا الشهر",
      "headcountJoined_many": "{{count}} انضمامًا هذا الشهر",
      "headcountJoined_other": "{{count}} انضمام هذا الشهر",
      "headcountLeft_zero": "لم يغادر أحد هذا الشهر",
      "headcountLeft_one": "مغادرة واحدة هذا الشهر",
      "headcountLeft_two": "مغادرتان هذا الشهر",
      "headcountLeft_few": "{{count}} مغادرات هذا الشهر",
      "headcountLeft_many": "{{count}} مغادرة هذا الشهر",
      "headcountLeft_other": "{{count}} مغادرة هذا الشهر",
      "openRoles": "وظائف شاغرة",
      "rolesPipeline_zero": "لا مرشحين في المسار",
      "rolesPipeline_one": "مرشح واحد في المسار",
      "rolesPipeline_two": "مرشحان في المسار",
      "rolesPipeline_few": "{{count}} مرشحين في المسار",
      "rolesPipeline_many": "{{count}} مرشحًا في المسار",
      "rolesPipeline_other": "{{count}} مرشح في المسار",
      "rolesPipelineNone": "لا مرشحين في المسار",
      "payrollRun": "تشغيل الرواتب",
      "payrollNone": "لا تشغيل يغطي الفترة الحالية"
    },
    "empty": {
      "title": "لا شيء لإدارته بعد",
      "body": "لا تتيح لك صلاحياتك الوصول إلى مساحات عمل الشركة. اطلب من المسؤول منحك صلاحية الوصول."
    },
    "sections": {
      "attention": "يحتاج انتباهك",
      "administration": "الإدارة",
      "openApprovals": "فتح صندوق الموافقات"
    },
    "quickActions": {
      "title": "إجراءات سريعة",
      "new": "جديد",
      "approvals": "الموافقات",
      "newInvoice": "فاتورة جديدة",
      "newSalesOrder": "أمر بيع جديد",
      "newBill": "فاتورة مورد جديدة",
      "recordExpense": "تسجيل مصروف",
      "reviewApprovals": "مراجعة الموافقات ({{count}})"
    }
  },
  "roles": {
    "title": "الأدوار والصلاحيات",
    "subtitle": "قوالب النظام والأدوار المخصصة التي عرفتها شركتك.",
    "list": {
      "heading": "الأدوار",
      "system": "أدوار نظامية",
      "custom": "أدوار مخصصة",
      "new": "دور جديد",
      "copy": "نسخ",
      "empty": "لا توجد أدوار مخصصة بعد",
      "permissionCount_zero": "لا صلاحيات",
      "permissionCount_one": "صلاحية واحدة",
      "permissionCount_two": "صلاحيتان",
      "permissionCount_few": "{{count}} صلاحيات",
      "permissionCount_many": "{{count}} صلاحية",
      "permissionCount_other": "{{count}} صلاحية",
      "select": "عرض {name}"
    },
    "matrix": {
      "column": {
        "object": "الوحدة / الكائن",
        "view": "عرض",
        "create": "إنشاء",
        "edit": "تعديل",
        "delete": "حذف",
        "approve": "اعتماد",
        "export": "تصدير",
        "scope": "النطاق"
      },
      "scope": {
        "own": "السجلات الذاتية",
        "department": "القسم",
        "branch": "الفرع",
        "company": "الشركة",
        "mixed": "مختلط",
        "none": "بلا صلاحيات"
      },
      "granted": "ممنوح",
      "revoked": "مسحوب",
      "grantAll": "منح الصف",
      "revokeAll": "سحب الصف",
      "save": "حفظ التغييرات",
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ التغييرات",
      "dirty": "تغييرات غير محفوظة",
      "noChanges": "لا تغييرات",
      "readOnly": "دور نظامي — للقراءة فقط",
      "reservedRoleManage": "محجوز لدور المالك والمدير",
      "entity": "الكائن",
      "moduleHeading": "الوحدة",
      "reservedHeading": "محجوز",
      "summary": "يستطيع هذا الدور عرض {{view}} عناصر وتغيير {{change}} والموافقة على {{approve}}، على مستوى الشركة.",
      "searchPlaceholder": "البحث بالاسم أو مفتاح الصلاحية",
      "searchCount": "{{count}} صفوف مطابقة",
      "clearSearch": "مسح البحث",
      "reservedPermission": "إدارة الأدوار والصلاحيات"
    },
    "detail": {
      "back": "كل الأدوار",
      "holders_zero": "لا يحمل هذا الدور أي عضو",
      "holders_one": "يحمل هذا الدور عضو واحد",
      "holders_two": "يحمل هذا الدور عضوان",
      "holders_few": "يحمل هذا الدور {{count}} أعضاء",
      "holders_many": "يحمل هذا الدور {{count}} عضوًا",
      "holders_other": "يحمل هذا الدور {{count}} عضو",
      "builtInNotice": "دور نظامي — انسخه لإنشاء نسخة قابلة للتعديل.",
      "expandAll": "توسيع الكل",
      "collapseAll": "طي الكل",
      "tally": "{{granted}} من {{total}} صلاحية",
      "noResults": "لا توجد صلاحيات مطابقة لهذا البحث.",
      "noValue": "—",
      "notFound": "لم يعد هذا الدور موجودًا."
    },
    "level": {
      "none": "بلا وصول",
      "read": "اطلاع",
      "contribute": "مساهمة",
      "full": "كامل",
      "custom": "مخصص",
      "legend": "مستوى الوصول",
      "help": {
        "none": "لا وصول إلى هذه الوحدة إطلاقًا.",
        "read": "عرض السجلات فقط، دون أي تغيير.",
        "contribute": "عرض السجلات وإنشاؤها وتعديلها.",
        "full": "كل شيء، بما في ذلك الحذف والاعتماد والتصدير."
      }
    },
    "changes": {
      "added_zero": "لا صلاحيات مضافة",
      "added_one": "صلاحية واحدة مضافة",
      "added_two": "صلاحيتان مضافتان",
      "added_few": "{{count}} صلاحيات مضافة",
      "added_many": "{{count}} صلاحية مضافة",
      "added_other": "{{count}} صلاحية مضافة",
      "removed_zero": "لا صلاحيات محذوفة",
      "removed_one": "صلاحية واحدة محذوفة",
      "removed_two": "صلاحيتان محذوفتان",
      "removed_few": "{{count}} صلاحيات محذوفة",
      "removed_many": "{{count}} صلاحية محذوفة",
      "removed_other": "{{count}} صلاحية محذوفة",
      "rescoped_zero": "لا تغيير في النطاق",
      "rescoped_one": "تغيّر نطاق واحد",
      "rescoped_two": "تغيّر نطاقان",
      "rescoped_few": "تغيّرت {{count}} نطاقات",
      "rescoped_many": "تغيّر {{count}} نطاقًا",
      "rescoped_other": "تغيّر {{count}} نطاق",
      "none": "لا تغييرات",
      "discard": "تجاهل التغييرات"
    },
    "modules": {
      "heading": "الوحدات",
      "instruction": "امنح كل وحدة مستوى وصول واحدًا ونطاقًا واحدًا. استخدم الضبط الدقيق عند الحاجة إلى استثناء فقط.",
      "count": "{{count}} وحدة",
      "granted": "ممنوحة",
      "grantedHelp": "عدد صلاحيات هذه الوحدة التي يحملها الدور، من أصل كل صلاحياتها.",
      "about": "عن {{name}}",
      "fineTune": "ضبط دقيق",
      "fineTuneFor": "ضبط دقيق لوحدة {{module}}",
      "fineTuneHint": "فعّل أو عطّل الصلاحيات المفردة وحدد نطاق كل صلاحية. أي تغيير هنا يجعل الوحدة تظهر كمخصصة.",
      "branchScopeAvailableFor": "نطاق الفرع متاح للصلاحيات التالية: {{permissions}}.",
      "branchScopePermission": "{{action}} {{entity}}",
      "branchScopeListSeparator": "، ",
      "permissionScope": "نطاق {{permission}}",
      "noGrants": "هذه الوحدة لا تمنح شيئًا بعد. اختر مستوى وصول أولًا.",
      "descriptions": {
        "accounting": "الفواتير والمدفوعات والقيود ودفتر الأستاذ.",
        "core": "إعدادات الشركة والفروع والبيانات المرجعية.",
        "directory": "العملاء والموردون وجهات الاتصال.",
        "hr": "ملفات الموظفين والحضور والإجازات والطلبات.",
        "identity": "المستخدمون والأدوار والوصول إلى الشركة.",
        "inventory": "الأصناف والمستودعات والجرد والتحويلات.",
        "payroll": "فترات الرواتب والأجور وكشوف الرواتب.",
        "platform": "عمليات المنصة وأدوات الدعم.",
        "purchasing": "أوامر الشراء وفواتير الموردين والمرتجعات.",
        "recruitment": "الوظائف الشاغرة والمرشحون وخطوات التوظيف.",
        "sales": "عروض الأسعار وأوامر البيع وفواتير العملاء والمرتجعات.",
        "subscriptions": "الخطط والاشتراكات وفوترة الشركة.",
        "workflow": "سلاسل الاعتماد والطلبات التي تمر بها."
      }
    },
    "scope": {
      "own": "السجلات الذاتية",
      "department": "القسم",
      "branch": "الفرع",
      "company": "الشركة",
      "mixed": "مختلط",
      "help": {
        "own": "السجلات التي يملكها المستخدم أو أنشأها فقط.",
        "department": "كل سجلات قسم المستخدم.",
        "branch": "كل سجلات الموظفين في فرع المستخدم.",
        "company": "كل سجلات الشركة."
      }
    },
    "form": {
      "createTitle": "دور جديد",
      "editTitle": "تعديل الدور",
      "copyTitle": "نسخ الدور النظامي",
      "nameEn": "الاسم (إنجليزي)",
      "nameAr": "الاسم (عربي)",
      "descriptionEn": "الوصف (إنجليزي)",
      "descriptionAr": "الوصف (عربي)",
      "submitCreate": "إنشاء الدور",
      "submitEdit": "حفظ",
      "submitCopy": "إنشاء نسخة",
      "submitting": "جارٍ الحفظ…",
      "nameRequired": "الاسم بالإنجليزية أو العربية مطلوب",
      "createFailed": "تعذّر إنشاء الدور",
      "updateFailed": "تعذّر حفظ التغييرات"
    },
    "deleteDialog": {
      "title": "حذف هذا الدور؟",
      "description": "سيتم حذف {{name}} وكل الصلاحيات التي يحملها نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      "confirm": "حذف الدور"
    },
    "wizard": {
      "details": "التفاصيل",
      "permissions": "الصلاحيات",
      "review": "المراجعة",
      "detailsHeading": "تفاصيل الدور",
      "detailsExplanation": "سمِّ الدور باللغتين. الوصف اختياري.",
      "continue": "متابعة",
      "templateHeading": "ابدأ بقالب",
      "templateExplanation": "انسخ مجموعة أولية من الصلاحيات إلى دور قابل للتعديل.",
      "blankRole": "دور فارغ",
      "blankDescription": "اختر الصلاحيات بنفسك من البداية.",
      "grantCount": "{{count}} صلاحيات",
      "selected": "محدد",
      "permissionBuilder": {
        "search": "البحث في الصلاحيات",
        "searchPlaceholder": "ابحث بالوحدة أو الصلاحية",
        "moduleFilter": "التصفية حسب الوحدة",
        "allModules": "كل الوحدات",
        "summary": "تم تحديد {{selected}} من أصل {{total}} صلاحية",
        "readOnly": "معاينة للقراءة فقط",
        "selectAll": "تحديد الكل",
        "viewOnly": "العرض فقط",
        "clearModule": "مسح الوحدة",
        "scope": "النطاق",
        "reservedExplanation": "محجوز لدور المالك والمدير ولا يمكن تحديده هنا.",
        "noResults": "لا توجد صلاحيات مطابقة لهذا البحث.",
        "accessSummary": {
          "eyebrow": "ملخص الوصول",
          "reviewHeading": "مراجعة الوصول",
          "total": "تم تحديد {{count}} صلاحية",
          "noAccess": "لم يتم تحديد أي وصول. لن يفتح هذا الدور أي منطقة محمية.",
          "broadScopeWarning": "نطاق واسع: يمكن لهذا الدور العمل على مستوى الشركة في الصلاحيات الموضحة أعلاه.",
          "capability": "يمكنه {{actions}} {{entity}} ضمن نطاق {{scope}}.",
          "modules": {
            "accounting": "المحاسبة",
            "core": "الأساسي",
            "directory": "الدليل",
            "hr": "الموارد البشرية",
            "identity": "الهوية",
            "inventory": "المخزون",
            "payroll": "الرواتب",
            "platform": "المنصة",
            "recruitment": "التوظيف",
            "subscriptions": "الاشتراكات",
            "workflow": "الاعتمادات",
            "purchasing": "المشتريات",
            "sales": "المبيعات"
          },
          "entities": {
            "account": "الحسابات",
            "accounting_account": "حسابات دليل الحسابات",
            "accounting_account_import": "استيراد شجرة الحسابات",
            "accounting_asset": "الأصول الثابتة",
            "accounting_asset_depreciation": "عمليات الإهلاك",
            "accounting_asset_disposal": "استبعاد الأصول",
            "accounting_bank": "الحسابات البنكية",
            "accounting_bank_rule": "قواعد البنك",
            "accounting_bill": "فواتير الموردين",
            "accounting_bill_confirm": "اعتماد فواتير الموردين",
            "accounting_bill_debit": "إشعارات المدين",
            "accounting_budget": "الموازنات",
            "accounting_cash_sale": "المبيعات النقدية",
            "accounting_invoice": "فواتير العملاء",
            "accounting_invoice_confirm": "اعتماد فواتير العملاء",
            "accounting_invoice_credit": "إشعارات الدائن",
            "accounting_journal": "القيود اليومية",
            "accounting_journal_post": "ترحيل القيود",
            "accounting_journal_void": "عكس القيود",
            "accounting_money_document": "مستندات الصرف",
            "accounting_opening": "الأرصدة الافتتاحية",
            "accounting_opening_post": "ترحيل الأرصدة الافتتاحية",
            "accounting_payment": "المدفوعات",
            "accounting_payment_cancel": "إلغاء المدفوعات",
            "accounting_payment_confirm": "اعتماد المدفوعات",
            "accounting_period": "الفترات المالية",
            "accounting_period_lock": "إقفال الفترات",
            "accounting_period_unlock": "إعادة فتح الفترات",
            "accounting_post_adjusting_entry": "قيود التسوية في فترة مقفلة",
            "accounting_reconciliation": "التسوية البنكية",
            "accounting_recurring": "القوالب المتكررة",
            "accounting_report": "التقارير المحاسبية",
            "accounting_report_consolidated": "التقارير المجمّعة للمجموعة",
            "accounting_revaluation": "إعادة تقييم العملات",
            "accounting_settings": "إعدادات المحاسبة",
            "accounting_spend": "المصروفات والمدفوعات المقدمة",
            "accounting_statement_import": "استيراد كشوف البنك",
            "accounting_tax": "الضرائب والإقرارات",
            "alert": "التنبيهات",
            "approval": "الاعتمادات",
            "asset": "أصول الشركة",
            "asset_assignment": "إسناد الأصول",
            "attendance": "سجلات الحضور",
            "attendance_correction": "تصحيحات الحضور",
            "attendance_import": "استيراد الحضور",
            "attendance_kiosk": "أجهزة الحضور المشتركة",
            "bill": "فواتير الموردين",
            "cash_custody": "العهد النقدية",
            "collection": "التحصيل والمتابعة",
            "company": "الشركات",
            "costing_method": "طرق التكلفة",
            "customer": "العملاء",
            "customer_return": "مرتجعات العملاء",
            "department": "الإدارات",
            "employee": "الموظفين",
            "employee_document": "وثائق الموظفين",
            "employee_document_restricted": "وثائق الموظفين المقيّدة",
            "employee_financial": "البيانات المالية للموظفين",
            "employee_personal": "البيانات الشخصية للموظفين",
            "expense": "مطالبات المصروفات",
            "expense_category": "فئات المصروفات",
            "goods_receipt": "إشعارات استلام البضاعة",
            "hr_report": "تقارير الموارد البشرية",
            "hr_workflow": "مسارات اعتماد الموارد البشرية",
            "hybrid_work": "جداول العمل المرن",
            "inventory_report": "تقارير المخزون",
            "invoice": "الفواتير",
            "leave": "طلبات الإجازة",
            "leave_balance": "أرصدة الإجازات",
            "leave_eligibility": "استحقاق الإجازات",
            "leave_type": "أنواع الإجازات",
            "lot": "دفعات المخزون",
            "notification": "الإشعارات",
            "overtime": "سجلات الوقت الإضافي",
            "payment": "المدفوعات",
            "payroll_component": "مكونات الراتب",
            "payroll_report": "تقارير الرواتب",
            "payroll_report_lines": "أعمدة مكونات الرواتب",
            "payroll_run": "دورات الرواتب",
            "payroll_run_cancel": "إلغاء دورة الرواتب",
            "payroll_run_confirm": "اعتماد دورة الرواتب",
            "payroll_run_pay": "صرف الرواتب",
            "payroll_run_post": "ترحيل الرواتب",
            "payroll_run_reverse": "عكس دورة الرواتب",
            "payslip": "قسائم الراتب",
            "payslip_release": "إصدار قسائم الرواتب",
            "performance": "تقييمات الأداء",
            "performance_cycle": "دورات التقييم",
            "performance_template": "نماذج التقييم",
            "permission_request": "طلبات الاستئذان",
            "position": "المسمّيات الوظيفية",
            "product": "المنتجات",
            "product_attribute": "خصائص المنتجات",
            "product_category": "فئات المنتجات",
            "product_variant": "أشكال المنتجات",
            "purchase_bill_allocation": "تخصيص فواتير المشتريات",
            "purchase_order": "أوامر الشراء",
            "recruitment_candidate": "المرشحين",
            "recruitment_candidate_convert": "تحويل المرشحين إلى موظفين",
            "recruitment_candidate_move": "نقل المرشحين بين المراحل",
            "recruitment_opening": "الوظائف الشاغرة",
            "recruitment_stage": "مراحل التوظيف",
            "role": "الأدوار",
            "sales_order": "أوامر البيع",
            "sales_price_override": "تجاوز أسعار البيع",
            "standard_cost": "التكاليف المعيارية",
            "stock": "المخزون",
            "stock_adjustment": "تسويات المخزون",
            "stock_count": "جرد المخزون",
            "stock_location": "مواقع التخزين",
            "stock_transfer": "تحويلات المخزون",
            "stock_valuation": "تقييم المخزون",
            "supplier": "الموردين",
            "supplier_return": "مرتجعات الموردين",
            "tag": "الوسوم",
            "unit_of_measure": "وحدات القياس",
            "user": "المستخدمين",
            "user_access": "رموز التفعيل وإعادة التعيين",
            "violation": "المخالفات السلوكية",
            "warehouse": "المخازن",
            "work_entry": "قيود العمل",
            "work_site": "مواقع العمل",
            "workflow": "مسارات الاعتماد"
          }
        },
        "accessPreview": {
          "eyebrow": "معاينة وصول توضيحية",
          "explanation": "هذه أمثلة على المناطق التي قد يستخدمها الدور، وليست قراراً بالتفويض.",
          "empty": "حدد صلاحية لرؤية أمثلة المناطق هنا.",
          "genericScreen": "شاشات توضيحية في هذه الوحدة",
          "screens": {
            "identity": "شاشات توضيحية: الأعضاء والأدوار",
            "accounting": "شاشات توضيحية: الفواتير وفواتير الموردين والمدفوعات",
            "directory": "شاشات توضيحية: العملاء والموردون والمنتجات",
            "hr": "شاشات توضيحية: الموظفون والحضور والإجازات",
            "payroll": "شاشات توضيحية: مسيّرات الرواتب وقسائم الراتب",
            "recruitment": "شاشات توضيحية: المرشحون والوظائف الشاغرة"
          }
        },
        "actions": {
          "view": "عرض",
          "create": "إنشاء",
          "edit": "تعديل",
          "delete": "حذف",
          "approve": "اعتماد",
          "export": "تصدير",
          "access_all": "الوصول إلى جميع المخازن"
        },
        "permissionLabels": {
          "warehouseAccessAll": "الوصول إلى جميع المخازن",
          "warehouseAccessAllExplanation": "يتيح الوصول إلى سجلات المخازن والمخزون في جميع المخازن."
        }
      }
    },
    "systemRoles": {
      "company_owner": "المالك",
      "company_administrator": "المدير",
      "accountant": "المحاسب",
      "sales_representative": "مندوب المبيعات",
      "purchasing_officer": "موظف المشتريات",
      "warehouse_keeper": "أمين المخزن",
      "hr_officer": "موظف الموارد البشرية",
      "employee": "موظف",
      "support_agent": "دعم ملتقى"
    },
    "systemRoleDescriptions": {
      "company_owner": "يستطيع فعل كل شيء في الشركة، بما في ذلك إدارة الأدوار.",
      "company_administrator": "يدير الأعضاء وحساباتهم وأدوار الشركة.",
      "accountant": "يقوم بأعمال المحاسبة للشركة كلها.",
      "sales_representative": "يتعامل مع العملاء والمنتجات والمخزون اللازم للمبيعات.",
      "purchasing_officer": "يتعامل مع الموردين والمنتجات والمخزون اللازم للمشتريات.",
      "warehouse_keeper": "يدير المخازن ومواقع التخزين والدفعات وحركات المخزون.",
      "hr_officer": "يقوم بأعمال الموارد البشرية للشركة كلها: الموظفون وسجلاتهم وحساباتهم.",
      "employee": "خدمة ذاتية فقط: يرى راتبه وإجازاته ووثائقه وطلباته، ولا يرى ما يخص غيره."
    },
    "table": {
      "role": "الدور",
      "kind": "النوع",
      "scope": "نطاق البيانات الافتراضي",
      "users": "المستخدمون",
      "companyChip": "الشركة = {{code}}",
      "tally": "{{total}} أدوار · {{builtIn}} مدمج، {{custom}} مخصص",
      "note": "الأدوار المدمجة قوالب في الكود وليست سجلات — لا يمكن تعديلها أو حذفها، بل نسخها فقط. لا يظهر دور مسؤول المنصة هنا: فهو بلا شركة.",
      "grants": "الصلاحيات",
      "open": "فتح {{name}}"
    },
    "copies": {
      "title": "مشاركته مع",
      "summary": "{{copies}} نُسخ · {{outOfDate}} غير محدَّثة",
      "copy": "نسخ إلى…",
      "push": "دفع التغييرات",
      "columns": {
        "company": "الشركة",
        "status": "الحالة",
        "people": "الأشخاص",
        "updated": "آخر تحديث"
      },
      "status": {
        "in_sync": "متطابق",
        "out_of_date": "غير محدَّث",
        "diverged": "مُتغيِّر محليًا",
        "conflict": "تعارض",
        "no_access": "لا وصول",
        "insufficient_grants": "لا يمكن الدفع"
      },
      "behindBy": "يفتقد {{count}} صلاحيات",
      "divergedBy": "تغيّر محليًا. لديه {{count}} صلاحيات لا يملكها هذا الدور.",
      "conflictWith": "يوجد هنا دور آخر بالاسم نفسه بالفعل.",
      "noAccess": "لا تملك إدارة الأدوار في هذه الشركة",
      "insufficient": "صلاحياتك في هذه الشركة أضيق من صلاحيات هذا الدور.",
      "empty": "هذا الدور موجود في هذه الشركة فقط.",
      "manageExcluded": "لا يتم نسخ صلاحية إدارة الأدوار مطلقًا.",
      "relative": {
        "today": "اليوم",
        "days": "منذ {{count}} أيام"
      }
    },
    "copy": {
      "title": "نسخ {{role}} إلى شركات أخرى",
      "subtitle": "تحصل كل شركة على نسخة مستقلة خاصة بها. لن يؤدي تعديل هذا الدور لاحقًا إلى تغييرها حتى تدفع التغييرات.",
      "cancel": "إلغاء",
      "submit": "نسخ إلى {{count}} شركات",
      "submitEmpty": "حدد الشركات",
      "done": "تم",
      "noCompanies": "هذه المجموعة تضم شركة واحدة فقط.",
      "selectAll": "تحديد الكل ({{count}})",
      "selected": "تم تحديد {{count}}",
      "alreadyHas": "لديها نسخة بالفعل",
      "noAccess": "لا تملك إدارة الأدوار في هذه الشركة",
      "conflict": "يوجد دور باسم {{name}} هنا بالفعل.",
      "mayFail": "صلاحياتك هنا أضيق. قد لا يتم نسخ بعض الصلاحيات.",
      "copied": "تم النسخ",
      "result": "تم النسخ إلى {{copied}} من أصل {{total}} شركات."
    },
    "push": {
      "title": "دفع التغييرات إلى النُسخ",
      "subtitle": "دفع التغييرات للدور {{role}}",
      "cancel": "إلغاء",
      "submit": "دفع التغييرات إلى {{count}} نُسخ",
      "done": "تم",
      "diffFailed": "تعذّر تحديد التغييرات التي ستحدث.",
      "noChanges": "النُسخ متطابقة مع هذا الدور بالفعل.",
      "companies": "الشركات",
      "willAdd": "سيتم إضافة ({{count}})",
      "willRemove": "سيتم إزالة ({{count}})",
      "willWiden": "سيتم توسيع ({{count}})",
      "willNarrow": "سيتم تضييق ({{count}})",
      "showLess": "عرض أقل",
      "showAll": "عرض الكل ({{count}})",
      "inSync": "متطابق بالفعل",
      "noAccess": "لا تملك إدارة الأدوار في هذه الشركة",
      "insufficient": "صلاحياتك في هذه الشركة أضيق من صلاحيات هذا الدور.",
      "willOverwrite": "تغيّر محليًا. سيؤدي الدفع إلى استبدال {{count}} من الصلاحيات المحلية.",
      "peopleAffected": "{{count}} شخصًا يحملون هذا الدور هنا",
      "overwriteWarning": "أنت تستبدل التغييرات المحلية في {{count}} شركات. لا يمكن التراجع عن هذا.",
      "pushed": "تم دفع التغييرات"
    }
  },
  "users": {
    "title": "الأعضاء",
    "subtitle": "الأشخاص الذين لديهم صلاحية الوصول إلى هذه الشركة والدور الذي يحملونه.",
    "list": {
      "heading": "الأعضاء",
      "summary_zero": "لا أعضاء",
      "summary_one": "عضو واحد",
      "summary_two": "عضوان",
      "summary_few": "{{count}} أعضاء",
      "summary_many": "{{count}} عضوًا",
      "summary_other": "{{count}} عضو",
      "empty": "لا يوجد أعضاء بعد",
      "emptyDescription": "ادعُ أول عضو في فريقك للبدء.",
      "invite": "دعوة عضو",
      "columns": {
        "member": "العضو",
        "role": "الدور",
        "branch": "الفرع",
        "status": "الحالة",
        "actions": "الإجراءات",
        "lastSignIn": "آخر تسجيل دخول"
      },
      "remove": "إزالة",
      "edit": "تعديل الدور",
      "removeDialog": {
        "title": "إزالة هذا العضو؟",
        "description": "سيفقد صلاحية الوصول إلى هذه الشركة. سيحتاج إلى دعوة جديدة للعودة."
      },
      "removeAction": "إزالة العضو",
      "noResultsTitle": "لا يوجد أعضاء مطابقون لبحثك",
      "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح البحث لعرض كل الأعضاء.",
      "never": "لم يسجّل الدخول من قبل",
      "actions": "إجراءات العضو",
      "suspend": "إيقاف",
      "reactivate": "إعادة تفعيل",
      "passwordReset": "إرسال بريد إعادة التعيين",
      "resetCode": "تسليم رمز إعادة تعيين",
      "filters": {
        "role": "الدور",
        "allRoles": "كل الأدوار",
        "status": "الحالة",
        "allStatuses": "كل الحالات"
      },
      "confirm": {
        "title": {
          "suspend": "إيقاف هذا العضو؟",
          "reactivate": "إعادة تفعيل هذا العضو؟",
          "reset": "إرسال بريد إعادة تعيين كلمة المرور؟",
          "resetCode": "تسليم رمز إعادة تعيين؟"
        },
        "body": {
          "suspend": "سيفقد {{name}} ({{email}}) الوصول إلى هذه الشركة حتى إعادة تفعيله.",
          "reactivate": "سيستعيد {{name}} ({{email}}) الوصول إلى هذه الشركة.",
          "reset": "سيُرسل رابط إعادة تعيين كلمة المرور إلى {{name}} على {{email}}.",
          "resetCode": "إصدار رمز إعادة تعيين لمرة واحدة إلى {{name}}؟"
        },
        "action": {
          "suspend": "إيقاف العضو",
          "reactivate": "إعادة تفعيل العضو",
          "reset": "إرسال البريد",
          "resetCode": "إصدار الرمز"
        }
      },
      "success": {
        "suspend": "تم إيقاف العضو",
        "reactivate": "تمت إعادة تفعيل العضو",
        "passwordReset": "تم إرسال بريد إعادة تعيين كلمة المرور إلى {{email}}",
        "remove": "تمت إزالة العضو"
      }
    },
    "invitations": {
      "title": "الدعوات المعلّقة",
      "count_zero": "لا توجد دعوات",
      "count_one": "دعوة واحدة",
      "count_two": "دعوتان",
      "count_few": "{{count}} دعوات",
      "count_many": "{{count}} دعوة",
      "count_other": "{{count}} دعوة",
      "columns": {
        "email": "البريد أو الهاتف",
        "role": "الدور",
        "sent": "تاريخ الإرسال",
        "employee": "الموظف",
        "expires": "تاريخ الانتهاء",
        "status": "الحالة",
        "actions": "الإجراءات"
      },
      "status": {
        "pending": "معلّقة",
        "expired": "منتهية",
        "no_code": "لم يُصدر رمز بعد"
      },
      "rowActions": "إجراءات {{email}}",
      "select": "تحديد",
      "selectRow": "تحديد دعوة {{name}}",
      "printSelected": "طباعة بطاقات الدخول ({{count}})",
      "cardsTitle": "بطاقات الدخول ({{count}})",
      "print": "طباعة",
      "closeCards": "إغلاق",
      "issueCode": "إصدار رمز",
      "reprintCode": "إعادة طباعة الرمز",
      "reprintTitle": "إعادة طباعة بطاقة الدخول؟",
      "reprintWarning": "سيتوقف الرمز السابق عن العمل.",
      "reprintSelected": "إعادة طباعة بطاقات الدخول",
      "reprintSelectedTitle": "إعادة طباعة بطاقات الدخول المحددة؟",
      "reprintSelectedWarning": "ستتوقف البطاقات المطبوعة ({{count}}) عن العمل.",
      "card": {
        "companyEn": "Company",
        "companyAr": "الشركة",
        "qrLabel": "رمز QR للتفعيل",
        "expires": "ينتهي",
        "instructionsEn": "Install the Multaqa app, tap Activate, then scan this code.",
        "instructionsAr": "ثبّت تطبيق ملتقى، واضغط تفعيل، ثم امسح هذا الرمز."
      },
      "resend": "إعادة الإرسال",
      "resendSuccess": "تم إرسال الدعوة مرة أخرى إلى {{email}}",
      "resendError": "تعذّرت إعادة إرسال الدعوة.",
      "rateLimited": "طلبات كثيرة جدًا. حاول مرة أخرى بعد دقيقة.",
      "cancel": "إلغاء الدعوة",
      "dismiss": "رجوع",
      "cancelTitle": "إلغاء هذه الدعوة؟",
      "cancelDescription": "سيتم إلغاء الدعوة الموجهة إلى {{email}}. سيتوقف الرابط الموجود في البريد الإلكتروني عن العمل.",
      "cancelPhoneDescription": "سيتم إلغاء الدعوة إلى {{phone}} وسيتوقف رمز التفعيل عن العمل.",
      "cancelSuccess": "تم إلغاء الدعوة",
      "cancelError": "تعذّر إلغاء الدعوة."
    },
    "loginPhone": {
      "title": "تغيير رقم الدخول",
      "label": "رقم الدخول",
      "change": "تغيير رقم الدخول",
      "remove": "إزالة",
      "useHrPhone": "استخدام رقم الموارد البشرية",
      "issueCode": "إصدار رمز تغيير رقم الهاتف",
      "issueCodeBody": "أدخل الرقم الجديد. يعمل الرمز لهذا الرقم فقط، مرة واحدة، لمدة 24 ساعة.",
      "issueCodeAction": "إصدار الرمز"
    },
    "phoneChangeCode": {
      "title": "رمز تغيير رقم الهاتف",
      "forNumber": "للرقم {{phone}}",
      "warning": "سلّم هذا الرمز للعضو شخصيًا فقط. يعمل لهذا الرقم فقط، مرة واحدة، لمدة 24 ساعة."
    },
    "resetCode": {
      "title": "رمز إعادة التعيين",
      "warning": "سلّم هذا الرمز للعضو شخصيًا فقط. يعمل مرة واحدة لمدة 24 ساعة."
    },
    "status": {
      "active": "نشط",
      "suspended": "موقوف",
      "removed": "مُزال"
    },
    "errors": {
      "lastOwner": "يجب أن يكون لدى الشركة مالك نشط واحد على الأقل. رقِّ شخصًا آخر إلى دور المالك أولًا، ثم أزل هذا العضو.",
      "removedInvite": "لم يعد هذا المستخدم عضوًا في الشركة. أرسل له دعوة جديدة ليعود.",
      "generic": "تعذّر تحديث العضو"
    },
    "invite": {
      "title": "دعوة عضو",
      "subtitle": "سيستلم بريدًا إلكترونيًا يحتوي على رابط لإعداد حسابه.",
      "phoneSubtitle": "أنشئ دعوة للحساب وسلّم رمز التفعيل للموظف.",
      "method": "طريقة الدعوة",
      "methods": {
        "email": "البريد الإلكتروني",
        "phone": "الهاتف"
      },
      "email": "البريد الإلكتروني",
      "name": "الاسم الكامل",
      "phone": "الهاتف",
      "role": "الدور",
      "roleSystem": "أدوار نظامية",
      "roleCustom": "أدوار مخصصة",
      "rolePlaceholder": "اختر دورًا",
      "noAssignableRoles": "لا يمكنك تعيين أي دور. اطلب ذلك من المالك أو المسؤول.",
      "employee": "سجل الموظف (اختياري)",
      "employeePlaceholder": "ابحث عن موظف…",
      "employeeHint": "اربط هذا الحساب بسجل موظف ليرى بيانات حضوره وإجازاته ومسيّرات رواتبه.",
      "submit": "إرسال الدعوة",
      "submitting": "جارٍ الإرسال…",
      "success": "تم إرسال الدعوة.",
      "errors": {
        "email": "أدخل بريدًا إلكترونيًا صالحًا",
        "name": "أدخل الاسم الكامل للموظف",
        "phone": "أدخل رقم الهاتف",
        "role": "اختر دورًا للدعوة",
        "generic": "تعذّر إرسال الدعوة"
      }
    },
    "form": {
      "editTitle": "تعديل العضو",
      "editSubtitle": "غيّر الدور أو الحالة، كلًّا على حدة.",
      "roleLabel": "الدور",
      "customRoleFallback": "دور مخصص",
      "roleNotAssignable": "لا يمكنك تغيير دور هذا العضو لأنه يتضمن صلاحيات لا تملكها.",
      "branchLabel": "الفرع",
      "branchHelp": "صلاحيات هذا المستخدم المحدودة بنطاق الفرع تُطبَّق على هذا الفرع.",
      "noBranch": "بدون فرع",
      "statusLabel": "الحالة",
      "noRole": "بدون دور",
      "submit": "حفظ التغيير",
      "submitting": "جارٍ الحفظ…",
      "errors": {
        "oneChange": "غيّر الدور أو الحالة، كلًّا على حدة.",
        "noChange": "لا تغيير للحفظ"
      }
    }
  },
  "groups": {
    "title": "المجموعات",
    "subtitle": "مجموعات الشركات على المنصة وخططها وحالتها.",
    "tally": "{{count}} مجموعة",
    "columns": {
      "group": "المجموعة",
      "status": "الحالة",
      "plan": "الخطة",
      "actions": "إجراءات"
    },
    "status": {
      "active": "نشط",
      "suspended": "موقوفة",
      "pending_purge": "بانتظار التنقية",
      "purged": "تمت تنقيتها"
    },
    "filter": {
      "status": "الحالة",
      "all": "كل الحالات"
    },
    "tabs": {
      "overview": "نظرة عامة",
      "entitlements": "الاستحقاقات",
      "users": "المستخدمون",
      "invitations": "الدعوات",
      "settings": "الإعدادات",
      "defaults": "الإعدادات الافتراضية"
    },
    "noPlan": "بدون خطة",
    "open": "فتح",
    "suspend": "إيقاف",
    "reactivate": "إعادة تفعيل",
    "copyId": "نسخ معرّف المجموعة",
    "changePlan": {
      "none": "بدون خطة (الوحدات فقط)"
    },
    "suspendDialog": {
      "title": "إيقاف {{name}}؟",
      "description": "ستفقد {{name}} الوصول فورًا. يمكن إعادة تفعيلها في أي وقت قبل تنفيذ التنقية.",
      "confirm": "إيقاف المجموعة",
      "success": "تم إيقاف {{name}}."
    },
    "reactivateDialog": {
      "title": "إعادة تفعيل {{name}}؟",
      "description": "ستستعيد {{name}} الوصول فورًا.",
      "confirm": "إعادة تفعيل",
      "success": "تمت إعادة تفعيل {{name}}."
    },
    "atLimit": "لقد بلغت الحد المسموح به في الباقة. غيّر الباقة لإضافة المزيد.",
    "slots": {
      "unlimited": "غير محدود"
    },
    "defaults": {
      "empty": {
        "title": "لا توجد إعدادات افتراضية",
        "body": "ستظهر الإعدادات الافتراضية للمجموعة بعد تحميلها."
      },
      "note": "تُطبَّق الإعدادات الافتراضية على الشركات الجديدة في هذه المجموعة. لا تتغيّر إعدادات الشركات الحالية.",
      "errors": {
        "generic": "تعذّر حفظ الإعدادات الافتراضية للمجموعة."
      },
      "settings": {
        "title": "الإعدادات الافتراضية للمجموعة",
        "cancel": "إلغاء",
        "save": "حفظ التغييرات",
        "saved": "تم حفظ الإعدادات الافتراضية",
        "reset": "إعادة التعيين إلى إعدادات المنصة الافتراضية",
        "resetSaved": "تمت إعادة تعيين الإعدادات الافتراضية",
        "edit": "تعديل الإعدادات الافتراضية",
        "systemDefault": "الافتراضي في المنصة: {{value}}",
        "fields": {
          "paymentTerms": "شروط السداد الافتراضية",
          "allowNegativeStock": "السماح بمخزون سالب",
          "expiryConvention": "متى يُعدّ الصنف منتهي الصلاحية؟",
          "expiryWarningDays": "أيام التحذير من الانتهاء",
          "allocationStrategy": "استراتيجية التخصيص",
          "overReceiptPolicy": "سياسة الاستلام الزائد",
          "permissionMonthlyMinutes": "دقائق الصلاحيات الشهرية",
          "brandingAccentColor": "لون العلامة التجارية"
        },
        "values": {
          "on": "في تاريخ الانتهاء",
          "after": "بعد تاريخ الانتهاء",
          "fefo": "الأقرب انتهاءً، يصرف أولًا (FEFO)",
          "fifo": "الوارد أولًا، يصرف أولًا (FIFO)",
          "block": "منع",
          "allow": "السماح",
          "none": "غير محدد",
          "enabled": "مفعّل",
          "disabled": "غير مفعّل"
        }
      },
      "templates": {
        "add": "إضافة",
        "edit": "تعديل",
        "deleteAction": "حذف",
        "loadSystem": "تحميل الإعدادات الافتراضية للنظام",
        "loaded": "تم تحميل الإعدادات الافتراضية للنظام.",
        "saved": "تم حفظ القالب.",
        "deleted": "تم حذف القالب.",
        "columns": {
          "nameEn": "الاسم (بالإنجليزية)",
          "nameAr": "الاسم (بالعربية)",
          "code": "الرمز",
          "actions": "الإجراءات"
        },
        "form": {
          "createTitle": "إضافة قالب",
          "editTitle": "تعديل القالب",
          "nameEn": "الاسم (بالإنجليزية)",
          "nameAr": "الاسم (بالعربية)",
          "code": "الرمز",
          "nameRequired": "أدخل الاسم باللغتين",
          "codeRequired": "أدخل رمزًا",
          "cancel": "إلغاء",
          "saveCreate": "إضافة القالب",
          "saveEdit": "حفظ التغييرات"
        },
        "delete": {
          "title": "حذف هذا القالب؟",
          "body": "سيتم حذف القالب {{code}}. لا يمكن التراجع عن هذا الإجراء.",
          "cancel": "إلغاء",
          "confirm": "حذف"
        },
        "departments": {
          "title": "قوالب الأقسام",
          "description": "تُنسخ قوالب الأقسام إلى الشركات الجديدة في هذه المجموعة.",
          "emptyTitle": "لا توجد قوالب أقسام بعد",
          "emptyBody": "أضف قالب قسم أو حمّل الإعدادات الافتراضية للنظام."
        },
        "positions": {
          "title": "قوالب المسميات الوظيفية",
          "description": "تُنسخ قوالب المسميات الوظيفية إلى الشركات الجديدة في هذه المجموعة.",
          "emptyTitle": "لا توجد قوالب مسميات وظيفية بعد",
          "emptyBody": "أضف قالب مسمى وظيفي أو حمّل الإعدادات الافتراضية للنظام."
        }
      }
    },
    "addCompany": {
      "action": "إضافة شركة",
      "title": "إضافة شركة إلى {{group}}",
      "subtitle": "تم استخدام {{used}} من أصل {{max}} مقعدًا.",
      "legalNameEn": "الاسم القانوني (بالإنجليزية)",
      "legalNameAr": "الاسم القانوني (بالعربية)",
      "tradingNameEn": "الاسم التجاري (بالإنجليزية)",
      "tradingNameAr": "الاسم التجاري (بالعربية)",
      "code": "الرمز",
      "currency": "العملة الأساسية",
      "currencyPlaceholder": "اختر عملة",
      "country": "الدولة",
      "countryPlaceholder": "اختر دولة",
      "noUsers": "لا يوجد مستخدمون لهذا العميل بعد.",
      "owners": "المالكون",
      "ownerElsewhere": "مالك لـ {{n}} شركات",
      "noOwners": "لن يكون لهذه الشركة مالك حتى تضيف واحدًا.",
      "submitFailed": "تعذّرت إضافة الشركة.",
      "otherErrors": "مشكلات أخرى في هذا الطلب:",
      "submit": "إضافة شركة",
      "timezone": "المنطقة الزمنية"
    },
    "empty": {
      "title": "لا توجد مجموعات بعد",
      "body": "ستظهر المجموعات هنا بمجرد تسجيل منظمة عميل.",
      "filteredTitle": "لا توجد مجموعات تطابق هذا الفلتر",
      "filteredBody": "جرّب حالة مختلفة.",
      "searchBody": "جرّب اسمًا آخر، أو أزل عوامل التصفية."
    },
    "search": {
      "label": "ابحث في المجموعات",
      "placeholder": "ابحث بالاسم…"
    },
    "detail": {
      "subtitle": "مجموعة واحدة: الشركات والخطة ودعم الوصول.",
      "notFound": "هذه المجموعة غير موجودة أو غير مرئية لك.",
      "companies": {
        "title_zero": "لا شركات",
        "title_one": "شركة واحدة",
        "title_two": "شركتان",
        "title_few": "{{count}} شركات",
        "title_many": "{{count}} شركة",
        "title_other": "{{count}} شركة",
        "emptyTitle": "لا توجد شركات بعد",
        "emptyBody": "أضف أول شركة للمجموعة من قائمة المجموعات."
      },
      "plan": {
        "title": "الخطة والاستحقاقات",
        "slotsLine_zero": "لا مقاعد شركات مستخدمة من {{limit}}",
        "slotsLine_one": "مقعد واحد مستخدم من {{limit}} لمقاعد الشركات",
        "slotsLine_two": "مقعدان مستخدمان من {{limit}} لمقاعد الشركات",
        "slotsLine_few": "{{count}} مقاعد مستخدمة من {{limit}} لمقاعد الشركات",
        "slotsLine_many": "{{count}} مقعدًا مستخدمًا من {{limit}} لمقاعد الشركات",
        "slotsLine_other": "{{count}} مقعد مستخدم من {{limit}} لمقاعد الشركات"
      },
      "modules": {
        "title": "الوحدات",
        "empty": "لا تمنح خطة هذه المجموعة أي وحدات.",
        "clear": "إلغاء التجاوز الخاص بـ {{module}}",
        "clearDialog": {
          "title": "إلغاء التجاوز الخاص بـ {{module}}؟",
          "description": "ستعود {{module}} إلى ما تمنحه الخطة. قد يُعطّل هذا وحدة يستخدمها عميل حاليًا.",
          "confirm": "إلغاء التجاوز",
          "success": "تم إلغاء التجاوز الخاص بـ {{module}}."
        }
      },
      "features": {
        "title": "الميزات",
        "empty": "لا تعلن خطة هذه المجموعة أي ميزات.",
        "clear": "إلغاء التجاوز الخاص بـ {{feature}}",
        "clearDialog": {
          "title": "إلغاء التجاوز الخاص بـ {{feature}}؟",
          "description": "ستعود {{feature}} إلى ما تمنحه الخطة.",
          "confirm": "إلغاء التجاوز",
          "success": "تم إلغاء التجاوز الخاص بـ {{feature}}."
        }
      },
      "limits": {
        "title": "الحدود",
        "empty": "لا تعلن خطة هذه المجموعة أي حدود.",
        "columns": {
          "key": "المفتاح",
          "value": "القيمة",
          "source": "المصدر"
        }
      },
      "entitlementsSource": {
        "plan": "من الخطة",
        "override": "تجاوز"
      },
      "overview": {
        "groupId": "معرّف المجموعة",
        "slug": "المعرّف النصي",
        "created": "تاريخ الإنشاء",
        "plan": "الخطة",
        "modulesOnly": "الوحدات فقط",
        "currency": "عملة العرض",
        "modules": "الوحدات المفعّلة",
        "noModules": "لا توجد وحدات مفعّلة."
      },
      "purge": {
        "action": "جدولة التنقية",
        "dialog": {
          "title": "جدولة تنقية {{name}}؟",
          "description": "يجدول هذا حذف المجموعة بعد انتهاء مهلة التنقية. اكتب المعرّف النصي للمجموعة للتأكيد.",
          "slugLabel": "المعرّف النصي للمجموعة",
          "slugPlaceholder": "اكتب {{slug}} للتأكيد",
          "confirm": "جدولة التنقية",
          "success": "تمت جدولة تنقية {{name}}."
        }
      },
      "sessions": {
        "title": "جلسات الدعم لهذه المجموعة",
        "emptyTitle": "لا جلسات دعم هنا بعد",
        "emptyBody": "ستظهر هنا الجلسات المفتوحة لهذه المجموعة، النشطة منها والسابقة."
      },
      "erasure": {
        "title": "محو البيانات",
        "description": "التشغيل التجريبي يحصي ما سيمحوه المحو لهذه المجموعة المنقّاة: الصفوف في كل جدول والملفات المخزنة والمستخدمين. لا يمحو شيئًا.",
        "dryRun": "تشغيل تجريبي",
        "dryRunAgain": "إعادة التشغيل التجريبي",
        "dryRunDone": "انتهى التشغيل التجريبي. لم يُمحَ شيء.",
        "plannedAt": "آخر تشغيل تجريبي: {{date}}",
        "noPlan": "لا يوجد تشغيل تجريبي بعد. شغّل واحدًا لترى ما سيمحوه المحو.",
        "noBlockers": "لا توجد موانع",
        "blockersTitle": "المحو ممنوع",
        "blockers": {
          "cross_group_link": "صف من مجموعة أخرى يشير إلى بيانات هذه المجموعة:",
          "demo_group": "هذه مجموعة العرض التجريبي؛ إعادة ضبط العرض هي التي تدير بياناتها:",
          "open_support_session": "جلسات دعم مفتوحة على هذه المجموعة:"
        },
        "auditTitle": "سجل التدقيق",
        "auditBody": "يُحتفظ بـ {{kept}} صف أمني مع مسح القيم القديمة والجديدة؛ ويُمحى {{deleted}} صف مالي. هذا وفق قاعدة الاحتفاظ لدينا وينتظر رأي المستشار القانوني.",
        "taxTitle": "السجلات الضريبية",
        "taxBody": "يحتفظ العميل بدفاتره الخاصة لمصلحة الضرائب. تأكد أنه صدّر بياناته قبل المحو. هذا ينتظر رأي المستشار القانوني.",
        "totals": {
          "rows": "الصفوف",
          "tables": "الجداول",
          "files": "الملفات",
          "users": "المستخدمون"
        },
        "columns": {
          "table": "الجدول",
          "rows": "الصفوف",
          "folder": "المجلد",
          "files": "الملفات",
          "size": "الحجم"
        },
        "bytes_zero": "{{value}} بايت",
        "bytes_one": "{{value}} بايت",
        "bytes_two": "{{value}} بايت",
        "bytes_few": "{{value}} بايت",
        "bytes_many": "{{value}} بايت",
        "bytes_other": "{{value}} بايت"
      }
    },
    "settings": {
      "title": "إعدادات المجموعة",
      "view": {
        "edit": "تعديل الإعدادات"
      },
      "fields": {
        "presentationCurrency": "عملة العرض",
        "currencyPlaceholder": "اختر عملة",
        "intercompanyMirroring": "مزامنة المعاملات بين الشركات",
        "retentionDays": "أيام الاحتفاظ",
        "purgeGraceDays": "أيام مهلة التنقية"
      },
      "platformDefault": "الإعداد الافتراضي للمنصة",
      "values": {
        "enabled": "مفعّل",
        "disabled": "غير مفعّل"
      },
      "form": {
        "cancel": "إلغاء",
        "save": "حفظ التغييرات",
        "saved": "تم حفظ إعدادات المجموعة"
      }
    },
    "users": {
      "title": "مستخدمو هذه المجموعة",
      "emptyTitle": "لا يوجد مستخدمون بعد",
      "emptyBody": "لا يوجد مستخدمون في هذه المجموعة.",
      "columns": {
        "name": "الاسم",
        "email": "البريد أو الهاتف",
        "companies": "الشركات",
        "owner": "مالك الشركة",
        "twoFactor": "التحقق بخطوتين",
        "actions": "الإجراءات"
      },
      "owner": "مالك",
      "twoFactor": {
        "on": "مفعّل",
        "reset": "إعادة ضبط التحقق بخطوتين",
        "resetFor": "إعادة ضبط التحقق بخطوتين لـ {{name}}",
        "hint": "افتح جلسة دعم لهذه المجموعة لتعيد ضبط التحقق بخطوتين لأحد المستخدمين.",
        "dialogTitle": "إعادة ضبط التحقق بخطوتين؟",
        "dialogBody": "يُسجَّل خروج {{name}} من كل الأجهزة، وعليه تفعيل التحقق بخطوتين مرة أخرى عند تسجيل الدخول القادم. يصله بريد بذلك، وتُسجَّل إعادة الضبط في سجل التدقيق.",
        "reason": "السبب",
        "reasonPlaceholder": "مثلاً: فقدان الهاتف، التذكرة 77",
        "confirm": "إعادة الضبط",
        "noSession": "انتهت جلسة الدعم لهذه المجموعة. افتح جلسة جديدة ثم حاول مرة أخرى.",
        "failed": "لم تتم إعادة الضبط. حاول مرة أخرى.",
        "done": "تمت إعادة ضبط التحقق بخطوتين لـ {{name}}."
      }
    },
    "invitations": {
      "title": "الدعوات المعلّقة",
      "emptyTitle": "لا توجد دعوات معلّقة",
      "emptyBody": "لا توجد دعوات معلّقة في هذه المجموعة.",
      "columns": {
        "email": "البريد أو الهاتف",
        "company": "الشركة",
        "role": "الدور",
        "status": "الحالة",
        "expires": "تنتهي",
        "actions": "إجراءات"
      },
      "resend": "إعادة الإرسال",
      "revoke": "إلغاء",
      "status": {
        "pending": "معلّقة",
        "expired": "منتهية",
        "accepted": "مقبولة",
        "revoked": "ملغاة"
      },
      "revokeDialog": {
        "title": "إلغاء الدعوة الموجهة إلى {{email}}؟",
        "description": "لن يتمكن {{email}} بعد الآن من قبول هذه الدعوة. يمكن إرسال دعوة جديدة لاحقًا.",
        "confirm": "إلغاء الدعوة"
      },
      "resendSuccess": "تمت إعادة إرسال الدعوة إلى {{email}}.",
      "revokeSuccess": "تم إلغاء دعوة {{email}}."
    }
  },
  "state": {
    "loading": "جارٍ التحميل…",
    "empty": "لا يوجد ما يُعرض",
    "error": "حدث خطأ ما",
    "inactive": "غير نشط",
    "saved": "تم الحفظ",
    "saving": "جارٍ الحفظ…"
  },
  "status": {
    "active": "نشط",
    "inactive": "غير نشط"
  },
  "none": "لا شيء",
  "onboarding": {
    "title": "تسجيل عميل جديد",
    "subtitle": "أنشئ مجموعة، واختر وحداتها، وأضف شركاتها، وادعُ المالك الأول.",
    "steps": {
      "customer": "العميل",
      "modules": "الوحدات",
      "defaults": "الإعدادات الافتراضية",
      "companies": "الشركات",
      "owner": "المالك الأول",
      "completed": "✓ "
    },
    "defaults": {
      "subtitle": "حدّد الإعدادات الافتراضية لشركات هذه المجموعة. يمكنك تغييرها لاحقًا.",
      "optional": "جميع الحقول في هذه الخطوة اختيارية.",
      "skip": "تخطّي الإعدادات الافتراضية",
      "sections": {
        "settings": "الإعدادات",
        "departments": "قوالب الأقسام",
        "positions": "قوالب المسميات الوظيفية"
      },
      "placeholders": {
        "choose": "اختر خيارًا"
      },
      "fields": {
        "paymentTermsDays": "شروط السداد الافتراضية (بالأيام)",
        "expiryWarningDays": "أيام التحذير من الانتهاء",
        "permissionMonthlyMinutes": "دقائق الصلاحيات الشهرية",
        "expiryConvention": "متى يُعدّ الصنف منتهي الصلاحية؟",
        "allocationStrategy": "استراتيجية التخصيص",
        "overReceiptPolicy": "سياسة الاستلام الزائد",
        "brandingAccentColor": "لون العلامة التجارية",
        "allowNegativeStock": "السماح بمخزون سالب"
      },
      "helpButton": "مزيد من المعلومات عن {{field}}",
      "help": {
        "paymentTermsDays": "يحدد عدد الأيام الافتراضي المسموح به لسداد الفواتير.",
        "expiryWarningDays": "يحدد عدد الأيام قبل الانتهاء التي ينبه فيها النظام المستخدمين.",
        "permissionMonthlyMinutes": "يحدد الحد الشهري لطلبات الاستئذان بالدقائق.",
        "expiryConvention": "اختر ما إذا كان الصنف يُعدّ منتهي الصلاحية في التاريخ الظاهر أو في اليوم التالي.",
        "allocationStrategy": "يحدد طريقة تخصيص المخزون: الأقرب انتهاءً أولًا أو الأقدم استلامًا أولًا.",
        "overReceiptPolicy": "يحدد ما إذا كان استلام كمية أكبر من المطلوبة ممنوعًا أو مسموحًا.",
        "brandingAccentColor": "يحدد اللون المميز المستخدم في هوية هذه الشركة.",
        "allowNegativeStock": "يحدد ما إذا كان يمكن أن ينخفض المخزون إلى أقل من الصفر."
      },
      "options": {
        "on": "في تاريخ الانتهاء",
        "after": "بعد تاريخ الانتهاء",
        "fefo": "الأقرب انتهاءً، يصرف أولًا (FEFO)",
        "fifo": "الوارد أولًا، يصرف أولًا (FIFO)",
        "block": "منع",
        "allow": "السماح"
      },
      "templates": {
        "nameEn": "الاسم (بالإنجليزية)",
        "nameAr": "الاسم (بالعربية)",
        "code": "الرمز",
        "departments": {
          "hint": "تُستخدم عند إعداد شركة جديدة.",
          "add": "إضافة قسم",
          "empty": "لم تتم إضافة قوالب أقسام.",
          "remove": "إزالة قالب القسم"
        },
        "positions": {
          "hint": "تُستخدم عند إعداد شركة جديدة.",
          "add": "إضافة مسمى وظيفي",
          "empty": "لم تتم إضافة قوالب مسميات وظيفية.",
          "remove": "إزالة قالب المسمى الوظيفي"
        }
      }
    },
    "slots": "المقاعد",
    "optional": "اختياري",
    "nameHint": "أدخل اسمًا واحدًا على الأقل، بالإنجليزية أو العربية.",
    "submit": "إنشاء العميل",
    "submitting": "جارٍ الإنشاء…",
    "submitFailed": "تعذّر إنشاء العميل.",
    "submitErrorTitle": "تعذّر إنشاء هذا العميل",
    "submitValidationFailed": "تحتاج بعض البيانات إلى مراجعتك قبل إنشاء العميل.",
    "submitValidationHint": "صحح الأخطاء الظاهرة في هذه الخطوة وحاول مرة أخرى.",
    "submitUnexpectedFailed": "تعذّر إعداد هذا العميل. ما زالت بياناتك التي أدخلتها محفوظة؛ حاول مرة أخرى.",
    "submitReference": "المرجع: {{reference}}",
    "leaveWarning": "لن تُحفظ إدخالاتك حتى تنشئ العميل.",
    "validation": {
      "name": "أدخل اسم العميل بإحدى اللغتين على الأقل.",
      "plan": "اختر باقة.",
      "companyName": "أدخل الاسم القانوني بإحدى اللغتين على الأقل.",
      "code": "أدخل رمز الشركة.",
      "country": "اختر دولة.",
      "currency": "اختر العملة الأساسية.",
      "duplicateCode": "يجب أن يكون رمز كل شركة فريدًا.",
      "ownerName": "أدخل اسم المالك الأول.",
      "ownerEmail": "أدخل بريدًا إلكترونيًا صالحًا للمالك الأول."
    },
    "customer": {
      "nameEn": "اسم العميل (بالإنجليزية)",
      "nameAr": "اسم العميل (بالعربية)",
      "slug": "الرابط: {{slug}}",
      "plan": "الباقة",
      "planLoadFailed": "تعذّر تحميل الباقات.",
      "planPlaceholder": "اختر باقة",
      "planLimits": "{{companies}} شركات، {{users}} مستخدمين",
      "slotsHint": "تسمح هذه الباقة بـ{{max}} شركات. يمكنك إضافة الباقي لاحقًا.",
      "noPlan": "بدون باقة (وحدات فقط)",
      "noPlanHint": "تُحدَّد الوحدات والحدود مباشرة على هذا العميل.",
      "limitsCompanies": "حد الشركات",
      "limitsUsers": "حد المستخدمين",
      "limitsStorage": "التخزين (ميجابايت)",
      "advanced": "إعدادات متقدمة",
      "purgeGraceDays": "أيام مهلة التنقية",
      "defaultGrace": "استخدم القيمة الافتراضية للمنصة"
    },
    "modules": {
      "intro": "اختر الوحدات التي تتضمنها باقة هذا العميل. يمكنك تغيير ذلك لاحقًا.",
      "loadFailed": "تعذّر تحميل كتالوج الوحدات.",
      "none": "لم تُرجع قائمة الوحدات أي مفاتيح تبديل.",
      "fromPlan": "مضمّنة في الباقة",
      "requiredBy": "مطلوبة بواسطة المخزون",
      "desc": {
        "hr": "إدارة الأفراد والحضور والإجازات.",
        "accounting": "إدارة الحسابات والمعاملات والتقارير المالية.",
        "inventory": "إدارة المنتجات والمخزون وحركات المستودعات."
      }
    },
    "companies": {
      "slots": "تم استخدام {{used}} من أصل {{max}} مقعدًا",
      "holding": "الشركة الأم",
      "company": "الشركة {{count}}",
      "remove": "إزالة الشركة",
      "legalNameEn": "الاسم القانوني (بالإنجليزية)",
      "legalNameAr": "الاسم القانوني (بالعربية)",
      "tradingName": "الاسم التجاري",
      "tradingNameEn": "الاسم التجاري (بالإنجليزية)",
      "tradingNameAr": "الاسم التجاري (بالعربية)",
      "code": "الرمز",
      "currency": "العملة الأساسية",
      "currencyPlaceholder": "اختر عملة",
      "atLimit": "تسمح هذه الباقة بـ{{max}} شركات. اختر باقة أكبر لإضافة المزيد.",
      "add": "إضافة شركة",
      "country": "الدولة",
      "countryPlaceholder": "اختر الدولة",
      "timezone": "المنطقة الزمنية"
    },
    "countries": {
      "EG": "مصر",
      "SA": "السعودية",
      "AE": "الإمارات العربية المتحدة",
      "KW": "الكويت",
      "BH": "البحرين",
      "OM": "عُمان",
      "QA": "قطر",
      "JO": "الأردن"
    },
    "owner": {
      "name": "اسم المالك",
      "email": "بريد المالك الإلكتروني",
      "roleNote": "سيكون مالك الشركة لجميع الشركات وعددها {{count}}.",
      "emailNote": "سنرسل إلى {{email}} دعوةً لإعداد كلمة المرور الخاصة به. لن تراها ولن تعيّنها."
    },
    "done": {
      "title": "{{name}} جاهزة",
      "invited": "أُرسلت دعوة إلى {{email}}. تنتهي صلاحيتها في {{date}}.",
      "groupCreated": "تم إنشاء المجموعة {{name}} مع شركاتها ودعوة مالكها.",
      "slots": "تم استخدام {{used}} من أصل {{max}} مقعدًا",
      "next": {
        "1": "يقبل المالك الدعوة ويعيّن كلمة مرور.",
        "2": "يسجّل المالك الدخول إلى تطبيق الشركة.",
        "3": "يضيف المالك مستخدميه وأدواره."
      },
      "backToGroups": "العودة إلى المجموعات",
      "allGroups": "كل المجموعات",
      "another": "تسجيل عميل آخر",
      "companies": "{{count}} شركات"
    }
  },
  "mcpConnect": {
    "trail": "التطبيقات المتصلة",
    "title": "السماح بالوصول",
    "asks": "يطلب {{client}} العمل في ملتقى باسمك.",
    "returnsTo": "يذهب الوصول إلى:",
    "canList": "يمكنه عرض مجموعات العملاء وشركاتها.",
    "needsSession": "لقراءة بيانات عميل أو تغييرها، يجب أن يفتح جلسة دعم، وتُدخل رمز مصادقة جديدًا في كل مرة.",
    "confirmWrites": "كل تغيير يقترحه ينتظر تأكيدك.",
    "revokeLater": "يمكنك إزالة هذا الوصول لاحقًا من إعداداتك.",
    "allow": "سماح",
    "deny": "رفض",
    "approveFailed": "تعذّر منح الوصول. ابدأ من جديد من تطبيقك.",
    "invalidTitle": "طلب الاتصال هذا غير صالح",
    "invalidBody": "التطبيق غير مسجّل في ملتقى، أو عنوان العودة لا يطابق. ابدأ من جديد من تطبيقك."
  },
  "supportSessions": {
    "title": "دعم الوصول",
    "subtitle": "وصول محدود المدة إلى مجموعة عميل. كل جلسة مسجلة ومرئية للشركة.",
    "groupLabel": "المجموعة",
    "groupPlaceholder": "اختر مجموعة",
    "overview": {
      "title": "عبر كل المجموعات",
      "meta": "الجلسات النشطة، وتلك التي انتهت خلال آخر 24 ساعة",
      "columns": {
        "group": "المجموعة"
      },
      "emptyTitle": "لا توجد جلسات دعم مفتوحة في أي مجموعة",
      "emptyBody": "لا شيء مفتوح أو منتهٍ حديثًا عبر كل المجموعات. امنح واحدة أدناه لكل مجموعة.",
      "errorTitle": "تعذر تحميل النظرة العامة",
      "error": "تعذر قراءة جلسات الدعم."
    },
    "grant": {
      "heading": "منح وصول الدعم",
      "reason": "السبب",
      "reasonPlaceholder": "ماذا تحتاج هذه الجلسة لإنجازه؟",
      "minutes": "الدقائق",
      "minutesPlaceholder": "60",
      "minutesHint": "اختياري. الافتراضي 60 دقيقة والحد الأقصى 240.",
      "submit": "منح الوصول",
      "code": "رمز المصادقة",
      "codePlaceholder": "123456",
      "codeHint": "الرمز الحالي المكوّن من 6 أرقام من تطبيق المصادقة."
    },
    "errors": {
      "reasonRequired": "السبب مطلوب",
      "minutesInvalid": "أدخل رقمًا صحيحًا بين 1 و240",
      "codeRequired": "أدخل رمز المصادقة الحالي",
      "handoffFailed": "تعذّر فتح رابط الدعم. تحقق من أن الجلسة ما زالت نشطة."
    },
    "sessions": {
      "heading": "الجلسات",
      "columns": {
        "granted": "مُنحت",
        "expires": "تنتهي",
        "reason": "السبب",
        "status": "الحالة",
        "actions": "إجراءات",
        "agent": "موظف الدعم"
      },
      "active": "نشطة",
      "revoked": "ملغاة",
      "expired": "منتهية",
      "revoke": "إلغاء",
      "emptyTitle": "لا توجد جلسات بعد",
      "emptyBody": "ستظهر الجلسات المفتوحة على هذه المجموعة هنا.",
      "errorTitle": "تعذر تحميل الجلسات",
      "errorBody": "تعذر تحميل الجلسات الممنوحة لهذه المجموعة.",
      "viewActions": "عرض الإجراءات",
      "end": "إنهاء الجلسة",
      "openAsSupport": "الدخول كدعم",
      "viaAssistant": "عبر مساعد ملتقى",
      "assistantHelp": "يستخدم مساعد ملتقى الذكاء الاصطناعي. يقرأ بياناتك ويقترح التغييرات، ويوافق موظف الدعم على كل تغيير قبل تنفيذه."
    },
    "companyView": {
      "title": "جلسات الدعم",
      "subtitle": "جلسات دعم المنصة المفتوحة على مجموعتك. كل جلسة مسجلة ومرئية هنا.",
      "errorTitle": "تعذّر تحميل جلسات الدعم.",
      "emptyTitle": "لا توجد جلسات دعم",
      "emptyBody": "ستظهر الجلسات التي يفتحها دعم المنصة على هذه المجموعة هنا."
    },
    "banner": {
      "title": "جلسة دعم",
      "body": "يعمل {{name}} من دعم ملتقى في شركتك حتى {{time}}. يُسجَّل كل إجراء.",
      "end": "إنهاء الآن"
    },
    "enter": {
      "headline": "وصول الدعم",
      "eyebrow": "دعم ملتقى",
      "title": "جارٍ فتح جلسة الدعم",
      "lede": "لحظة واحدة. تُسجَّل دخولك بمستخدم الدعم الخاص بك.",
      "failedTitle": "رابط الدعم هذا لا يعمل",
      "failedBody": "الرابط مستخدم أو منتهي الصلاحية، أو انتهت جلسته. افتح رابطاً جديداً من تطبيق الإدارة."
    },
    "ended": {
      "headline": "وصول الدعم",
      "title": "انتهت جلسة الدعم",
      "lede": "خرجت من هذه الشركة. يرى مالكوها كل ما فعلته الجلسة في سجل التدقيق.",
      "close": "إغلاق علامة التبويب"
    }
  },
  "errors": {
    "fileAction": "تعذّر إنشاء الملف. حاول مرة أخرى، أو تواصل مع الدعم إذا تكرر ذلك."
  },
  "error": {
    "generic": {
      "title": "حدث خطأ ما",
      "body": "هذا خطؤنا وليس خطأك. اذكر الرقم المرجعي أدناه وسنتمكن من العثور على ما حدث بدقة."
    },
    "asyncTitle": "تعذّر تحميل هذا القسم",
    "asyncBody": "تعذّر تحميل {{title}}. يرجى المحاولة مرة أخرى.",
    "network": {
      "title": "مشكلة في الاتصال",
      "body": "تعذّر الاتصال. تحقّق من اتصالك وحاول مرة أخرى."
    },
    "unauthorized": {
      "title": "انتهت صلاحية جلستك",
      "body": "سجّل الدخول مرة أخرى للمتابعة. لم تفقد أيًا من البيانات التي حفظتها."
    },
    "suspended": {
      "title": "حسابك موقوف",
      "body": "تم تعليق الوصول إلى مؤسسة الشركة. تواصل مع مسؤول النظام."
    },
    "forbidden": {
      "title": "لا تملك صلاحية الوصول إلى هذا",
      "body": "لا يتضمن دورك هذه الشاشة. إذا كنت تعتقد أنه ينبغي أن تتضمنها صلاحياتك، فاسأل مسؤول النظام."
    },
    "openSupport": "فتح جلسة دعم",
    "notFound": {
      "title": "غير موجود",
      "body": "هذا السجل غير موجود، أو أنه يتبع شركة أخرى.",
      "goToDashboard": "الانتقال إلى لوحة التحكم",
      "pageTitle": "هذه الصفحة غير موجودة",
      "pageBody": "تحقّق من العنوان، أو عُد إلى لوحة التحكم."
    },
    "conflict": {
      "title": "تعذّر حفظ ذلك"
    },
    "validation": "يرجى مراجعة الحقول المميزة.",
    "boundary": {
      "notFound": "تعذّر تحميل {{path}}. ربما حُذفت الصفحة، أو أنها تتبع شركة أخرى.",
      "forbidden": "تم رفض الوصول إلى {{path}}. دورك لا يشمل هذه الصفحة."
    },
    "rateLimited": {
      "title": "محاولات كثيرة جدًا",
      "body": "انتظر دقيقة وحاول مرة أخرى."
    },
    "reference": "الرقم المرجعي",
    "referenceHint": "أرفق هذا الرقم عند التواصل مع الدعم.",
    "details": "التفاصيل التقنية",
    "moduleNotEnabled": "هذه الوحدة غير مُفعَّلة."
  },
  "feature": {
    "names": {
      "remove_branding": "إزالة علامة Multaqa"
    }
  },
  "module": {
    "names": {
      "hr": "الموارد البشرية",
      "accounting": "المحاسبة",
      "inventory": "المخزون",
      "purchasing": "المشتريات",
      "sales": "المبيعات",
      "subscriptions": "الاشتراكات"
    },
    "notEnabled": {
      "title": "غير مُتضمَّنة في باقتك",
      "body": "وحدة {{module}} غير مُتضمَّنة في باقتك الحالية. تواصل مع مسؤول النظام لتفعيلها."
    }
  },
  "directory": {
    "entityKinds": {
      "customer": "عميل",
      "supplier": "مورد",
      "employee": "موظف"
    }
  },
  "accounting": {
    "payee": {
      "placeholder": "اختر المدفوع له",
      "search": "ابحث عن العملاء أو الموردين أو الموظفين…",
      "empty": "لا يوجد مدفوع له مطابق"
    }
  },
  "recordHistory": {
    "trigger": "السجل",
    "title": "سجل التغييرات",
    "description": "التغييرات التي أُجريت على هذا السجل.",
    "empty": "لا توجد تغييرات مسجلة بعد.",
    "noValue": "لا توجد قيمة",
    "view": "عرض",
    "openInAudit": "فتح في سجل التدقيق",
    "event": "{{action}}"
  },
  "platformConsole": {
    "title": "وحدة تحكم المنصة",
    "subtitle": "جانبنا من المنتج.",
    "signedInAs": "تم تسجيل الدخول باسم {{name}}. المشغلون ليس لديهم سياق شركة.",
    "customers": {
      "title": "العملاء",
      "meta": "المجموعات والشركات",
      "body": "أدر مجموعات العملاء والخطط وسعة الشركات من وحدة تحكم المنصة.",
      "open": "فتح المجموعات"
    },
    "operations": {
      "title": "العمليات",
      "meta": "الدعم والتدقيق والصحة",
      "body": "افتح جلسة دعم مسجلة أو راجع سجل تدقيق المنصة.",
      "support": "جلسات الدعم",
      "audit": "سجل المنصة",
      "auditNeedsSession": "يتطلب جلسة دعم نشطة — افتح واحدة من جلسات الدعم."
    },
    "stats": {
      "groups": "المجموعات",
      "groupsNote": "{{active}} نشطة، {{suspended}} موقوفة",
      "companies": "الشركات",
      "companiesNote": "عبر جميع المجموعات",
      "atLimit": "عند حد الخطة",
      "atLimitNote": "من {{count}} بحد معروف",
      "openSessions": "جلسات الدعم المفتوحة",
      "openSessionsNote": "ممنوحة ولم تنتهِ بعد أو تُلغَ"
    },
    "activity": {
      "title": "النشاط الأخير",
      "meta": "الملاحظات والدعم",
      "feedbackTitle": "الملاحظات الأخيرة",
      "feedbackError": "تعذّر تحميل الملاحظات الأخيرة.",
      "feedbackEmpty": "لا توجد ملاحظات بعد.",
      "supportTitle": "الدعم المفتوح",
      "supportCount_zero": "لا توجد جلسات دعم مفتوحة",
      "supportCount_one": "جلسة دعم واحدة مفتوحة",
      "supportCount_two": "جلستا دعم مفتوحتان",
      "supportCount_few": "{{count}} جلسات دعم مفتوحة",
      "supportCount_many": "{{count}} جلسة دعم مفتوحة",
      "supportCount_other": "{{count}} جلسة دعم مفتوحة",
      "supportError": "تعذّر تحميل جلسات الدعم المفتوحة.",
      "supportEmpty": "لا توجد جلسات دعم مفتوحة.",
      "viewAll": "عرض الكل"
    },
    "quickActions": {
      "title": "إجراءات سريعة",
      "provisionTenant": "تسجيل عميل جديد",
      "managePlans": "إدارة الخطط",
      "grantSupport": "منح وصول الدعم"
    },
    "recentGroups": {
      "title": "المجموعات الأخيرة",
      "meta": "أحدث مجموعات العملاء",
      "error": "تعذّر تحميل المجموعات الأخيرة.",
      "emptyTitle": "لا توجد مجموعات بعد",
      "provision": "تسجيل عميل جديد",
      "viewAll": "عرض كل المجموعات",
      "columns": {
        "name": "المجموعة",
        "plan": "الخطة",
        "companies": "الشركات",
        "status": "الحالة",
        "created": "تاريخ الإنشاء"
      }
    }
  },
  "plans": {
    "title": "الخطط والاستحقاقات",
    "subtitle": "كتالوج الخطط، وما تحوزه كل مجموعة فعليًا.",
    "catalogue": {
      "heading": "كتالوج الخطط",
      "newPlan": "خطة جديدة",
      "columns": {
        "name": "الخطة",
        "status": "الحالة",
        "entitlements": "الاستحقاقات",
        "actions": "إجراءات"
      },
      "active": "نشطة",
      "inactive": "غير نشطة",
      "entitlementCount_zero": "لا توجد استحقاقات",
      "entitlementCount_one": "استحقاق واحد",
      "entitlementCount_two": "استحقاقان",
      "entitlementCount_few": "{{count}} استحقاقات",
      "entitlementCount_many": "{{count}} استحقاقًا",
      "entitlementCount_other": "{{count}} استحقاقات",
      "edit": "تعديل الخطة",
      "deactivate": "إلغاء التفعيل",
      "delete": "حذف",
      "emptyTitle": "لا توجد خطط بعد",
      "emptyBody": "أنشئ الخطة الأولى لبدء تعيين العملاء."
    },
    "form": {
      "createTitle": "خطة جديدة",
      "editTitle": "تعديل الخطة",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "active": "نشطة",
      "identity": "تفاصيل الخطة",
      "entitlements": {
        "title": "الاستحقاقات",
        "description": "حدّد الحدود والوحدات المضمّنة في هذه الخطة.",
        "loadFailed": "تعذّر تحميل كتالوج الاستحقاقات.",
        "empty": "لا توجد استحقاقات متاحة.",
        "valueLabel": "قيمة {{key}}",
        "clearValue": "مسح قيمة {{key}}",
        "kind": {
          "switch": "مفتاح تبديل",
          "limit": "حد"
        },
        "columns": {
          "key": "المفتاح",
          "kind": "النوع",
          "value": "القيمة",
          "actions": "الإجراءات"
        }
      },
      "impactConfirm": {
        "title_zero": "لا توجد مجموعات تستخدم هذه الخطة",
        "title_one": "تستخدم مجموعة واحدة هذه الخطة",
        "title_two": "تستخدم مجموعتان هذه الخطة",
        "title_few": "تستخدم {{count}} مجموعات هذه الخطة",
        "title_many": "تستخدم {{count}} مجموعة هذه الخطة",
        "title_other": "تستخدم {{count}} مجموعة هذه الخطة",
        "overridesUnaffected": "لن تتغيّر التجاوزات الخاصة بالمجموعات.",
        "save": "حفظ الخطة"
      },
      "submitCreate": "إنشاء الخطة",
      "submitEdit": "حفظ التغييرات",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "createFailed": "تعذّر إنشاء الخطة",
      "updateFailed": "تعذّر حفظ الخطة"
    },
    "deleteDialog": {
      "title": "حذف هذه الخطة؟",
      "description": "ستُزال {{name}} من الكتالوج. المجموعات الموجودة عليها تحتفظ بوصولها الحالي.",
      "confirm": "حذف الخطة",
      "inUse": "هذه الخطة معيّنة لمجموعة واحدة أو أكثر ولا يمكن حذفها. ألغِ تفعيلها بدلًا من ذلك."
    },
    "groupContext": {
      "heading": "سياق المجموعة",
      "groupLabel": "المجموعة",
      "groupPlaceholder": "اختر مجموعة",
      "noGroup": "اختر مجموعة لرؤية استحقاقاتها الفعلية.",
      "currentPlan": "الخطة الحالية",
      "changePlan": "تغيير الخطة",
      "columns": {
        "key": "الاستحقاق",
        "module": "الوحدة",
        "planValue": "قيمة الخطة",
        "override": "تجاوز",
        "effective": "الفعلي"
      },
      "noValue": "—",
      "changePlanDialog": {
        "title": "تغيير خطة {{name}}",
        "planLabel": "الخطة الجديدة",
        "planPlaceholder": "اختر خطة",
        "confirm": "تغيير الخطة",
        "warnTitle": "هذا التغيير يعطّل وحدة",
        "warnBody_zero": "لن تُعطّل أي وحدة من الوحدات {{modules}}. تبقى جميع بياناتها محفوظة ومتاحة إذا أُعيد تفعيلها لاحقًا.",
        "warnBody_one": "ستُعطَّل {{module}}. تبقى جميع بياناتها محفوظة ومتاحة إذا أُعيد تفعيل الوحدة لاحقًا.",
        "warnBody_two": "ستُعطَّل الوحدتان {{modules}}. تبقى جميع بياناتهما محفوظة ومتاحة إذا أُعيد تفعيلهما لاحقًا.",
        "warnBody_few": "ستُعطَّل الوحدات {{modules}}. تبقى جميع بياناتها محفوظة ومتاحة إذا أُعيد تفعيلها لاحقًا.",
        "warnBody_many": "ستُعطَّل الوحدات {{modules}}. تبقى جميع بياناتها محفوظة ومتاحة إذا أُعيد تفعيلها لاحقًا.",
        "warnBody_other": "ستُعطَّل الوحدات {{modules}}. تبقى جميع بياناتها محفوظة ومتاحة إذا أُعيد تفعيل الوحدات لاحقًا."
      }
    }
  },
  "platformSettings": {
    "title": "إعدادات المنصة",
    "subtitle": "القيم الافتراضية القابلة للتعديل وقت التشغيل للاحتفاظ واللغات والرفع.",
    "view": {
      "edit": "تعديل الإعدادات"
    },
    "fields": {
      "retention_days": "أيام الاحتفاظ",
      "retention_days_hint": "مدة بقاء المجموعة الموقوفة في مرحلة الاحتفاظ قبل جدولة التنقية.",
      "purge_grace_days": "أيام مهلة التنقية",
      "purge_grace_days_hint": "فترة الإشعار بين التنقية المعلقة والتنقية نفسها.",
      "selectable_locales": "اللغات المتاحة",
      "selectable_locales_hint": "رموز اللغات مفصولة بفواصل التي يمكن لتطبيقات الشركات عرضها.",
      "max_upload_mb": "الحد الأقصى للرفع (ميجابايت)",
      "max_upload_mb_hint": "أكبر ملف واحد تقبله المنصة."
    },
    "form": {
      "save": "حفظ التغييرات",
      "cancel": "إلغاء"
    },
    "errors": {
      "required": "هذه القيمة مطلوبة",
      "numeric": "أدخل رقمًا صحيحًا",
      "locales": "أدخل رموز لغات مفصولة بفواصل"
    },
    "general": {
      "title": "الإعدادات العامة"
    },
    "mobileVersions": {
      "title": "إصدارات تطبيق الجوال",
      "description": "يتحقق تطبيق الموظفين من هذه القيم عند فتحه وعند العودة إليه. اترك الحقل فارغًا لإيقاف التحقق منه.",
      "edit": "تعديل الإصدارات",
      "notSet": "غير محدد",
      "minimumHint": "الإصدارات الأقدم من هذا الإصدار يجب تحديثها قبل فتحها.",
      "latestHint": "الإصدارات الأقدم من هذا الإصدار تعرض رسالة تحديث يمكن إغلاقها.",
      "fields": {
        "mobile_min_version_android": "الحد الأدنى لإصدار Android",
        "mobile_latest_version_android": "أحدث إصدار Android",
        "mobile_min_version_ios": "الحد الأدنى لإصدار iOS",
        "mobile_latest_version_ios": "أحدث إصدار iOS"
      }
    },
    "socialInsuranceLimits": {
      "title": "حدود التأمين الاجتماعي",
      "description": "الحد الأدنى والأقصى القانونيان لأجر الاشتراك لكل سنة. تستخدمهما الرواتب في جميع الشركات.",
      "columns": {
        "year": "السنة",
        "minimum": "الحد الأدنى",
        "maximum": "الحد الأقصى",
        "actions": "الإجراءات"
      },
      "add": "إضافة سنة",
      "edit": "تعديل حدود سنة {{year}}",
      "remove": "إزالة حدود سنة {{year}}",
      "empty": "لا توجد حدود بعد. أضف السنة الحالية قبل أول تشغيل للرواتب فيها.",
      "dialog": {
        "addTitle": "إضافة حدود سنوية",
        "editTitle": "تعديل حدود {{year}}",
        "description": "أدخل حدود أجر الاشتراك القانونية بالجنيه المصري لهذه السنة.",
        "year": "السنة",
        "minimum": "الحد الأدنى (جنيه مصري)",
        "maximum": "الحد الأقصى (جنيه مصري)",
        "removeTitle": "إزالة الحدود السنوية",
        "removeDescription": "هل تريد إزالة الحد الأدنى والأقصى لأجر الاشتراك لسنة {{year}}؟ لن يكون لدى الرواتب حد قانوني لهذه السنة.",
        "removeConfirm": "إزالة الحدود"
      },
      "errors": {
        "yearRequired": "أدخل السنة.",
        "yearRange": "أدخل سنة بين 2019 و2100.",
        "yearDuplicate": "حدود هذه السنة موجودة بالفعل.",
        "amountRequired": "أدخل المبلغ.",
        "amountDecimal": "أدخل مبلغًا موجبًا بما لا يزيد على منزلتين عشريتين.",
        "minimumPositive": "يجب أن يكون الحد الأدنى أكبر من صفر.",
        "maximumGreater": "يجب أن يكون الحد الأقصى أكبر من الحد الأدنى."
      }
    },
    "salaryTaxTables": {
      "title": "جداول ضريبة كسب العمل",
      "description": "قواعد ضريبة كسب العمل المصرية لكل تاريخ سريان: الإعفاءات والشرائح وقواعد الدخول المرتفعة. يستخدم الرواتب الجدول الساري في تاريخ كل صرف، لكل الشركات.",
      "columns": {
        "effectiveFrom": "تاريخ السريان",
        "personalExemption": "الإعفاء الشخصي",
        "disabilityExemption": "إعفاء ذوي الإعاقة",
        "actions": "الإجراءات"
      },
      "add": "إضافة جدول",
      "edit": "تعديل",
      "editLabel": "تعديل الجدول الساري من {{date}}",
      "dialog": {
        "addTitle": "إضافة جدول ضريبة كسب العمل",
        "editTitle": "تعديل جدول ضريبة كسب العمل",
        "description": "كل المبالغ سنوية بالجنيه المصري، والنسب مئوية. يبدأ الجدول الجديد نسخة من أحدث جدول.",
        "effectiveFrom": "تاريخ السريان",
        "effectiveFromHint": "يستخدم الرواتب هذا الجدول لتواريخ الصرف في هذا التاريخ أو بعده.",
        "personalExemption": "الإعفاء الشخصي (ج.م)",
        "disabilityExemption": "إعفاء ذوي الإعاقة (ج.م)",
        "roundingUnit": "وحدة التقريب (ج.م)",
        "martyrsFundRate": "نسبة صندوق الشهداء (%)",
        "bands": "الشرائح الضريبية",
        "bandsHint": "صافي الدخل السنوي الخاضع للضريبة بعد الإعفاء الشخصي. الشريحة الأخيرة بلا حد أعلى.",
        "upTo": "حتى (ج.م)",
        "rate": "النسبة (%)",
        "noUpperLimit": "بلا حد أعلى",
        "bandUpTo": "الحد الأعلى للشريحة {{number}} (ج.م)",
        "bandRate": "نسبة الشريحة {{number}} (%)",
        "removeBand": "حذف الشريحة {{number}}",
        "addBand": "إضافة شريحة",
        "rules": "قواعد الدخول المرتفعة",
        "rulesHint": "فوق دخل سنوي معين لا تنطبق الشرائح الأدنى: يخضع الدخل حتى سقف النسبة الموحدة لنسبة واحدة.",
        "ruleTitle": "القاعدة {{number}}",
        "over": "الدخل السنوي أكثر من (ج.م)",
        "flatUpTo": "سقف النسبة الموحدة (ج.م)",
        "removeRule": "حذف القاعدة {{number}}",
        "addRule": "إضافة قاعدة"
      },
      "errors": {
        "required": "أدخل قيمة.",
        "rate": "أدخل نسبة من 0 إلى 100 بمنزلتين عشريتين على الأكثر."
      }
    }
  },
  "companies": {
    "title": "الشركات",
    "subtitle": "كيانات مجموعتك وكيفية ترتيبها. الفروع تندرج تحت الكيان المالك لها.",
    "emptyBody": "تُضاف الشركات بواسطة دعم ملتقى. تواصل معنا لإضافة شركة.",
    "status": {
      "label": "الحالة",
      "active": "نشطة",
      "suspended": "موقوفة",
      "deactivated": "معطّلة"
    },
    "list": {
      "empty": "لا توجد كيانات بعد",
      "columns": {
        "entity": "الكيان",
        "code": "الرمز",
        "currency": "العملة الأساسية",
        "status": "الحالة",
        "actions": "إجراءات"
      },
      "edit": "تعديل الكيان",
      "editActiveOnly": "يمكن تعديل الشركة التي سجّلت الدخول بها فقط من هنا.",
      "rootsNote": "كيانات المستوى الأعلى",
      "summary": "{{total}} كيانًا في المجموعة",
      "noResultsTitle": "لا توجد كيانات مطابقة لبحثك",
      "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح البحث لعرض كل الكيانات."
    },
    "edit": {
      "title": "تعديل {{name}}"
    },
    "form": {
      "legalNameEn": "الاسم القانوني (الإنجليزية)",
      "legalNameAr": "الاسم القانوني (العربية)",
      "tradingNameEn": "الاسم التجاري (الإنجليزية)",
      "tradingNameAr": "الاسم التجاري (العربية)",
      "code": "الرمز",
      "codeHint": "معرّف قصير، فريد داخل المجموعة.",
      "country": "الدولة",
      "countryHint": "ISO 3166-1 alpha-2، مثل EG أو SA.",
      "baseCurrency": "العملة الأساسية",
      "baseCurrencyReadOnly": "العملة الأساسية ثابتة بعد الإنشاء.",
      "registrationNumber": "رقم التسجيل",
      "taxIdentifier": "المعرّف الضريبي",
      "defaultLocale": "اللغة الافتراضية",
      "localeEnglish": "الإنجليزية",
      "localeArabic": "العربية",
      "createdAt": "تاريخ الإنشاء",
      "fiscalYearStart": "تبدأ السنة المالية في",
      "fiscalSetup": "السنة المالية",
      "fiscalSetupHint": "تُنشأ السنة المالية الأولى بهذه الإعدادات. لا يمكن تغيير فتراتها بعد إنشائها.",
      "periods": "الفترات",
      "monthly": "شهرية",
      "monthlyHint": "12 فترة، فترة لكل شهر.",
      "quarterly": "ربع سنوية",
      "quarterlyHint": "4 فترات، كل فترة ثلاثة أشهر. يبدأ الربع الأول في أول شهر من سنتك المالية.",
      "parent": "الكيان الأب",
      "parentNone": "كيان المستوى الأعلى",
      "validationTitle": "يرجى مراجعة الحقول المميزة.",
      "parentLoadFailed": "تعذّر تحميل الكيانات الأب.",
      "retryParents": "حاول مرة أخرى",
      "nameRequired": "أدخل الاسم القانوني بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "countryRequired": "أدخل رمز الدولة",
      "currencyRequired": "اختر عملة أساسية",
      "localeRequired": "اختر اللغة الافتراضية",
      "monthRequired": "اختر شهر بدء السنة المالية",
      "submitCreate": "إضافة الكيان",
      "submitEdit": "حفظ التغييرات",
      "submitting": "جارٍ الحفظ…",
      "createFailed": "تعذّرت إضافة الكيان",
      "updateFailed": "تعذّر حفظ الكيان",
      "parentFailed": "تعذّر نقل الكيان",
      "cycleRefused": "هذا الأب سيُنشئ حلقة — لا يمكن أن يندرج كيان تحت فرعه الخاص.",
      "groupRefused": "لا يمكنك اختيار هذا الكيان ككيان أب. اختر كيانًا آخر.",
      "month": {
        "1": "يناير",
        "2": "فبراير",
        "3": "مارس",
        "4": "أبريل",
        "5": "مايو",
        "6": "يونيو",
        "7": "يوليو",
        "8": "أغسطس",
        "9": "سبتمبر",
        "10": "أكتوبر",
        "11": "نوفمبر",
        "12": "ديسمبر"
      }
    },
    "tabs": {
      "overview": "نظرة عامة",
      "settings": "الإعدادات",
      "departments": "الأقسام",
      "positions": "المسميات الوظيفية",
      "sequences": "التسلسلات",
      "imports": "استيراد البيانات"
    },
    "common": {
      "empty": "لا توجد قيمة",
      "loading": "جارٍ التحميل…"
    },
    "notFound": {
      "title": "الشركة غير موجودة",
      "body": "هذه الشركة غير موجودة في المجموعة المحددة أو لم تعد متاحة.",
      "back": "العودة إلى المجموعة"
    },
    "detail": {
      "deactivate": "تعطيل",
      "reactivate": "إعادة تفعيل",
      "deactivateDialog": {
        "title": "تعطيل {{name}}؟",
        "description": "لن يمكن استخدام {{name}} حتى تتم إعادة تفعيلها. يُحتفظ بسجلها وإعداداتها.",
        "confirm": "تعطيل"
      },
      "deactivated": "تم تعطيل {{name}}.",
      "reactivated": "تمت إعادة تفعيل {{name}}.",
      "loadFailed": {
        "title": "تعذّر تحميل هذه الشركة",
        "body": "أعد المحاولة، أو ارجع إلى المجموعة."
      }
    },
    "settings": {
      "groups": {
        "purchasing": "المشتريات",
        "purchasingDescription": "الإعدادات الافتراضية وقواعد الشراء والاستلام.",
        "approvals": "الموافقات",
        "approvalsDescription": "حدّد الحد الذي يرسل المعاملات للمراجعة.",
        "hr": "الموارد البشرية",
        "hrDescription": "الحد الشهري للصلاحيات المستخدم في إجراءات الموارد البشرية.",
        "branding": "العلامة التجارية",
        "brandingDescription": "إعدادات العلامة التجارية لهذه الشركة، للقراءة فقط.",
        "warehousing": "التخزين",
        "warehousingDescription": "المستودعات الافتراضية المستخدمة للمرتجعات والتجهيز.",
        "regional": "المنطقة الزمنية",
        "regionalDescription": "الوقت المحلي للحضور وتطبيق الجوال."
      },
      "fields": {
        "paymentTerms": "شروط السداد الافتراضية",
        "approvalThreshold": "حد الموافقة",
        "approvalCurrency": "عملة حد الموافقة",
        "overReceipt": "سياسة الاستلام الزائد",
        "negativeStock": "السماح بمخزون سالب",
        "expiryConvention": "متى يُعدّ الصنف منتهي الصلاحية؟",
        "expiryWarningDays": "أيام التحذير من الانتهاء",
        "allocationStrategy": "استراتيجية التخصيص",
        "permissionMonthlyMinutes": "دقائق الصلاحيات الشهرية",
        "accentColor": "لون العلامة التجارية",
        "logo": "الشعار",
        "returnsWarehouse": "مستودع المرتجعات",
        "fulfilmentWarehouse": "مستودع التجهيز",
        "timezone": "المنطقة الزمنية"
      },
      "values": {
        "overReceipt": {
          "block": "منع",
          "allow": "السماح"
        },
        "expiry": {
          "on": "في تاريخ الانتهاء",
          "after": "بعد تاريخ الانتهاء"
        },
        "allocation": {
          "fefo": "الأقرب انتهاءً، يصرف أولًا (FEFO)",
          "fifo": "الوارد أولًا، يصرف أولًا (FIFO)"
        },
        "enabled": "مفعّل",
        "disabled": "غير مفعّل",
        "days": "يوم"
      },
      "form": {
        "save": "حفظ التغييرات",
        "edit": "تعديل",
        "wholeNumber": "أدخل عددًا صحيحًا",
        "saveFailed": "تعذّر حفظ إعدادات الشركة",
        "currencyRequired": "اختر عملة لحد الموافقة"
      }
    },
    "departments": {
      "title": "الأقسام",
      "subtitle": "شجرة أقسام شركتك. تندرج الأقسام تحت قسم أب.",
      "add": "إضافة قسم",
      "empty": "لا توجد أقسام بعد",
      "emptyDescription": "أضف القسم الأول لبدء تنظيم الشركة.",
      "nameEn": "الاسم (بالإنجليزية)",
      "nameAr": "الاسم (بالعربية)",
      "code": "الرمز",
      "parent": "القسم الأب",
      "status": "الحالة",
      "actions": "إجراءات",
      "active": "نشط",
      "inactive": "غير نشط",
      "rowActions": "إجراءات {{code}}",
      "edit": "تعديل القسم",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "saveFailed": "تعذّر حفظ القسم",
      "editTitle": "تعديل القسم",
      "createTitle": "إضافة قسم",
      "parentNone": "قسم المستوى الأعلى",
      "submitEdit": "حفظ التغييرات",
      "submitCreate": "إضافة القسم"
    },
    "positions": {
      "title": "المسميات الوظيفية",
      "subtitle": "المسميات الوظيفية التي يمكن أن يشغلها الموظفون في هذه الشركة.",
      "add": "إضافة مسمى وظيفي",
      "empty": "لا توجد مسميات وظيفية بعد",
      "emptyDescription": "أضف المسمى الوظيفي الأول لبدء تعيين الموظفين.",
      "nameEn": "الاسم (بالإنجليزية)",
      "nameAr": "الاسم (بالعربية)",
      "code": "الرمز",
      "status": "الحالة",
      "actions": "إجراءات",
      "active": "نشط",
      "inactive": "غير نشط",
      "rowActions": "إجراءات {{code}}",
      "edit": "تعديل المسمى الوظيفي",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "saveFailed": "تعذّر حفظ المسمى الوظيفي",
      "editTitle": "تعديل المسمى الوظيفي",
      "createTitle": "إضافة مسمى وظيفي",
      "submitEdit": "حفظ التغييرات",
      "submitCreate": "إضافة المسمى الوظيفي"
    },
    "imports": {
      "title": "استيراد البيانات",
      "subtitle": "حمّل فروع هذه الشركة وأقسامها وموظفيها وغير ذلك من مصنف واحد.",
      "template": "تنزيل النموذج",
      "templateTitle": "تنزيل نموذج",
      "templateDescription": "اختر الأوراق التي تحتاجها هذه الشركة. كل ورقة تسرد أعمدتها، والأعمدة المعلّمة بـ * مطلوبة للسجلات الجديدة.",
      "templateDownload": "تنزيل",
      "templateNone": "اختر ورقة واحدة على الأقل.",
      "templateFailed": "تعذّر تنزيل النموذج",
      "upload": "رفع المصنف",
      "uploadHint": "ملف بصيغة xlsx حتى 10 ميغابايت، مُعدّ من النموذج.",
      "uploadFailed": "تعذّر رفع المصنف",
      "validating": "جارٍ فحص المصنف. يستغرق ذلك بضع ثوانٍ.",
      "applying": "جارٍ تطبيق الاستيراد. يستغرق ذلك بضع ثوانٍ.",
      "ready": "المعاينة جاهزة. لا يُحفظ شيء حتى تطبّقها.",
      "readyWithWarnings": "المعاينة جاهزة، وفيها تحذيرات للمراجعة أدناه. لا يُحفظ شيء حتى تطبّقها.",
      "invalid": "في المصنف مشكلات. أصلحها في الملف ثم ارفعه مرة أخرى.",
      "stale": "تغيّرت بيانات الشركة بعد هذه المعاينة. ارفع الملف مرة أخرى للحصول على معاينة جديدة.",
      "applied": "تم الاستيراد. يسجّل سجل التدقيق كل تغيير.",
      "failed": "توقف الاستيراد ولم يُحفظ شيء. أصلح المشكلات ثم ارفع الملف مرة أخرى.",
      "cancelled": "أُلغي هذا الاستيراد. لم يُحفظ شيء.",
      "expired": "انتهت صلاحية هذا الاستيراد بعد 7 أيام دون تطبيقه. لم يُحفظ شيء.",
      "apply": "تطبيق الاستيراد",
      "cancel": "إلغاء الاستيراد",
      "applyTitle": "تطبيق هذا الاستيراد؟",
      "applyBody": "سيغيّر هذا {{company}}: {{created}} جديد، {{updated}} محدّث.",
      "applyNote": "يسجّلك سجل التدقيق بوصفك من أجرى هذه التغييرات.",
      "applyConfirm": "تطبيق",
      "keepPreview": "ليس الآن",
      "applyFailed": "تعذّر تطبيق الاستيراد",
      "cancelFailed": "تعذّر إلغاء الاستيراد",
      "summary": "الملخص",
      "sheet": "الورقة",
      "created": "جديد",
      "updated": "محدّث",
      "unchanged": "دون تغيير",
      "errors": "المشكلات",
      "problems": "مشكلات يجب إصلاحها",
      "problemsMore": "يُعرض أول {{shown}} من أصل {{total}} مشكلة.",
      "row": "الصف",
      "column": "العمود",
      "problem": "المشكلة",
      "wholeRow": "الصف كاملًا",
      "warnings": "تحذيرات للمراجعة",
      "warning": "التحذير",
      "warningsHint": "تُستورد هذه الصفوف رغم ذلك. راجع كلًّا منها في الملف، أو في السجل بعد التطبيق.",
      "changes": "ما الذي سيتغير",
      "changesHint": "أسماء الحقول فقط. تبقى القيم في الملف.",
      "totals": "الإجماليات",
      "history": "سجل الاستيراد",
      "historyEmpty": "لا توجد عمليات استيراد بعد",
      "historyEmptyDescription": "نزّل النموذج واملأه ثم ارفعه هنا.",
      "file": "الملف",
      "uploadedBy": "رفعه",
      "uploadedAt": "تاريخ الرفع",
      "statusLabel": "الحالة",
      "result": "النتيجة",
      "resultCounts": "{{created}} جديد، {{updated}} محدّث",
      "open": "فتح",
      "close": "إغلاق المعاينة",
      "importAction": "استيراد",
      "sheetsHeading": "اختيار الأوراق",
      "sheetsHint": "اختر الأوراق التي تريدها. يحتوي النموذج على الأوراق المختارة فقط.",
      "uploadHeading": "ارفع المصنف بعد تعبئته",
      "noSheets": "لا يمكنك استيراد أي ورقة بعد. اطلب من المسؤول الصلاحية التي تحتاجها الورقة.",
      "door": {
        "admin": "فريق المنصة",
        "company": "مستخدم الشركة"
      },
      "status": {
        "validating": "قيد الفحص",
        "ready": "جاهز للتطبيق",
        "invalid": "به مشكلات",
        "applying": "قيد التطبيق",
        "applied": "مطبّق",
        "failed": "فشل",
        "stale": "قديم",
        "cancelled": "ملغى",
        "expired": "منتهي الصلاحية"
      }
    },
    "sequences": {
      "title": "تسلسلات المستندات",
      "subtitle": "كيفية ترقيم كل نوع مستند في هذه الشركة.",
      "empty": "لا توجد تسلسلات بعد",
      "emptyDescription": "أضف تسلسلًا لكل نوع مستند يحتاج إلى رقم.",
      "type": "نوع المستند",
      "prefix": "البادئة",
      "next": "الرقم التالي",
      "padding": "الحشو",
      "preview": "معاينة التالي",
      "actions": "إجراءات",
      "edit": "تعديل التسلسل",
      "previewFailed": "تعذّرت معاينة الرقم التالي",
      "editTitle": "تعديل التسلسل",
      "prefixRequired": "أدخل البادئة",
      "paddingInvalid": "أدخل عددًا صحيحًا من 1 إلى 20",
      "saveFailed": "تعذّر حفظ التسلسل",
      "submitEdit": "حفظ التغييرات",
      "resetLabel": "وتيرة إعادة الترقيم",
      "reset": {
        "never": "أبدًا",
        "yearly": "سنويًا",
        "monthly": "شهريًا"
      }
    }
  },
  "companySettings": {
    "title": "إعدادات الشركة",
    "subtitle": "الافتراضات وسياسات هذه الشركة.",
    "groups": {
      "identity": "الهوية",
      "identityDescription": "هوية الشركة وعلامتها التجارية.",
      "financial": "المالية",
      "financialDescription": "الإعدادات الافتراضية لتسجيل المعاملات.",
      "approvals": "الموافقات",
      "approvalsDescription": "القواعد التي تحدد متى تحتاج المعاملة إلى مراجعة.",
      "stock": "المخزون",
      "stockDescription": "طريقة التعامل مع الاستلام والعجز وتسويات المخزون.",
      "costing": "تكلفة المخزون",
      "costingDescription": "طريقة تقييم المخزون وموعد بدء التكلفة.",
      "regional": "المنطقة الزمنية",
      "regionalDescription": "الوقت المحلي للحضور وتطبيق الجوال."
    },
    "view": {
      "edit": "تعديل الإعدادات",
      "editSection": "تعديل {{section}}"
    },
    "fields": {
      "paymentTerms": "شروط السداد الافتراضية",
      "paymentTermsDays": "يوم",
      "termDays_zero": "{{count}} يوم",
      "termDays_one": "يوم واحد",
      "termDays_two": "يومان",
      "termDays_few": "{{count}} أيام",
      "termDays_many": "{{count}} يومًا",
      "termDays_other": "{{count}} يوم",
      "overReceipt": "سياسة الاستلام الزائد",
      "overReceiptHint": "المنع يرفض أي استلام يزيد عن الأمر؛ والسماح يقبله ويسجّل الزيادة.",
      "negativeStock": "السماح بمخزون سالب",
      "negativeStockHint": "قد ينخفض المخزون تحت الصفر عند شحن البضاعة قبل ترحيل الاستلام.",
      "adjustmentReasons": "أسباب التسوية",
      "adjustmentReasonsHint": "يعرض نموذج تسوية المخزون هذه الأسباب فقط. أضف سببًا واحدًا على الأقل قبل تسجيل أي تسوية.",
      "adjustmentReasonsEmpty": "لا توجد أسباب تسوية بعد",
      "adjustmentReasonPlaceholder": "مثال: الجرد الدوري",
      "addAdjustmentReason": "إضافة سبب",
      "removeAdjustmentReason": "إزالة {{reason}}",
      "reasonSeparator": "، ",
      "expiryConvention": "متى يُعدّ الصنف منتهي الصلاحية؟",
      "expiryWarningDays": "أيام التحذير من الانتهاء",
      "allocationStrategy": "استراتيجية التخصيص",
      "permissionMonthlyMinutes": "دقائق الصلاحيات الشهرية",
      "returnsWarehouse": "مستودع المرتجعات",
      "fulfilmentWarehouse": "مستودع التجهيز",
      "accentColor": "لون العلامة التجارية",
      "logoPath": "مسار شعار العلامة",
      "logo": "الشعار",
      "approvalThreshold": "حد الاعتماد",
      "approvalThresholdHint": "المعاملات التي تبلغ هذا المبلغ أو تزيد تتطلب اعتمادًا.",
      "approvalCurrency": "عملة حد الاعتماد",
      "defaultCostingMethod": "طريقة التكلفة الافتراضية",
      "defaultCostingMethodHint": "تستخدمها كل فئة منتجات لا تحدد طريقة خاصة بها.",
      "costingCutoverDate": "تاريخ بدء التكلفة",
      "costingCutoverHint": "يُقيَّم المخزون بطريقة تكلفته ابتداءً من هذا التاريخ. لا يُحدَّد إلا مرة واحدة.",
      "costingCutoverNotSet": "غير محدد",
      "timezone": "المنطقة الزمنية"
    },
    "logo": {
      "upload": "رفع الشعار",
      "replace": "استبدال الشعار",
      "remove": "إزالة الشعار",
      "none": "لا يوجد شعار",
      "hint": "PNG أو JPG أو WebP، بحجم 1 ميغابايت أو أقل. يُطبع أعلى كل ملف PDF.",
      "previewAlt": "شعار الشركة",
      "uploaded": "تم حفظ الشعار.",
      "removed": "تمت إزالة الشعار."
    },
    "overReceipt": {
      "block": "منع",
      "allow": "السماح"
    },
    "values": {
      "expiryOn": "في تاريخ الانتهاء",
      "expiryAfter": "بعد تاريخ الانتهاء",
      "fefo": "الأقرب انتهاءً، يصرف أولًا (FEFO)",
      "fifo": "الوارد أولًا، يصرف أولًا (FIFO)"
    },
    "accent": {
      "placeholder": "#0F766E",
      "pick": "اختر لونًا",
      "hint": "لون سداسي عشري مثل ⁦#0F766E⁩. اتركه فارغًا لاستخدام اللون الداكن القياسي.",
      "invalid": "أدخل اللون بالعلامة # وستة أحرف أو أرقام، مثل ⁦#0F766E⁩.",
      "preview": "المعاينة على المستندات",
      "previewCompany": "شركتك",
      "previewTitle": "فاتورة"
    },
    "form": {
      "save": "حفظ التغييرات",
      "saving": "جارٍ الحفظ…",
      "saved": "حُفظت الإعدادات",
      "cancel": "إلغاء",
      "amountInvalid": "أدخل مبلغًا مثل 50000.00",
      "currencyRequired": "اختر عملة للحد",
      "costingMethodChange": "سينتقل مخزون الفئات التي تستخدم الطريقة الافتراضية للشركة إلى الطريقة الجديدة عند الحفظ.",
      "costingForbidden": "ليست لديك صلاحية تغيير طريقة التكلفة."
    },
    "errors": {
      "generic": "تعذّر حفظ الإعدادات"
    },
    "documents": {
      "title": "المستندات",
      "description": "ما يُطبع على أوامر الشراء وأوامر البيع وعروض الأسعار. اسم شركتك وعنوانها ورقمها الضريبي وشعارها تأتي من ملف الشركة.",
      "options": {
        "show_sku": "رمز الصنف",
        "show_discount": "الخصم",
        "show_tax": "الضريبة",
        "show_notes": "الملاحظات",
        "show_reference": "مرجع الطرف الآخر",
        "show_signatures": "خانات التوقيع",
        "show_serials": "الأرقام التسلسلية (أوامر البيع)"
      },
      "kinds": {
        "purchase_order": "أمر شراء",
        "sales_order": "أمر بيع",
        "quotation": "عرض سعر"
      },
      "previewOf": "معاينة",
      "previewTitle": "معاينة المستند",
      "previewLoading": "جارٍ تجهيز المعاينة…",
      "previewFailed": "تعذر تجهيز المعاينة.",
      "save": "حفظ",
      "reset": "تراجع عن التغييرات",
      "saved": "تم حفظ خيارات المستندات.",
      "saveFailed": "تعذر حفظ خيارات المستندات."
    }
  },
  "departments": {
    "title": "الأقسام",
    "subtitle": "شجرة أقسام شركتك. تندرج الأقسام تحت قسم أب.",
    "list": {
      "add": "إضافة قسم",
      "empty": "لا توجد أقسام بعد",
      "emptyDescription": "أضف القسم الأول لبدء تنظيم الشركة.",
      "columns": {
        "department": "القسم",
        "code": "الرمز",
        "actions": "إجراءات",
        "parent": "القسم الأب",
        "status": "الحالة"
      },
      "edit": "تعديل القسم",
      "rootsNote": "الأقسام الرئيسية",
      "summary_zero": "لا توجد أقسام",
      "summary_one": "قسم واحد",
      "summary_two": "قسمان",
      "summary_few": "{{total}} أقسام",
      "summary_many": "{{total}} قسمًا",
      "summary_other": "{{total}} قسم",
      "status": {
        "active": "نشط",
        "hidden": "مخفي"
      },
      "showHidden": "إظهار المخفي",
      "rowActions": "إجراءات {{code}}",
      "actions": {
        "hide": "إخفاء",
        "unhide": "إظهار",
        "delete": "حذف",
        "hideInstead": "أخفِه بدلًا من ذلك"
      },
      "deleteTitle": "حذف القسم؟",
      "deleteDescription": "حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.",
      "actionFailed": "تعذّر حفظ التغيير.",
      "noResultsTitle": "لا توجد إدارات مطابقة لبحثك",
      "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح البحث لعرض كل الإدارات."
    },
    "form": {
      "createTitle": "إضافة قسم",
      "editTitle": "تعديل القسم",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "code": "الرمز",
      "codeHint": "معرّف قصير، فريد داخل الشركة.",
      "costCenter": "مركز التكلفة",
      "costCenterPlaceholder": "اختر مركز تكلفة",
      "costCenterAutomatic": "اترك هذا الحقل فارغًا لإنشاء مركز تكلفة مطابق تلقائيًا.",
      "parent": "القسم الأب",
      "parentNone": "قسم المستوى الأعلى",
      "active": "نشط",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "cycleRefused": "هذا الأب سيُنشئ حلقة — لا يمكن أن يندرج قسم تحت شجرته الفرعية.",
      "submitCreate": "إضافة القسم",
      "submitEdit": "حفظ التغييرات",
      "submitting": "جارٍ الحفظ…",
      "createFailed": "تعذّرت إضافة القسم",
      "updateFailed": "تعذّر حفظ القسم"
    }
  },
  "branches": {
    "title": "الفروع",
    "subtitle": "المواقع التي تعمل منها الشركة. الفرع موقع، وليس وظيفة.",
    "list": {
      "add": "إضافة فرع",
      "empty": "لا توجد فروع بعد",
      "emptyDescription": "الفرع موقع تعمل منه الشركة — متجر أو مستودع أو مكتب إقليمي. القسم وظيفة تتكرر في كل فرع، أما الفرع فهو موقع واحد.",
      "columns": {
        "branch": "الفرع",
        "employeeCount": "عدد الموظفين",
        "code": "الرمز",
        "status": "الحالة",
        "actions": "إجراءات"
      },
      "edit": "تعديل الفرع",
      "summary_zero": "لا توجد فروع",
      "summary_one": "فرع واحد",
      "summary_two": "فرعان",
      "summary_few": "{{total}} فروع",
      "summary_many": "{{total}} فرعًا",
      "summary_other": "{{total}} فرع",
      "status": {
        "active": "مفتوح",
        "inactive": "مغلق"
      },
      "rowActions": "إجراءات {{code}}",
      "actions": {
        "archive": "إغلاق",
        "restore": "إعادة فتح"
      },
      "editRecord": "تعديل الفرع {{name}}",
      "archiveRecord": "إغلاق الفرع {{name}}",
      "restoreRecord": "إعادة فتح الفرع {{name}}",
      "actionFailed": "تعذّر تحديث الفرع {{name}}.",
      "errorTitle": "تعذّر تحميل الفروع",
      "errorDescription": "لم تصل القائمة. تحقّق من الاتصال ثم أعد المحاولة.",
      "retry": "إعادة المحاولة",
      "noResultsTitle": "لا توجد فروع مطابقة لبحثك",
      "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح البحث لعرض كل الفروع."
    },
    "form": {
      "createTitle": "إضافة فرع",
      "editTitle": "تعديل الفرع",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "code": "الرمز",
      "codeHint": "معرّف قصير، فريد داخل الشركة.",
      "active": "مفتوح",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "codeTaken": "يستخدم فرع آخر في هذه الشركة الرمز {{code}}. يجب أن تكون الرموز فريدة داخل الشركة الواحدة.",
      "submitCreate": "إضافة الفرع",
      "submitEdit": "حفظ التغييرات",
      "submitting": "جارٍ الحفظ…",
      "createFailed": "تعذّرت إضافة الفرع",
      "updateFailed": "تعذّر حفظ الفرع"
    }
  },
  "positions": {
    "title": "المسميات الوظيفية",
    "subtitle": "المسميات الوظيفية التي يمكن أن يشغلها الموظفون في هذه الشركة.",
    "list": {
      "add": "إضافة مسمى",
      "empty": "لا توجد مسميات بعد",
      "emptyDescription": "أضف المسمى الأول لبدء تعيين الموظفين.",
      "columns": {
        "position": "المسمى",
        "code": "الرمز",
        "actions": "إجراءات",
        "status": "الحالة"
      },
      "edit": "تعديل المسمى",
      "summary_zero": "لا توجد مسميات",
      "summary_one": "مسمى واحد",
      "summary_two": "مسميان",
      "summary_few": "{{total}} مسميات",
      "summary_many": "{{total}} مسمى",
      "summary_other": "{{total}} مسمى",
      "status": {
        "active": "نشط",
        "hidden": "مخفي"
      },
      "showHidden": "إظهار المخفي",
      "rowActions": "إجراءات {{code}}",
      "actions": {
        "hide": "إخفاء",
        "unhide": "إظهار",
        "delete": "حذف",
        "hideInstead": "أخفِه بدلًا من ذلك"
      },
      "deleteTitle": "حذف المسمى الوظيفي؟",
      "deleteDescription": "حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.",
      "actionFailed": "تعذّر حفظ التغيير.",
      "noResultsTitle": "لا توجد مسميات مطابقة لبحثك",
      "noResultsBody": "جرّب مصطلح بحث آخر، أو امسح البحث لعرض كل المسميات."
    },
    "form": {
      "createTitle": "إضافة مسمى",
      "editTitle": "تعديل المسمى",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "code": "الرمز",
      "codeHint": "معرّف قصير، فريد داخل الشركة.",
      "active": "نشط",
      "nameRequired": "أدخل الاسم بلغة واحدة على الأقل",
      "codeRequired": "أدخل الرمز",
      "submitCreate": "إضافة المسمى",
      "submitEdit": "حفظ التغييرات",
      "submitting": "جارٍ الحفظ…",
      "createFailed": "تعذّرت إضافة المسمى",
      "updateFailed": "تعذّر حفظ المسمى"
    }
  },
  "documentSequences": {
    "title": "الترقيم",
    "subtitle": "اختر طريقة ترقيم السجلات الجديدة، مثل EMP-0001.",
    "list": {
      "add": "إضافة ترقيم",
      "empty": "لا يوجد ترقيم بعد",
      "emptyDescription": "أضف طريقة ترقيم لكل سجل يحتاج إلى رقم.",
      "columns": {
        "type": "السجل",
        "prefix": "البادئة",
        "next": "الرقم التالي",
        "padding": "عدد الخانات",
        "reset": "يبدأ من جديد",
        "actions": "إجراءات"
      },
      "edit": "تعديل الترقيم",
      "summary_zero": "لا توجد قواعد ترقيم",
      "summary_one": "قاعدة ترقيم واحدة",
      "summary_two": "قاعدتا ترقيم",
      "summary_few": "{{total}} قواعد ترقيم",
      "summary_many": "{{total}} قاعدة ترقيم",
      "summary_other": "{{total}} قاعدة ترقيم",
      "module": "الوحدة",
      "moduleAll": "كل الوحدات",
      "noResultsTitle": "لا توجد قواعد ترقيم مطابقة لعوامل التصفية",
      "noResultsBody": "جرّب وحدة أو مصطلح بحث آخر، أو امسح عوامل التصفية لعرض كل قواعد الترقيم."
    },
    "modules": {
      "hr": "الموارد البشرية والرواتب",
      "sales": "المبيعات",
      "purchasing": "المشتريات",
      "accounting": "المحاسبة",
      "inventory": "المخزون",
      "directory": "العملاء والمنتجات",
      "other": "أخرى"
    },
    "types": {
      "asset": "أصل",
      "bank_deposit": "إيداع بنكي",
      "bank_transfer": "تحويل بنكي",
      "bill": "فاتورة مورد",
      "card_credit": "دائن بطاقة",
      "cash_sale": "بيع نقدي",
      "cheque": "شيك",
      "credit_note": "إشعار دائن",
      "customer": "عميل",
      "debit_note": "إشعار مدين",
      "employee": "موظف",
      "expense": "مصروف",
      "fixed_asset": "أصل ثابت",
      "invoice": "فاتورة",
      "journal_entry": "قيد يومية",
      "payment": "دفعة",
      "payroll_run": "مسير رواتب",
      "stock_transfer": "تحويل مخزون",
      "sales_order": "أمر بيع",
      "customer_return": "مرتجع عميل",
      "purchase_order": "أمر شراء",
      "goods_receipt": "إذن استلام",
      "supplier_return": "مرتجع مورد",
      "landed_cost": "تكاليف الشحن والتخليص",
      "product": "منتج",
      "unknown": "سجل آخر"
    },
    "form": {
      "createTitle": "إضافة ترقيم",
      "editTitle": "تعديل الترقيم",
      "documentType": "السجل",
      "documentTypeHint": "السجل الذي يحصل على رقم، مثل فاتورة.",
      "prefix": "البادئة",
      "nextNumber": "الرقم التالي",
      "nextNumberHint": "القيمة الحالية: {{current}}. لا يمكن للرقم إلا التقدم. تقديمه يترك فجوة في التسلسل.",
      "largeJumpConfirmation": "هذه قفزة تتجاوز 100. اكتب CONFIRM للمتابعة.",
      "largeJumpText": "CONFIRM",
      "padding": "عدد الخانات",
      "resetFrequency": "يبدأ من جديد",
      "resetNever": "أبدًا",
      "resetYearly": "سنويًا",
      "resetMonthly": "شهريًا",
      "typeRequired": "أدخل سجلًا",
      "prefixRequired": "أدخل البادئة",
      "submitCreate": "إضافة ترقيم",
      "submitEdit": "حفظ التغييرات",
      "submitting": "جارٍ الحفظ…",
      "createFailed": "تعذّرت إضافة الترقيم",
      "updateFailed": "تعذّر حفظ الترقيم"
    },
    "preview": {
      "action": "معاينة التالي",
      "next": "الرقم التالي",
      "hint": "المعاينة لا تستهلك الرقم.",
      "failed": "تعذّرت معاينة الرقم التالي"
    }
  },
  "companyAudit": {
    "title": "سجل التدقيق",
    "subtitle": "كل تغيير في السجلات الحساسة: من غيّر ماذا ومتى.",
    "description": "كل تغيير في السجلات الحساسة: من غيّر ماذا ومتى.",
    "summary": "{{count}} {{changeUnit}} بواسطة {{people}} {{peopleUnit}} على {{records}} {{recordUnit}}",
    "changes": {
      "zero": "تغييرات",
      "one": "تغيير",
      "two": "تغييران",
      "few": "تغييرات",
      "many": "تغييرًا",
      "other": "تغيير"
    },
    "people": {
      "zero": "أشخاص",
      "one": "شخص",
      "two": "شخصين",
      "few": "أشخاص",
      "many": "شخصًا",
      "other": "شخص"
    },
    "records": {
      "zero": "سجلات",
      "one": "سجل",
      "two": "سجلين",
      "few": "سجلات",
      "many": "سجلًا",
      "other": "سجل"
    },
    "loadMore": "تحميل المزيد",
    "loadError": "يرجى المحاولة مرة أخرى.",
    "export": {
      "action": "تصدير CSV",
      "done": "تم تصدير سجل التدقيق.",
      "capped": "يقتصر التصدير على 10,000 سجل.",
      "error": "تعذّر تصدير سجل التدقيق."
    },
    "filters": {
      "person": "الشخص",
      "allPeople": "كل الأشخاص",
      "module": "الوحدة",
      "allModules": "كل الوحدات",
      "recordType": "نوع السجل",
      "allRecordTypes": "كل أنواع السجلات",
      "record": "السجل",
      "selectedRecord": "السجل المحدد",
      "allActions": "كل الإجراءات",
      "date": "التاريخ",
      "search": "بحث",
      "searchPlaceholder": "ابحث في الأسماء والسجلات…",
      "action": "الإجراء",
      "from": "من",
      "to": "إلى",
      "actions": {
        "created": "إنشاء",
        "changed": "تغيير",
        "deleted": "حذف",
        "other": "أخرى"
      },
      "presets": {
        "today": "اليوم",
        "7days": "آخر 7 أيام",
        "30days": "آخر 30 يومًا",
        "month": "هذا الشهر"
      },
      "supportSession": "جلسة دعم",
      "supportSessionValue": "الجلسة المحددة"
    },
    "timeline": {
      "today": "اليوم",
      "yesterday": "أمس",
      "created": "أنشأ",
      "changed": "غيّر",
      "deleted": "حذف",
      "system": "النظام",
      "hidden": "تم التغيير",
      "maskedTooltip": "ليس لديك إذن لعرض هذه القيمة",
      "showLess": "عرض أقل",
      "moreChanges": "+{{count}} تغييرات أخرى",
      "requestChanges_zero": "{{count}} أحداث",
      "requestChanges_one": "{{count}} حدث",
      "requestChanges_two": "{{count}} حدثان",
      "requestChanges_few": "{{count}} أحداث",
      "requestChanges_many": "{{count}} حدثًا",
      "requestChanges_other": "{{count}} حدث"
    },
    "detail": {
      "changes": "التغييرات",
      "old": "قبل",
      "new": "بعد",
      "actor": "الشخص",
      "date": "التاريخ والوقت",
      "reference": "مرجع الطلب",
      "copyReference": "نسخ مرجع الطلب",
      "copied": "تم النسخ",
      "ip": "عنوان IP",
      "device": "الجهاز",
      "unknown": "غير معروف",
      "actingFor": "يعمل لصالح",
      "openRecord": "فتح السجل",
      "showHistory": "عرض سجل هذا العنصر",
      "related": "النشاط المرتبط"
    },
    "noValue": "—",
    "errorTitle": "تعذّر تحميل سجل التغييرات.",
    "emptyTitle": "لا توجد أحداث تدقيق بعد",
    "emptyBody": "ستظهر أحداث الإدارة هنا بمجرد تسجيلها.",
    "noResultsTitle": "لا توجد أحداث تطابق هذه المرشحات",
    "noResultsBody": "جرّب عبارة بحث مختلفة، أو امسح المرشحات لعرض كل الأحداث."
  },
  "unsaved": {
    "title": "المغادرة دون حفظ؟",
    "body": "التغييرات في هذه الشاشة لم تُحفظ بعد. المغادرة الآن ستؤدي إلى فقدانها.",
    "stay": "البقاء",
    "leave": "المغادرة"
  },
  "announcements": {
    "title": "الإعلانات",
    "description": "أرسل رسالة إلى العملاء، أو اختبر وصول البريد الإلكتروني والإشعارات الفورية.",
    "compose": {
      "title": "رسالة جديدة",
      "audience": "إرسال إلى",
      "audiences": {
        "all": "الجميع",
        "company": "شركة واحدة",
        "user": "شخص واحد"
      },
      "everyoneHelp": "كل مستخدم نشط في كل شركة نشطة.",
      "company": "الشركة",
      "companyPlaceholder": "اختر شركة",
      "companySearch": "ابحث بالاسم أو الرمز",
      "companyMembers_zero": "لا يوجد أعضاء نشطون",
      "companyMembers_one": "عضو نشط واحد",
      "companyMembers_two": "عضوان نشطان",
      "companyMembers_few": "{{count}} أعضاء نشطين",
      "companyMembers_many": "{{count}} عضوًا نشطًا",
      "companyMembers_other": "{{count}} عضو نشط",
      "person": "الشخص",
      "personPlaceholder": "اختر شخصًا",
      "personSearch": "ابحث بالاسم أو البريد الإلكتروني",
      "personSearchHint": "اكتب حرفين على الأقل.",
      "phones_zero": "لا يوجد هاتف مسجل",
      "phones_one": "هاتف واحد مسجل",
      "phones_two": "هاتفان مسجلان",
      "phones_few": "{{count}} هواتف مسجلة",
      "phones_many": "{{count}} هاتفًا مسجلًا",
      "phones_other": "{{count}} هاتف مسجل",
      "noResults": "لا توجد نتائج.",
      "channels": "القنوات",
      "channelNames": {
        "in_app": "داخل التطبيق",
        "email": "البريد الإلكتروني",
        "push": "إشعار فوري"
      },
      "channelsRequired": "اختر قناة واحدة على الأقل.",
      "mode": "طريقة الإرسال",
      "modes": {
        "queued": "عبر قائمة الانتظار",
        "direct": "مباشر"
      },
      "queuedHelp": "نفس مسار الإشعارات الحقيقية. استخدمه لاختبار عامل قائمة الانتظار.",
      "directHelp": "يتجاوز قائمة الانتظار ويعرض رد المزود فورًا. استخدمه لاختبار Firebase وخادم البريد.",
      "directOnlyOnePerson": "الإرسال المباشر متاح لشخص واحد فقط.",
      "english": "الإنجليزية",
      "arabic": "العربية",
      "optional": "اختياري",
      "messageTitle": "العنوان",
      "messageBody": "الرسالة",
      "arabicFallback": "يرى قراء العربية النص الإنجليزي عندما يكون هذا فارغًا.",
      "send": "إرسال",
      "sendTest": "إرسال اختبار",
      "required": "مطلوب.",
      "confirmTitle": "الإرسال إلى الجميع؟",
      "confirmBody": "سيستلم كل مستخدم نشط في كل شركة نشطة هذه الرسالة. لا يمكنك تعديلها أو سحبها.",
      "cancel": "إلغاء",
      "sent": "تم إرسال الرسالة."
    },
    "history": {
      "title": "المرسلة",
      "empty": "لم يُرسل شيء بعد",
      "emptyDescription": "تظهر هنا الرسائل التي ترسلها مع أعداد التسليم.",
      "sentAt": "وقت الإرسال",
      "message": "الرسالة",
      "audience": "الجمهور",
      "recipients": "الأشخاص",
      "email": "البريد الإلكتروني",
      "push": "إشعار فوري",
      "notSent": "لم يُرسل",
      "counts": "{{sent}} مُرسل · {{failed}} فاشل · {{queued}} في الانتظار",
      "view": "التسليمات",
      "loadError": "تعذر تحميل الرسائل المرسلة."
    },
    "report": {
      "title": "التسليمات",
      "close": "إغلاق",
      "refresh": "تحديث",
      "checking": "يتم الفحص كل 3 ثوانٍ ما دامت رسالة في الانتظار.",
      "loadError": "تعذر تحميل التسليمات.",
      "rowsTitle": "كل محاولة",
      "none": "لم تتم أي محاولة إرسال بريد أو إشعار.",
      "recipient": "الشخص",
      "channel": "القناة",
      "status": "الحالة",
      "reply": "رد المزود",
      "statuses": {
        "queued": "في الانتظار",
        "sent": "مُرسل",
        "failed": "فاشل"
      },
      "verdicts": {
        "accepted": "قبل المزود كل الرسائل. إذا لم تصل، فافحص الهاتف أو صندوق الوارد، لا الخادم.",
        "providerRefused": "رفض المزود الرسالة. افحص بيانات الاعتماد أو رمز الجهاز أو حالة المزود. عامل قائمة الانتظار غير معني.",
        "jobFailed": "نفّذ العامل المهمة وفشلت. اقرأ الخطأ أدناه.",
        "waiting": "في انتظار أن يلتقطها عامل قائمة الانتظار.",
        "workerStuck": "ما زالت في الانتظار بعد دقيقة. على الأرجح أن عامل قائمة الانتظار لا يعمل.",
        "noDevice": "لا يوجد هاتف مسجل لهذا الشخص، لذلك لم يُرسل إشعار. سجّل الدخول في التطبيق لتسجيل هاتف.",
        "noAddress": "لا يوجد بريد إلكتروني لهذا الشخص، لذلك لم يُرسل بريد."
      }
    }
  },
  "feedback": {
    "report": {
      "action": "الإبلاغ عن مشكلة",
      "title": "الإبلاغ عن مشكلة أو اقتراح",
      "subtitle": "يقرأ فريق الدعم كل تقرير.",
      "typeLabel": "ما نوع هذا التقرير؟",
      "type": {
        "problem": "هناك شيء لا يعمل",
        "suggestion": "لديّ اقتراح"
      },
      "promptProblem": "أخبرنا بما حدث",
      "promptSuggestion": "ما الذي يجعل هذا أفضل؟",
      "descriptionPlaceholder": "كلما أخبرتنا أكثر، أصلحنا الأمر أسرع.",
      "charactersLeft": "بقي {{count}} حرفًا",
      "disclosure": "نرسل أيضًا الصفحة التي تستخدمها، ولغتك، وإصدار المتصفح. لا نرسل أبدًا ما كتبته في الحقول الأخرى.",
      "screenshotLabel": "أضف صورة (اختياري)",
      "screenshotHint": "اختر ملفًا، أو اسحبه إلى هنا، أو الصقه بالضغط على Ctrl+V.",
      "chooseFile": "اختر ملفًا",
      "fileSize": "{{size}} كيلوبايت",
      "screenshotWrongType": "هذا الملف ليس صورة. يرجى اختيار صورة بصيغة JPG أو PNG أو WebP.",
      "screenshotTooLarge": "حجم الصورة كبير جدًا. يرجى اختيار صورة أقل من 5 ميجابايت.",
      "submit": "إرسال",
      "submitting": "جارٍ الإرسال…",
      "errorTitle": "لم يتم إرسال التقرير",
      "errorBody": "يرجى التحقق من الاتصال والمحاولة مرة أخرى. لم يُفقد شيء مما كتبته.",
      "thanksTitle": "شكرًا لك",
      "thanksBody": "وصل تقريرك إلى فريق الدعم. سنتواصل معك إذا احتجنا إلى تفاصيل أكثر.",
      "referenceHint": "اذكر هذا الرقم إذا تواصلت معنا هاتفيًا أو بالبريد الإلكتروني.",
      "minChars": "مطلوب ١٠ أحرف على الأقل",
      "copyReference": "نسخ الرقم المرجعي",
      "copiedReference": "تم النسخ إلى الحافظة",
      "dropActive": "أفلت الصورة هنا للإرفاق",
      "pasteHint": "أو الصق باستخدام Ctrl+V",
      "promptHintProblem": "صِف ما كنت تحاول القيام به، وما حدث بدلاً من ذلك، وأي خطوات لتكرار المشكلة.",
      "promptHintSuggestion": "صِف اقتراحك وكيف سيُحسّن عملك اليومي."
    },
    "action": "الإبلاغ عن مشكلة أو اقتراح",
    "type": {
      "problem": "مشكلة",
      "suggestion": "اقتراح"
    },
    "descriptionProblem": "أخبرنا بما حدث",
    "descriptionSuggestion": "ما الذي سيُحسّن هذا؟",
    "descriptionPlaceholder": "صِف المشكلة أو الفكرة بكلماتك الخاصة.",
    "screenshot": {
      "label": "لقطة شاشة (اختياري)",
      "hint": "حدّد أو اسحب أو الصق صورة.",
      "dropzone": "أفلت صورة هنا",
      "change": "تغيير الصورة",
      "remove": "إزالة الصورة",
      "errorType": "يُقبل فقط صور JPEG أو PNG أو WebP.",
      "errorSize": "يجب أن لا تتجاوز الصورة 5 ميجابايت."
    },
    "disclosure": "يُرسل تفصيل الصفحة الحالية وبعض بيانات المتصفح مع التقرير.",
    "submit": "إرسال",
    "submitting": "جارٍ الإرسال…",
    "success": {
      "title": "شكرًا لك",
      "body": "تم إرسال تقريرك إلى فريق الدعم.",
      "reference": "المرجع: {{reference}}",
      "close": "إغلاق"
    },
    "error": {
      "title": "تعذّر إرسال تقريرك",
      "body": "حدث خطأ ما. وصفك ولقطة الشاشة لا تزالان هنا — حاول مرة أخرى.",
      "retry": "حاول مرة أخرى"
    },
    "admin": {
      "title": "الملاحظات",
      "subtitle": "التقارير المقدمة من مستخدمي الشركات.",
      "inbox": {
        "emptyTitle": "لا توجد تقارير بعد",
        "emptyBody": "ستظهر التقارير المقدمة من مستخدمي الشركات هنا."
      },
      "columns": {
        "reference": "المرجع",
        "type": "النوع",
        "description": "الوصف",
        "company": "الشركة",
        "reporter": "المبلّغ",
        "submittedAt": "تاريخ الإرسال",
        "status": "الحالة",
        "priority": "الأولوية"
      },
      "filters": {
        "status": "الحالة",
        "statusAll": "كل الحالات",
        "type": "النوع",
        "typeAll": "كل الأنواع",
        "company": "الشركة",
        "companyPlaceholder": "كل الشركات"
      },
      "detail": {
        "title": "التقرير {{reference}}",
        "description": "الوصف",
        "screenshot": "لقطة الشاشة",
        "screenshotDownload": "تنزيل لقطة الشاشة",
        "reporter": "المبلّغ",
        "reporterEmail": "البريد أو الهاتف",
        "company": "الشركة",
        "group": "المجموعة",
        "route": "الصفحة",
        "locale": "اللغة",
        "userAgent": "المتصفح",
        "supportReference": "مرجع الدعم",
        "submittedAt": "تاريخ الإرسال",
        "triage": {
          "title": "المراجعة",
          "status": "الحالة",
          "priority": "الأولوية",
          "internalNotes": "ملاحظات داخلية",
          "internalNotesPlaceholder": "ملاحظات مرئية لمسؤولي المنصة فقط.",
          "save": "حفظ التغييرات",
          "saving": "جارٍ الحفظ…",
          "saved": "تم حفظ التغييرات",
          "error": "تعذّر حفظ تغييرات المراجعة."
        }
      },
      "status": {
        "new": "جديد",
        "reviewing": "قيد المراجعة",
        "resolved": "تم الحل",
        "closed": "مغلق"
      },
      "priority": {
        "low": "منخفضة",
        "normal": "عادية",
        "high": "مرتفعة",
        "urgent": "عاجلة"
      }
    },
    "status": {
      "new": "جديد",
      "reviewing": "قيد المراجعة",
      "resolved": "تم الحل",
      "closed": "مغلق"
    },
    "priority": {
      "low": "منخفضة",
      "normal": "عادية",
      "high": "عالية",
      "urgent": "عاجلة"
    },
    "locale": {
      "locale": "اللغة",
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "inbox": {
      "title": "الملاحظات",
      "subtitle": "المشكلات والاقتراحات الواردة من تطبيق الشركة.",
      "allStatuses": "أي حالة",
      "allTypes": "أي نوع",
      "allCompanies": "أي شركة",
      "hasScreenshot": "يحتوي على صورة",
      "emptyTitle": "لا توجد ملاحظات بعد",
      "emptyBody": "تظهر هنا التقارير الواردة من تطبيق الشركة.",
      "noMatchTitle": "لا توجد تقارير تطابق عوامل التصفية",
      "noMatchBody": "جرّب توسيع عوامل التصفية.",
      "searchPlaceholder": "البحث بالمرجع أو الوصف أو المُبلِّغ...",
      "stats": {
        "total": "إجمالي التقارير",
        "new": "جديدة / بانتظار المراجعة",
        "problems": "مشكلات",
        "suggestions": "اقتراحات"
      },
      "filters": {
        "status": "الحالة",
        "statusAll": "أي حالة",
        "type": "النوع",
        "typeAll": "أي نوع",
        "company": "الشركة",
        "companyPlaceholder": "أي شركة"
      },
      "columns": {
        "reference": "الرقم المرجعي",
        "type": "النوع",
        "description": "ما أخبرونا به",
        "company": "الشركة",
        "reporter": "المُبلِّغ",
        "submitted": "تاريخ الإرسال",
        "submittedAt": "تاريخ الإرسال",
        "status": "الحالة",
        "priority": "الأولوية",
        "screenshot": "صورة",
        "actions": "عرض"
      }
    },
    "detail": {
      "title": "التقرير {{reference}}",
      "reportedAt": "تم الإبلاغ {{at}}",
      "overview": "تفاصيل التقرير",
      "description": "ما أخبرونا به",
      "screenshot": "لقطة الشاشة",
      "screenshotDownload": "تنزيل لقطة الشاشة",
      "zoomScreenshot": "انقر على الصورة للعرض بالحجم الكامل",
      "noScreenshot": "لم تُرفق أي صورة.",
      "screenshotAlt": "صورة أرفقها المُبلِّغ",
      "screenshotFailedTitle": "تعذّر تحميل الصورة",
      "screenshotFailedBody": "التقرير نفسه غير متأثر. جرّب إعادة تحميل الصفحة.",
      "diagnostics": "بيانات التشخيص والسياق",
      "context": "السياق",
      "reporter": "المُبلِّغ",
      "reporterEmail": "البريد الإلكتروني",
      "company": "الشركة",
      "group": "المجموعة",
      "route": "الصفحة",
      "userAgent": "المتصفح",
      "supportReference": "مرجع الدعم",
      "submittedAt": "تاريخ الإرسال",
      "submitted": "تاريخ الإرسال",
      "screen": "الشاشة",
      "language": "اللغة",
      "browser": "المتصفح",
      "logReference": "مرجع السجل",
      "resolvedAt": "تاريخ الحل",
      "internalNotes": "ملاحظات داخلية",
      "internalNotesPlaceholder": "ما وجدته، وما جرّبته، وما يجب فعله بعد ذلك.",
      "internalNotesPrivate": "يمكن لفريق المنصة فقط رؤية هذه الملاحظات. لا تُعرض أبدًا على المُبلِّغ.",
      "saveFailed": "لم يتم حفظ التغيير.",
      "triage": {
        "title": "الفرز",
        "status": "الحالة",
        "priority": "الأولوية",
        "internalNotes": "ملاحظات داخلية",
        "internalNotesPlaceholder": "ما وجدته، وما جرّبته، وما يجب فعله بعد ذلك.",
        "error": "تعذّر حفظ تغييرات الفرز.",
        "saved": "تم حفظ التغييرات",
        "saving": "جارٍ الحفظ…",
        "save": "حفظ التغييرات"
      }
    }
  },
  "map": {
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "toggleAttribution": "عرض مصدر الخريطة",
    "unavailable": "تعذّر تحميل الخريطة."
  },
  "tabularReport": {
    "loadingTitle": "تقرير",
    "from": "من",
    "to": "إلى",
    "asAt": "حتى تاريخ",
    "resetPeriod": "إعادة ضبط",
    "export": {
      "csv": "تصدير CSV",
      "pdf": "تصدير PDF"
    },
    "exportFailed": "تعذر تصدير التقرير.",
    "loadFailed": "تعذر تحميل التقرير",
    "loadFailedDescription": "تحقق من اتصالك وحاول مرة أخرى.",
    "emptyTitle": "لا يوجد ما يُعرض",
    "emptyDescription": "لا توجد بيانات في هذه الفترة للمستودعات التي يمكنك رؤيتها."
  },
  "documentCurrency": {
    "label": "العملة",
    "rate": "⁦1 {{currency}} = {{rate}} {{base}}⁩، السعر الساري اليوم. يحتفظ الأمر بسعر تاريخه.",
    "quote": "⁦1 {{currency}} = {{rate}} {{base}}⁩، السعر في {{date}}. يحتفظ المستند بهذا السعر.",
    "noRate": "لا يوجد سعر لعملة {{currency}} في هذا التاريخ أو قبله. أضف سعرًا في أسعار الصرف أولًا.",
    "supplierNoRate": "يتعامل هذا المورد بعملة {{currency}}، لكن لا يوجد لدى الشركة سعر صرف لها، لذلك هذا الأمر بعملة {{base}}. أضف سعر صرف لعملة {{currency}} لتطلب بها.",
    "rateField": {
      "label": "سعر الصرف",
      "onFile": "السعر المسجل بتاريخ {{date}} هو {{rate}}. أي سعر تغيّره هنا يُطبَّق على هذا الأمر فقط.",
      "thisOrder": "أي سعر تغيّره هنا يُطبَّق على هذا الأمر فقط.",
      "useOnFile": "استخدم السعر المسجل",
      "invalid": "أدخل سعرًا أكبر من صفر، بعشر خانات عشرية على الأكثر."
    }
  },
  "serialNumbers": {
    "label": "الأرقام التسلسلية",
    "placeholder": "رقم تسلسلي في كل سطر",
    "count": "تم إدخال {{entered}} من {{expected}}"
  },
  "dashboardFilters": {
    "label": "عوامل تصفية لوحة المؤشرات",
    "period": "الفترة",
    "presets": {
      "this_month": "هذا الشهر",
      "last_month": "الشهر الماضي",
      "this_quarter": "هذا الربع",
      "this_year": "هذه السنة",
      "custom": "فترة مخصصة"
    },
    "from": "من",
    "to": "إلى",
    "warehouse": "المستودع",
    "allWarehouses": "كل المستودعات",
    "problem": {
      "incomplete": "اختر تاريخ البداية وتاريخ النهاية معًا.",
      "out_of_range": "اختر فترة لا تزيد على سنة وتنتهي اليوم أو قبله."
    }
  },
  "documentEditor": {
    "shortcuts": "اختصارات لوحة المفاتيح",
    "totals": "الإجماليات",
    "hintNewLine": "سطر جديد",
    "hintMoveLines": "التنقل بين الأسطر",
    "afterDiscounts": "بعد خصومات الأسطر البالغة {{amount}}",
    "onBase": "على {{amount}}",
    "withholding": "الخصم تحت حساب الضريبة",
    "amountDue": "المبلغ المستحق",
    "lineActions": "إجراءات السطر {{line}}",
    "duplicate": "تكرار",
    "moveLineUp": "نقل لأعلى",
    "moveLineDown": "نقل لأسفل",
    "sku": "رمز الصنف",
    "customLine": "سطر حر",
    "catalogItem": "صنف من الدليل",
    "lineTotal": "إجمالي السطر"
  },
  "employeeBulkPicker": {
    "label": "اختر الموظفين",
    "searchPlaceholder": "البحث بالاسم أو الرقم الوظيفي",
    "searchHint": "أدخل حرفين على الأقل.",
    "branchFilter": "الفرع",
    "departmentFilter": "القسم",
    "allBranches": "كل الفروع",
    "allDepartments": "كل الأقسام",
    "branchUnavailable": "اسم الفرع غير متاح",
    "departmentUnavailable": "اسم القسم غير متاح",
    "noBranches": "لا توجد فروع متاحة",
    "noDepartments": "لا توجد أقسام متاحة",
    "filterOptionsError": "تعذّر تحميل خيارات التصفية.",
    "retryFilters": "إعادة المحاولة",
    "noEmployees": "لا يوجد موظفون مؤهلون يطابقون عوامل التصفية.",
    "selectAllEligible": "تحديد جميع الموظفين المؤهلين ({{count}})",
    "selectAllMatching": "تحديد كل المطابقين ({{count}})",
    "tooManyMatches": "يوجد أكثر من 100 موظف مطابق. ضيّق نطاق الفرع أو القسم أو البحث لتحديد كل المطابقين.",
    "pages": "صفحات نتائج الموظفين",
    "previousPage": "الصفحة السابقة",
    "nextPage": "الصفحة التالية",
    "pageOf": "الصفحة {{current}} من {{total}}",
    "selectAllShown": "تحديد كل الظاهرين",
    "selected": "الموظفون المحددون ({{count}})",
    "removeSelectedEmployee": "إزالة {{employee}} من التحديد",
    "removeSelection": "إزالة",
    "selectionLimit": "يمكنك تحديد 100 موظف كحد أقصى في المرة الواحدة.",
    "optionsError": "تعذّر البحث عن الموظفين.",
    "retrySearch": "إعادة البحث"
  },
  "timeZone": {
    "search": "ابحث عن منطقة زمنية",
    "empty": "لا توجد منطقة زمنية مطابقة.",
    "hint": "الوقت المحلي للحضور والورديات والتذكيرات وتطبيق الجوال."
  }
}
